const Ot = {
  simple: [
    [
      "C",
      "G",
      "Am",
      "F"
    ],
    [
      "C",
      "Em",
      "F",
      "G"
    ],
    [
      "Am",
      "F",
      "C",
      "G"
    ],
    [
      "C",
      "Am",
      "Dm",
      "G"
    ],
    [
      "C",
      "F",
      "G",
      "C"
    ]
  ],
  town_peaceful: [
    [
      "C",
      "F",
      "C",
      "G"
    ],
    [
      "C",
      "G",
      "Em",
      "Am"
    ],
    [
      "F",
      "G",
      "Em",
      "Am"
    ],
    [
      "C",
      "F",
      "Am",
      "G"
    ],
    [
      "C",
      "G",
      "F",
      "C"
    ]
  ],
  heroic_fanfare: [
    [
      "C",
      "Am",
      "F",
      "G"
    ],
    [
      "C",
      "G",
      "Am",
      "Em"
    ],
    [
      "F",
      "C",
      "G",
      "Am"
    ],
    [
      "C",
      "Dm",
      "G",
      "C"
    ],
    [
      "Am",
      "F",
      "G",
      "C"
    ]
  ],
  playful: [
    [
      "C",
      "F",
      "G",
      "Am"
    ],
    [
      "C",
      "Em",
      "Am",
      "F"
    ],
    [
      "F",
      "G",
      "C",
      "Am"
    ],
    [
      "C",
      "G",
      "F",
      "Em"
    ],
    [
      "Am",
      "G",
      "F",
      "C"
    ]
  ]
}, It = {
  castle_majestic: [
    [
      "Em",
      "C",
      "G",
      "D"
    ],
    [
      "Em",
      "B7",
      "Em",
      "C"
    ],
    [
      "C",
      "G",
      "D",
      "Em"
    ],
    [
      "Em",
      "C",
      "D",
      "G"
    ],
    [
      "Em",
      "Em",
      "C",
      "D"
    ]
  ],
  dark: [
    [
      "Em",
      "D",
      "C",
      "B7"
    ],
    [
      "Em",
      "C",
      "Am",
      "B7"
    ],
    [
      "Em",
      "Bm",
      "C",
      "G"
    ],
    [
      "Em",
      "C",
      "D",
      "Bm"
    ],
    [
      "Em",
      "G",
      "F",
      "B7"
    ]
  ],
  ending_sorrowful: [
    [
      "Em",
      "C",
      "G",
      "D"
    ],
    [
      "Em",
      "Bm",
      "C",
      "G"
    ],
    [
      "Em",
      "D",
      "C",
      "B7"
    ],
    [
      "Em",
      "G",
      "D",
      "C"
    ],
    [
      "Em",
      "C",
      "Am",
      "B7"
    ]
  ],
  final_battle_tense: [
    [
      "Em",
      "C",
      "D",
      "B7"
    ],
    [
      "Em",
      "G",
      "D",
      "Em"
    ],
    [
      "C",
      "D",
      "Em",
      "Em"
    ],
    [
      "Em",
      "Bm",
      "C",
      "D"
    ],
    [
      "G",
      "D",
      "Em",
      "C"
    ]
  ],
  mysterious: [
    [
      "Em",
      "Am",
      "F",
      "C"
    ],
    [
      "Am",
      "Em",
      "G",
      "C"
    ],
    [
      "Em",
      "F",
      "G",
      "Em"
    ],
    [
      "Dm",
      "Am",
      "G",
      "C"
    ],
    [
      "Em",
      "C",
      "Am",
      "Bm"
    ]
  ],
  epic_adventure: [
    [
      "Em",
      "C",
      "G",
      "D"
    ],
    [
      "G",
      "Em",
      "C",
      "D"
    ],
    [
      "C",
      "G",
      "Am",
      "Em"
    ],
    [
      "Em",
      "D",
      "C",
      "G"
    ],
    [
      "Am",
      "Em",
      "G",
      "D"
    ]
  ]
}, Dt = {
  heroic: [
    [
      "G",
      "C",
      "D",
      "G"
    ],
    [
      "G",
      "Em",
      "C",
      "D"
    ],
    [
      "C",
      "D",
      "G",
      "G"
    ],
    [
      "G",
      "B7",
      "Em",
      "C"
    ],
    [
      "Em",
      "C",
      "G",
      "D"
    ]
  ],
  overworld_bright: [
    [
      "G",
      "D",
      "Em",
      "C"
    ],
    [
      "C",
      "G",
      "D",
      "G"
    ],
    [
      "G",
      "Em",
      "Am",
      "D"
    ],
    [
      "G",
      "C",
      "D",
      "G"
    ],
    [
      "G",
      "B7",
      "Em",
      "C"
    ]
  ],
  triumph: [
    [
      "G",
      "D",
      "C",
      "G"
    ],
    [
      "C",
      "D",
      "G",
      "Em"
    ],
    [
      "G",
      "C",
      "Am",
      "D"
    ],
    [
      "Em",
      "C",
      "D",
      "G"
    ],
    [
      "G",
      "D",
      "Em",
      "D"
    ]
  ],
  adventure: [
    [
      "G",
      "Em",
      "C",
      "D"
    ],
    [
      "Am",
      "D",
      "G",
      "C"
    ],
    [
      "G",
      "C",
      "D",
      "Em"
    ],
    [
      "C",
      "Am",
      "G",
      "D"
    ],
    [
      "G",
      "D",
      "C",
      "Am"
    ]
  ]
}, Ft = {
  adventure_bright: [
    [
      "D",
      "A",
      "G",
      "A"
    ],
    [
      "D",
      "G",
      "A",
      "D"
    ],
    [
      "G",
      "A",
      "D",
      "D"
    ],
    [
      "D",
      "A",
      "Bm",
      "G"
    ],
    [
      "D",
      "Em",
      "A",
      "D"
    ]
  ],
  upbeat_dance: [
    [
      "D",
      "G",
      "Bm",
      "A"
    ],
    [
      "D",
      "A",
      "G",
      "Em"
    ],
    [
      "Bm",
      "G",
      "D",
      "A"
    ],
    [
      "D",
      "D",
      "G",
      "A"
    ],
    [
      "G",
      "D",
      "A",
      "Bm"
    ]
  ]
}, xt = {
  warm_bright: [
    [
      "F",
      "C",
      "Dm",
      "Bb"
    ],
    [
      "F",
      "Bb",
      "C",
      "F"
    ],
    [
      "Dm",
      "Bb",
      "F",
      "C"
    ],
    [
      "F",
      "C",
      "Bb",
      "C"
    ],
    [
      "Bb",
      "F",
      "C",
      "Dm"
    ]
  ],
  peaceful_flow: [
    [
      "F",
      "Am",
      "Bb",
      "C"
    ],
    [
      "F",
      "C",
      "Am",
      "Bb"
    ],
    [
      "Dm",
      "F",
      "Bb",
      "C"
    ],
    [
      "F",
      "Gm",
      "C",
      "F"
    ],
    [
      "Am",
      "Bb",
      "F",
      "C"
    ]
  ]
}, Ct = {
  melancholy: [
    [
      "Am",
      "G",
      "F",
      "E7"
    ],
    [
      "Am",
      "F",
      "C",
      "G"
    ],
    [
      "Am",
      "Dm",
      "G",
      "Am"
    ],
    [
      "F",
      "G",
      "Am",
      "Am"
    ],
    [
      "Am",
      "Em",
      "F",
      "G"
    ]
  ],
  wistful_journey: [
    [
      "Am",
      "C",
      "G",
      "F"
    ],
    [
      "Dm",
      "Am",
      "G",
      "C"
    ],
    [
      "Am",
      "G",
      "Em",
      "F"
    ],
    [
      "F",
      "C",
      "G",
      "Am"
    ],
    [
      "Am",
      "Am",
      "F",
      "G"
    ]
  ]
}, Ht = {
  sorrowful_deep: [
    [
      "Dm",
      "Bb",
      "C",
      "A7"
    ],
    [
      "Dm",
      "Am",
      "Bb",
      "C"
    ],
    [
      "Dm",
      "C",
      "Bb",
      "A7"
    ],
    [
      "Bb",
      "F",
      "C",
      "Dm"
    ],
    [
      "Dm",
      "Gm",
      "A7",
      "Dm"
    ]
  ],
  minor_ballad: [
    [
      "Dm",
      "Bb",
      "F",
      "C"
    ],
    [
      "Dm",
      "Am",
      "Gm",
      "A7"
    ],
    [
      "Gm",
      "Dm",
      "Bb",
      "C"
    ],
    [
      "Dm",
      "C",
      "Gm",
      "A7"
    ],
    [
      "F",
      "C",
      "Dm",
      "Bb"
    ]
  ]
}, wt = {
  tense_dark: [
    [
      "Bm",
      "G",
      "D",
      "A"
    ],
    [
      "Bm",
      "F#7",
      "G",
      "A"
    ],
    [
      "Bm",
      "Em",
      "F#7",
      "Bm"
    ],
    [
      "G",
      "D",
      "A",
      "Bm"
    ],
    [
      "Bm",
      "A",
      "G",
      "F#7"
    ]
  ],
  brooding_drama: [
    [
      "Bm",
      "G",
      "A",
      "F#7"
    ],
    [
      "D",
      "A",
      "Bm",
      "G"
    ],
    [
      "Bm",
      "D",
      "G",
      "A"
    ],
    [
      "Em",
      "Bm",
      "A",
      "G"
    ],
    [
      "Bm",
      "Bm",
      "G",
      "A"
    ]
  ]
}, kt = {
  dramatic_tension: [
    [
      "Cm",
      "Ab",
      "Bb",
      "G7"
    ],
    [
      "Cm",
      "Gm",
      "Ab",
      "Bb"
    ],
    [
      "Cm",
      "Bb",
      "Ab",
      "G7"
    ],
    [
      "Ab",
      "Eb",
      "Bb",
      "Cm"
    ],
    [
      "Cm",
      "Fm",
      "G7",
      "Cm"
    ]
  ],
  dark_industrial: [
    [
      "Cm",
      "Ab",
      "Eb",
      "Bb"
    ],
    [
      "Cm",
      "Gm",
      "Fm",
      "G7"
    ],
    [
      "Gm",
      "Cm",
      "Ab",
      "Bb"
    ],
    [
      "Cm",
      "Bb",
      "Gm",
      "G7"
    ],
    [
      "Eb",
      "Bb",
      "Cm",
      "Ab"
    ]
  ]
}, Kt = {
  C_Major: Ot,
  E_Minor: It,
  G_Major: Dt,
  D_Major: Ft,
  F_Major: xt,
  A_Minor: Ct,
  D_Minor: Ht,
  B_Minor: wt,
  C_Minor: kt
}, Ee = Kt, Nt = 0.25, Lt = {
  slow: 90,
  medium: 120,
  fast: 150
}, Ce = {
  standard: {
    id: "standard",
    description: "Classic melody + accompaniment + bass",
    voices: [
      { role: "melody", channel: "square1", priority: 1, octaveOffset: 0 },
      { role: "accompaniment", channel: "square2", priority: 1, octaveOffset: 0 },
      { role: "bass", channel: "triangle", priority: 1, octaveOffset: 0 }
    ]
  },
  swapped: {
    id: "swapped",
    description: "Swapped square channels for tonal variety",
    voices: [
      { role: "melody", channel: "square2", priority: 1, octaveOffset: 0 },
      { role: "accompaniment", channel: "square1", priority: 1, octaveOffset: 0 },
      { role: "bass", channel: "triangle", priority: 1, octaveOffset: 0 }
    ]
  },
  dualBass: {
    id: "dualBass",
    description: "Melody with dual bass (thick low end)",
    voices: [
      { role: "melody", channel: "square1", priority: 1, octaveOffset: 0 },
      { role: "bass", channel: "square2", priority: 1, octaveOffset: 0, seedOffset: 0 },
      { role: "bassAlt", channel: "triangle", priority: 0.7, octaveOffset: -1, seedOffset: 100 }
    ]
  },
  bassLed: {
    id: "bassLed",
    description: "Bass-focused with sparse melodic decoration",
    voices: [
      { role: "bass", channel: "triangle", priority: 1, octaveOffset: -1, seedOffset: 0 },
      { role: "bassAlt", channel: "square2", priority: 0.8, octaveOffset: 0, seedOffset: 200 },
      { role: "melody", channel: "square1", priority: 0.3, octaveOffset: 0 }
    ]
  },
  layeredBass: {
    id: "layeredBass",
    description: "Layered bass with complementary square/triangle movement",
    voices: [
      { role: "bass", channel: "square1", priority: 1, octaveOffset: 0, seedOffset: 0 },
      { role: "bassAlt", channel: "triangle", priority: 0.85, octaveOffset: 0, seedOffset: 160 },
      { role: "melody", channel: "square2", priority: 1, octaveOffset: 0 }
    ]
  },
  minimal: {
    id: "minimal",
    description: "Minimal techno: bass + sparse pad only",
    voices: [
      { role: "bass", channel: "square1", priority: 1, octaveOffset: 0 },
      { role: "pad", channel: "triangle", priority: 0.4, octaveOffset: 0 }
    ]
  },
  breakLayered: {
    id: "breakLayered",
    description: "Breakbeat layering: dual bass pressure with agile lead",
    voices: [
      { role: "bass", channel: "square1", priority: 1, octaveOffset: 0, seedOffset: 0 },
      { role: "bassAlt", channel: "triangle", priority: 0.95, octaveOffset: -1, seedOffset: 140 },
      { role: "melody", channel: "square2", priority: 0.85, octaveOffset: 0, seedOffset: 240 }
    ]
  },
  lofiPadLead: {
    id: "lofiPadLead",
    description: "Lo-fi pad-first texture with gentle lead flourishes",
    voices: [
      { role: "pad", channel: "triangle", priority: 0.9, octaveOffset: -1 },
      { role: "accompaniment", channel: "square2", priority: 1, octaveOffset: -1, seedOffset: 60 },
      { role: "melody", channel: "square1", priority: 0.45, octaveOffset: 0, seedOffset: 180 }
    ]
  },
  retroPulse: {
    id: "retroPulse",
    description: "Retro loopwave pulse arpeggios with anchored bass",
    voices: [
      { role: "melody", channel: "square1", priority: 1, octaveOffset: 0, seedOffset: 80 },
      { role: "accompaniment", channel: "square2", priority: 0.85, octaveOffset: 0, seedOffset: 140 },
      { role: "bass", channel: "triangle", priority: 0.9, octaveOffset: -1, seedOffset: 40 }
    ]
  }
}, Gt = {
  minimalTechno: { standard: 2, minimal: 5, bassLed: 3, dualBass: 2, swapped: 1, layeredBass: 1 },
  progressiveHouse: { standard: 4, swapped: 3, layeredBass: 3, dualBass: 2, bassLed: 1, minimal: 0 },
  retroLoopwave: { standard: 2, swapped: 3, retroPulse: 5, layeredBass: 1, minimal: 0, bassLed: 1 },
  breakbeatJungle: { breakLayered: 5, dualBass: 3, layeredBass: 2, bassLed: 2, standard: 1, swapped: 1, minimal: 0 },
  lofiChillhop: { lofiPadLead: 5, minimal: 3, standard: 2, swapped: 1, bassLed: 1, layeredBass: 0, dualBass: 1 }
}, He = {
  standard: 3,
  swapped: 3,
  dualBass: 3,
  bassLed: 3,
  layeredBass: 3,
  minimal: 2,
  breakLayered: 3,
  lofiPadLead: 3,
  retroPulse: 3
}, qt = {
  upbeat: ["overworld_bright", "heroic"],
  sad: ["ending_sorrowful", "dark"],
  tense: ["final_battle_tense", "castle_majestic"],
  peaceful: ["town_peaceful", "simple"]
}, me = {
  // major-energetic
  heroic: { calm: 0.5, melodic: 0 },
  overworld_bright: { calm: 0.4, melodic: 0.2 },
  triumph: { calm: 0.4, melodic: 0 },
  adventure: { calm: 0.3, melodic: 0 },
  adventure_bright: { calm: 0.5, melodic: 0.1 },
  upbeat_dance: { calm: 0.4, melodic: -0.2 },
  heroic_fanfare: { calm: 0.3, melodic: 0 },
  playful: { calm: 0, melodic: 0.2 },
  // major-calm
  town_peaceful: { calm: -0.3, melodic: 0.1 },
  simple: { calm: -0.2, melodic: 0 },
  warm_bright: { calm: -0.3, melodic: 0.2 },
  peaceful_flow: { calm: -0.4, melodic: 0.2 },
  // minor-percussive
  final_battle_tense: { calm: 0.3, melodic: -0.5 },
  castle_majestic: { calm: 0, melodic: -0.4 },
  tense_dark: { calm: 0.1, melodic: -0.4 },
  dramatic_tension: { calm: 0.2, melodic: -0.5 },
  dark_industrial: { calm: 0, melodic: -0.5 },
  brooding_drama: { calm: -0.2, melodic: -0.3 },
  dark: { calm: -0.1, melodic: -0.2 },
  // minor-melodic
  ending_sorrowful: { calm: -0.2, melodic: 0.2 },
  melancholy: { calm: -0.3, melodic: 0.2 },
  wistful_journey: { calm: -0.2, melodic: 0.3 },
  sorrowful_deep: { calm: -0.3, melodic: 0.2 },
  minor_ballad: { calm: -0.2, melodic: 0.3 },
  mysterious: { calm: -0.1, melodic: 0.1 },
  epic_adventure: { calm: 0.2, melodic: 0 }
};
function Ut(t, e) {
  const a = Object.keys(t).filter((s) => me[s]);
  return a.length ? a.sort((s, n) => {
    const o = me[s], r = me[n], l = Math.hypot(o.calm - e.calmEnergetic, o.melodic - e.percussiveMelodic), i = Math.hypot(r.calm - e.calmEnergetic, r.melodic - e.percussiveMelodic);
    return l - i;
  }).slice(0, 2) : Object.keys(t);
}
const fe = {
  major: ["G_Major", "C_Major", "D_Major", "F_Major"],
  minor: ["E_Minor", "A_Minor", "D_Minor", "B_Minor", "C_Minor"]
}, X = Object.keys(Ee), Vt = {
  G_Major: [0, 2, 4, 5, 7, 9, 11],
  E_Minor: [0, 2, 3, 5, 7, 8, 10],
  C_Major: [0, 2, 4, 5, 7, 9, 11],
  D_Major: [0, 2, 4, 5, 7, 9, 11],
  F_Major: [0, 2, 4, 5, 7, 9, 11],
  A_Minor: [0, 2, 3, 5, 7, 8, 10],
  D_Minor: [0, 2, 3, 5, 7, 8, 10],
  B_Minor: [0, 2, 3, 5, 7, 8, 10],
  C_Minor: [0, 2, 3, 5, 7, 8, 10]
}, we = [
  [
    { id: "Intro", measures: 1 },
    { id: "A", measures: 3 },
    { id: "B", measures: 2 },
    { id: "A", measures: 2 }
  ],
  [
    { id: "A", measures: 2 },
    { id: "B", measures: 2 },
    { id: "A", measures: 2 },
    { id: "C", measures: 2 }
  ],
  [
    { id: "Intro", measures: 2 },
    { id: "A", measures: 2 },
    { id: "Bridge", measures: 2 },
    { id: "A", measures: 2 }
  ],
  [
    { id: "A", measures: 4 },
    { id: "B", measures: 2 },
    { id: "C", measures: 2 }
  ]
], Wt = {
  tense: [0, 3],
  upbeat: [1, 2],
  sad: [2, 3],
  peaceful: [1, 2]
}, ke = {
  // 16 measures
  16: {
    upbeat: [
      [{ id: "A", measures: 8 }, { id: "B", measures: 8 }],
      [{ id: "A", measures: 6 }, { id: "B", measures: 6 }, { id: "A", measures: 4 }],
      [{ id: "Intro", measures: 4 }, { id: "A", measures: 8 }, { id: "Outro", measures: 4 }]
    ],
    peaceful: [
      [{ id: "A", measures: 8 }, { id: "B", measures: 8 }],
      [{ id: "A", measures: 12 }, { id: "B", measures: 4 }],
      [{ id: "Intro", measures: 4 }, { id: "A", measures: 12 }]
    ],
    tense: [
      [{ id: "A", measures: 8 }, { id: "B", measures: 8 }],
      [{ id: "A", measures: 4 }, { id: "B", measures: 8 }, { id: "C", measures: 4 }],
      [{ id: "A", measures: 10 }, { id: "B", measures: 6 }]
    ],
    sad: [
      [{ id: "A", measures: 8 }, { id: "B", measures: 8 }],
      [{ id: "Intro", measures: 4 }, { id: "A", measures: 12 }],
      [{ id: "A", measures: 6 }, { id: "B", measures: 6 }, { id: "A", measures: 4 }]
    ]
  },
  // 32 measures
  32: {
    upbeat: [
      [{ id: "A", measures: 8 }, { id: "B", measures: 8 }, { id: "C", measures: 8 }, { id: "D", measures: 8 }],
      [{ id: "A", measures: 8 }, { id: "A", measures: 8 }, { id: "B", measures: 16 }],
      [{ id: "Intro", measures: 4 }, { id: "A", measures: 10 }, { id: "B", measures: 10 }, { id: "A", measures: 8 }]
    ],
    peaceful: [
      [{ id: "A", measures: 16 }, { id: "B", measures: 16 }],
      [{ id: "A", measures: 12 }, { id: "B", measures: 12 }, { id: "A", measures: 8 }],
      [{ id: "Intro", measures: 8 }, { id: "A", measures: 16 }, { id: "Outro", measures: 8 }]
    ],
    tense: [
      [{ id: "A", measures: 8 }, { id: "B", measures: 8 }, { id: "A", measures: 8 }, { id: "C", measures: 8 }],
      [{ id: "A", measures: 12 }, { id: "B", measures: 12 }, { id: "C", measures: 8 }],
      [{ id: "Intro", measures: 4 }, { id: "A", measures: 14 }, { id: "B", measures: 14 }]
    ],
    sad: [
      [{ id: "Intro", measures: 4 }, { id: "A", measures: 12 }, { id: "B", measures: 8 }, { id: "A", measures: 8 }],
      [{ id: "A", measures: 16 }, { id: "B", measures: 16 }],
      [{ id: "Intro", measures: 8 }, { id: "A", measures: 12 }, { id: "B", measures: 12 }]
    ]
  },
  // 64 measures
  64: {
    upbeat: [
      [{ id: "A", measures: 16 }, { id: "B", measures: 16 }, { id: "C", measures: 16 }, { id: "D", measures: 16 }],
      [{ id: "A", measures: 16 }, { id: "A", measures: 16 }, { id: "B", measures: 32 }],
      [{ id: "Intro", measures: 8 }, { id: "A", measures: 20 }, { id: "B", measures: 20 }, { id: "A", measures: 16 }]
    ],
    peaceful: [
      [{ id: "A", measures: 16 }, { id: "B", measures: 16 }, { id: "A", measures: 16 }, { id: "C", measures: 16 }],
      [{ id: "A", measures: 32 }, { id: "B", measures: 32 }],
      [{ id: "Intro", measures: 8 }, { id: "A", measures: 24 }, { id: "B", measures: 24 }, { id: "Outro", measures: 8 }]
    ],
    tense: [
      [{ id: "Intro", measures: 8 }, { id: "A", measures: 16 }, { id: "B", measures: 16 }, { id: "C", measures: 12 }, { id: "A", measures: 12 }],
      [{ id: "A", measures: 20 }, { id: "B", measures: 20 }, { id: "C", measures: 24 }],
      [{ id: "Intro", measures: 8 }, { id: "A", measures: 28 }, { id: "B", measures: 28 }]
    ],
    sad: [
      [{ id: "Intro", measures: 8 }, { id: "A", measures: 20 }, { id: "B", measures: 16 }, { id: "A", measures: 20 }],
      [{ id: "A", measures: 32 }, { id: "B", measures: 32 }],
      [{ id: "Intro", measures: 12 }, { id: "A", measures: 24 }, { id: "B", measures: 16 }, { id: "Outro", measures: 12 }]
    ]
  }
}, gt = /* @__PURE__ */ new Set(["A"]), _e = "steady", jt = 1, Yt = {
  textureFocus: 0,
  loopCentric: 0,
  gradualBuild: 0,
  harmonicStatic: 0,
  percussiveLayering: 0,
  breakInsertion: 0,
  filterMotion: 0,
  syncopationBias: 0,
  atmosPad: 0,
  lofiFeel: 0
}, vt = {
  minimalTechno: {
    textureFocus: 1,
    loopCentric: 1,
    harmonicStatic: 1,
    percussiveLayering: 1,
    filterMotion: 1,
    syncopationBias: 1
  },
  progressiveHouse: {
    textureFocus: 1,
    loopCentric: 1,
    gradualBuild: 1,
    percussiveLayering: 1,
    breakInsertion: 1,
    filterMotion: 1,
    atmosPad: 1
  },
  retroLoopwave: {
    textureFocus: 1,
    loopCentric: 1,
    percussiveLayering: 1,
    filterMotion: 1,
    syncopationBias: 1
  },
  breakbeatJungle: {
    textureFocus: 1,
    percussiveLayering: 1,
    breakInsertion: 1,
    filterMotion: 1,
    syncopationBias: 1
  },
  lofiChillhop: {
    loopCentric: 1,
    harmonicStatic: 1,
    atmosPad: 1,
    textureFocus: 1
  }
};
function zt() {
  return { ...Yt };
}
function Ke(t, e) {
  if (!e)
    return t;
  const a = { ...t };
  for (const s of Object.keys(t))
    if (e[s] !== void 0) {
      const n = e[s];
      a[s] = typeof n == "number" ? Math.max(0, Math.min(1, n)) : 0;
    }
  return a;
}
function $t(t) {
  let e = {};
  if (t.styleOverrides && (e = { ...e, ...t.styleOverrides }), t.stylePreset) {
    const a = vt[t.stylePreset];
    a && (e = { ...e, ...a });
  }
  return e;
}
function Jt(t, e) {
  let a = zt();
  const s = e.reduce((g, v) => g + v.measures, 0), n = e.reduce((g, v) => (g.set(v.templateId, (g.get(v.templateId) ?? 0) + 1), g), /* @__PURE__ */ new Map()), o = Array.from(n.values()).some((g) => g >= 2), r = e.length ? s / e.length : s;
  (o || r <= 4) && (a.loopCentric = 1), t.tempo !== "slow" && s >= 8 && (a.loopCentric = 1, a.percussiveLayering = 1), (t.mood === "tense" || t.mood === "sad") && (a.textureFocus = 1), t.mood === "peaceful" && (a.atmosPad = 1), (t.mood === "upbeat" || t.mood === "tense") && (a.syncopationBias = 1), t.tempo === "fast" && (a.filterMotion = 1, a.percussiveLayering = 1), s >= 12 && (a.gradualBuild = 1);
  const l = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set();
  let u = 0;
  for (const g of e)
    g.chordProgression.forEach((p) => l.add(p)), i.add(g.chordProgression.join("|")), new Set(g.chordProgression).size <= 1 && u++;
  const c = e.length > 0 && u === e.length;
  i.size <= 1 && (l.size <= 2 || c) && (a.harmonicStatic = 1), s >= 8 && t.tempo !== "slow" && (a.breakInsertion = 1);
  const d = a.harmonicStatic;
  a = Ke(a, t.styleOverrides);
  const h = t.styleOverrides && typeof t.styleOverrides.harmonicStatic == "number";
  if (d <= 0 && !h && (a.harmonicStatic = 0), t.stylePreset) {
    const g = vt[t.stylePreset];
    g && (a = Ke(a, g));
  }
  return a;
}
function H(t, e) {
  const a = Math.imul(t ?? 0, 1664525) + Math.imul(e, 1013904223) >>> 0;
  return (Math.imul(a, 22695477) + 1 >>> 0) / 4294967295;
}
function Xt(t, e) {
  const a = e ? { ...He, ...Gt[e] } : He, s = Object.entries(a), n = s.reduce((l, [, i]) => l + i, 0), o = H(t, 100);
  let r = 0;
  for (const [l, i] of s)
    if (r += i / n, o < r)
      return Ce[l];
  return Ce.standard;
}
function Qt(t, e) {
  let a = ((t ?? 0) ^ e ^ 2654435769) >>> 0;
  return a = Math.imul(a ^ a >>> 16, 569420461) >>> 0, a = Math.imul(a ^ a >>> 15, 1935289751) >>> 0, a ^= a >>> 15, (a >>> 0) / 4294967295;
}
function Zt(t, e, a) {
  const s = Ee[t];
  if (!s)
    throw new Error(`No chord motifs for key ${t}`);
  const n = [];
  for (const r of e)
    Array.isArray(s[r]) && n.push(...s[r]);
  const o = n.length ? n : Object.values(s).flat();
  if (!o.length)
    throw new Error(`No chord progressions available for key ${t}`);
  return ft(o, a, 100).map((r) => [...r]);
}
function Ne(t, e) {
  const a = t.match(/^([A-G])(#|b)?(.*)$/);
  if (!a) return t;
  const [, s, n = "", o] = a, r = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"], l = {
    C: 0,
    "C#": 1,
    Db: 1,
    D: 2,
    "D#": 3,
    Eb: 3,
    E: 4,
    F: 5,
    "F#": 6,
    Gb: 6,
    G: 7,
    "G#": 8,
    Ab: 8,
    A: 9,
    "A#": 10,
    Bb: 10,
    B: 11
  }, i = s + n, u = l[i];
  if (u === void 0) return t;
  const c = (u + e + 12) % 12;
  return r[c] + o;
}
function ea(t) {
  const e = t.match(/^([A-G](?:#|b)?)(m?)(.*)$/);
  if (!e) return t;
  const [, a, s, n] = e;
  return s === "m" ? a + n : a + "m" + n;
}
function ta(t) {
  const e = [];
  return e.push(Ne(t, 7)), e.push(Ne(t, 5)), e.push(ea(t)), e;
}
function aa(t, e) {
  const a = 3 + Math.floor(e() * 2), s = Array(a).fill(t);
  if (e() < 0.2) {
    const n = ta(t), o = n[Math.floor(e() * n.length)];
    s.push(o);
  }
  return s;
}
function sa(t, e, a, s) {
  const n = t.lengthInMeasures;
  let o;
  if (n in ke) {
    const m = ke[n][t.mood], _ = Math.floor(H(a, 24301) * m.length) % m.length;
    o = m[_].map((b) => ({ ...b }));
  } else
    o = pa(t.mood, a);
  const r = o.reduce((m, _) => m + _.measures, 0);
  let l = [];
  if (n === r)
    l = o;
  else if (n > r) {
    const m = Math.floor(n / r);
    for (let S = 0; S < m; S++)
      l = l.concat(o);
    let _ = n - m * r, b = 0;
    for (; _ > 0; ) {
      const S = o[b % o.length], T = Math.min(S.measures, _);
      l.push({ id: S.id, measures: T }), _ -= T, b++;
    }
  } else {
    let m = 0;
    for (const _ of o) {
      if (m + _.measures > n) {
        const b = Math.max(n - m, 0);
        b > 0 && l.push({ id: _.id, measures: b });
        break;
      }
      l.push(_), m += _.measures;
    }
  }
  const i = [];
  let u = 0, c = 0;
  const d = ft(e, a, 200 + c), h = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Set();
  for (const m of d)
    m.forEach((_) => g.add(_));
  const p = ((m) => {
    let _ = (m ?? 987654321) >>> 0;
    return _ === 0 && (_ = 987654321), () => (_ = _ * 1664525 + 1013904223 >>> 0, _ / 4294967295);
  })(a), y = (s.harmonicStatic ?? 0) > 0.5, f = y && g.size <= 1;
  for (const m of l) {
    let _;
    if (f && d.length > 0)
      _ = [d[0][0]];
    else if (y && e.length > 0) {
      const F = e[0][0];
      _ = aa(F, p);
    } else
      _ = d[c % d.length];
    const b = m.id, S = (h.get(b) ?? 0) + 1;
    h.set(b, S);
    const T = oa(b, S, a);
    i.push({
      id: `${m.id}${i.filter((F) => F.id.startsWith(m.id)).length + 1}`,
      startMeasure: u,
      measures: m.measures,
      chordProgression: _,
      templateId: b,
      occurrenceIndex: S,
      texture: T
    }), u += m.measures, f || c++;
  }
  return i;
}
const na = {
  Intro: ["broken"],
  A: ["broken", "steady", "broken"],
  B: ["steady", "steady", "arpeggio"],
  Bridge: ["arpeggio", "steady"],
  C: ["steady", "arpeggio", "steady"]
}, ra = {
  Intro: 1,
  A: 2,
  B: 2,
  Bridge: 4,
  C: 2
}, Le = {
  firstOccurrence: 0.7,
  repeatOccurrence: 0.4
};
function oa(t, e, a) {
  const s = na[t] ?? [_e], n = s[(e - 1) % s.length] ?? _e;
  if (n === "arpeggio") {
    const l = e === 1, i = t.split("").reduce((d, h) => d + h.charCodeAt(0), 0), u = H(a, 1e3 + i * 7 + e * 13), c = l ? Le.firstOccurrence : Le.repeatOccurrence;
    if (u > c)
      return s.find((h) => h !== "arpeggio") ?? _e;
  }
  const o = t.charCodeAt(0) * 100 + e;
  if (H(a, 2e3 + o) < Nt) {
    const i = ["steady", "broken", "arpeggio"].filter((c) => c !== n), u = Math.floor(Qt(a, 3e3 + o) * i.length);
    return i[u] ?? n;
  }
  return n;
}
function ia(t) {
  return ra[t] ?? jt;
}
function mt(t) {
  return ia(t.templateId);
}
function de(t) {
  return t.occurrenceIndex === 1 && gt.has(t.templateId);
}
function x(t) {
  return t.occurrenceIndex > 1 && gt.has(t.templateId);
}
function la(t, e, a) {
  let s, n = 50;
  switch (t) {
    case "tense":
      s = { echoProbability: 0.5, detuneProbability: 0.3, fastArpeggioProbability: 0.4 }, n = 10;
      break;
    case "upbeat":
      s = { echoProbability: 0.4, detuneProbability: 0.2, fastArpeggioProbability: 0.2 }, n = 20;
      break;
    case "sad":
      s = { echoProbability: 0.6, detuneProbability: 0.1, fastArpeggioProbability: 0.1 }, n = 30;
      break;
    case "peaceful":
      s = { echoProbability: 0.5, detuneProbability: 0.05, fastArpeggioProbability: 0.05 }, n = 40;
      break;
    default:
      s = { echoProbability: 0.3, detuneProbability: 0.3, fastArpeggioProbability: 0.3 };
      break;
  }
  const o = ca(s, e);
  return ua(o, a, n);
}
function ua(t, e, a) {
  const s = (o) => Math.min(0.95, Math.max(0.05, o)), n = (o) => (H(e, a + o) - 0.5) * 0.2;
  return {
    echoProbability: s(t.echoProbability + n(1)),
    detuneProbability: s(t.detuneProbability + n(2)),
    fastArpeggioProbability: s(t.fastArpeggioProbability + n(3))
  };
}
function ca(t, e) {
  const a = { ...t };
  return e.textureFocus > 0.5 && (a.fastArpeggioProbability = Math.max(0.05, a.fastArpeggioProbability * 0.6), a.echoProbability = Math.min(0.95, a.echoProbability + 0.05)), e.loopCentric > 0.5 && (a.detuneProbability = Math.max(0.05, a.detuneProbability * 0.8)), e.gradualBuild > 0.5 && (a.echoProbability = Math.min(0.95, a.echoProbability + 0.1)), e.harmonicStatic > 0.5 && (a.detuneProbability = Math.max(0.05, a.detuneProbability * 0.7)), e.percussiveLayering > 0.5 && (a.fastArpeggioProbability = Math.min(0.9, a.fastArpeggioProbability + 0.05)), e.filterMotion > 0.5 && (a.detuneProbability = Math.min(0.9, a.detuneProbability + 0.1)), e.syncopationBias > 0.5 && (a.echoProbability = Math.min(0.9, a.echoProbability + 0.05)), e.atmosPad > 0.5 && (a.echoProbability = Math.min(0.95, a.echoProbability + 0.08)), e.breakInsertion > 0.5 && (a.fastArpeggioProbability = Math.max(0.05, a.fastArpeggioProbability * 0.9)), a;
}
function da(t) {
  const e = Lt[t.tempo], a = Math.round((H(t.seed, 1) - 0.5) * 30), s = e + Math.max(-15, Math.min(15, a)), n = ha(t.mood, t.seed, t.mode), o = Vt[n];
  if (!o)
    throw new Error(`Scale not defined for key ${n}`);
  const r = t.axis ? Ut(Ee[n], t.axis) : qt[t.mood], l = Zt(n, r, t.seed), i = $t(t), u = sa(t, l, t.seed, i), c = Jt(t, u), d = la(t.mood, c, t.seed);
  ga(t.lengthInMeasures, u);
  const h = Xt(t.seed, t.stylePreset);
  return {
    bpm: s,
    key: n,
    scaleDegrees: o,
    sections: u,
    techniqueStrategy: d,
    styleIntent: c,
    voiceArrangement: h
  };
}
function pa(t, e) {
  const a = Wt[t] ?? we.map((n, o) => o), s = a[Math.floor(H(e, 60) * a.length)] ?? 0;
  return we[s].map((n) => ({ ...n }));
}
function ft(t, e, a) {
  const s = [...t];
  for (let n = s.length - 1; n > 0; n--) {
    const o = Math.floor(H(e, a + n) * (n + 1)), r = s[n];
    s[n] = s[o], s[o] = r;
  }
  return s;
}
function ha(t, e, a) {
  const n = (a ? fe[a] : t === "upbeat" || t === "peaceful" ? fe.major : fe.minor).filter((r) => X.includes(r));
  if (n.length) {
    const r = Math.floor(H(e, 4660) * n.length) % n.length;
    return n[r];
  }
  if (!X.length)
    throw new Error("Chord library is empty");
  const o = Math.floor(H(e, 5) * X.length) % X.length;
  return X[o];
}
function ga(t, e) {
  const a = e.reduce((s, n) => s + n.measures, 0);
  if (a !== t)
    throw new Error(`Section length mismatch. expected=${t}, actual=${a}`);
}
const ie = 0.25, va = {
  K: 0.25,
  S: 0.25,
  H: 0.125,
  O: 0.375,
  T: 0.5,
  N: 0.375
}, ma = {
  C: 0,
  "C#": 1,
  Db: 1,
  D: 2,
  "D#": 3,
  Eb: 3,
  E: 4,
  F: 5,
  "F#": 6,
  Gb: 6,
  G: 7,
  "G#": 8,
  Ab: 8,
  A: 9,
  "A#": 10,
  Bb: 10,
  B: 11
}, re = {
  "": [0, 4, 7],
  // Major triad (C-E-G)
  m: [0, 3, 7],
  // Minor triad (C-Eb-G)
  7: [0, 4, 7, 10],
  // Dominant 7th (C-E-G-Bb)
  m7: [0, 3, 7, 10],
  // Minor 7th (C-Eb-G-Bb)
  maj7: [0, 4, 7, 11],
  // Major 7th (C-E-G-B)
  sus2: [0, 2, 7],
  // Suspended 2nd (C-D-G) - removes 3rd for ambiguity
  sus4: [0, 5, 7],
  // Suspended 4th (C-F-G) - tension/resolution
  dim: [0, 3, 6],
  // Diminished (C-Eb-Gb) - for dramatic passages
  aug: [0, 4, 8]
  // Augmented (C-E-G#) - for surreal/tense moments
}, M = 4;
function k(t, e) {
  const a = t.match(/^[A-G](#|b)?/i);
  if (!a)
    return e;
  const s = a[0].toUpperCase(), n = ma[s] ?? 0;
  return e - e % 12 + n;
}
function pe(t) {
  const e = t.match(/^[A-G](?:#|b)?(.*)$/), a = (e == null ? void 0 : e[1]) ?? "";
  return a in re ? re[a] : a.startsWith("m") ? re.m : re[""];
}
function he(t, e, a, s = 0) {
  const n = ((t - 1) % e.length + e.length) % e.length, o = Math.floor((t - 1) / e.length) + s, r = e[n] + 12 * o;
  return a + r;
}
function _t(t, e, a) {
  const s = [];
  for (let o = 0; o < t.length; o++) {
    const r = t[o];
    if (r === "-")
      continue;
    const l = e + o / 16 * M;
    s.push({
      startBeat: l,
      durationBeats: va[r] ?? 0.25,
      instrument: r,
      sectionId: a
    });
  }
  return s;
}
function D(t, e, a = M) {
  const s = Math.floor(e / a), n = t.sections.find((r) => s >= r.startMeasure && s < r.startMeasure + r.measures);
  if (!n) {
    const r = t.sections[0];
    return (r == null ? void 0 : r.chordProgression[0]) ?? "C";
  }
  const o = Math.max(0, s - n.startMeasure);
  return n.chordProgression[o % n.chordProgression.length];
}
function fa(t) {
  return 12 * Math.log2(t);
}
function _a(t) {
  return 440 * Math.pow(2, (t - 69) / 12);
}
function ya(t) {
  return (t % 12 + 12) % 12;
}
function I(t, e) {
  const a = k(e, t), s = pe(e);
  let n = t, o = 1 / 0;
  for (const r of s)
    for (let l = -2; l <= 2; l++) {
      const i = a + r + l * 12, u = Math.abs(i - t);
      u < o && (n = i, o = u);
    }
  return n;
}
const ba = /* @__PURE__ */ new Set([0, 3, 4, 5, 7, 8, 9]);
function ae(t, e, a) {
  if (a === void 0)
    return I(t, e);
  const s = k(e, a), n = pe(e);
  let o = t, r = Number.POSITIVE_INFINITY;
  for (const l of n)
    for (let i = -2; i <= 2; i++) {
      const u = s + l + i * 12, c = ya(u - a), d = ba.has(c) ? 0 : 10, h = Math.abs(u - t) * 0.1, g = Math.abs(u - a) * 0.05, v = d + h + g;
      v < r && (r = v, o = u);
    }
  return o;
}
const Ge = {
  /** Minimum safe velocity value for all channels */
  MIN: 20,
  /** Maximum accent velocity (used for emphasized notes) */
  MAX_ACCENT: 118
}, q = {
  /** Triangle channel base scale (kept at full strength for audibility) */
  TRIANGLE_BASE: 1,
  /** Low triangle bass compensation for weak fundamental perception below E3 */
  TRIANGLE_LOW_RANGE_BOOST: 1.1,
  /** Triangle non-bass role additional scale (full strength) */
  TRIANGLE_NON_BASS: 1,
  /** Bass role base scale (all channels) */
  BASS_BASE: 0.7,
  /** Square-bass low-range attenuation (below E3) */
  BASS_LOW_RANGE: 0.85,
  /** Square channel bass role additional scale (reduced to de-emphasize square) */
  SQUARE_BASS: 0.66,
  /** Melody channel velocity scale (prevents melody from overpowering the mix) */
  MELODY_CHANNEL_SCALE: 0.4
}, Sa = {
  /** E3 (MIDI 52) - bass low-range boost threshold */
  BASS_LOW_RANGE: 52
}, qe = {
  broken: 74,
  steady: 70,
  arpeggio: 76,
  /** Default fallback when texture is unknown */
  default: 72
}, Ue = {
  /** Downbeat (step 0) velocity boost */
  DOWNBEAT_BOOST: 6,
  /** Strong beat (step % 4 === 0) velocity boost */
  STRONG_BEAT_BOOST: 3
}, Ma = {
  /** Pickup note base velocity */
  PICKUP_BASE: 72
}, K = {
  /** Early-start accompaniment note velocity */
  EARLY_START: 52,
  /** Pad sustained note minimum velocity */
  PAD_MIN: 48,
  /** Base velocity scale for arpeggio texture (relative to seed) */
  ARPEGGIO_SCALE: 0.75,
  /** Broken chord velocity scale (relative to seed) */
  BROKEN_SCALE: 0.9,
  /** Steady chord velocity scale (relative to seed) */
  STEADY_SCALE: 0.85
}, Ve = {
  /** Echo effect velocity scale */
  ECHO_SCALE: 0.6,
  /** Detune effect velocity scale */
  DETUNE_SCALE: 0.7
}, W = {
  /** K - Kick drum (long period, index 3) */
  KICK: 102,
  /** T - Tom (long period, index 5) */
  TOM: 99,
  /** N - Low noise (long period, index 8) */
  LOW_NOISE: 95,
  /** S - Snare (short period, index 1) */
  SNARE: 98,
  /** H - Hi-hat (short period, index 0) */
  HIHAT: 100,
  /** O - Open hat (short period, index 2) */
  OPEN_HAT: 97
}, Ra = [
  {
    id: "RM001",
    length: 4,
    pattern: [
      4,
      4,
      4,
      4
    ],
    tags: [
      "start",
      "straight",
      "loop_safe"
    ],
    variations: [
      "RM002",
      "RM003"
    ]
  },
  {
    id: "RM002",
    length: 4,
    pattern: [
      4,
      8,
      8,
      4,
      4
    ],
    tags: [
      "start",
      "straight",
      "loop_safe",
      "kick"
    ],
    variations: [
      "RM003"
    ]
  },
  {
    id: "RM003",
    length: 4,
    pattern: [
      8,
      8,
      8,
      8,
      4,
      4
    ],
    tags: [
      "start",
      "straight",
      "loop_safe",
      "sfx_long"
    ],
    variations: [
      "RM005"
    ]
  },
  {
    id: "RM005",
    length: 4,
    pattern: [
      8,
      8,
      4,
      8,
      8,
      4
    ],
    tags: [
      "start",
      "straight",
      "loop_safe"
    ],
    variations: [
      "RM007"
    ]
  },
  {
    id: "RM007",
    length: 4,
    pattern: [
      8,
      16,
      16,
      8,
      16,
      16,
      4,
      4
    ],
    tags: [
      "start",
      "syncopation",
      "loop_safe",
      "anacrusis"
    ],
    variations: [
      "RM008",
      "RM027"
    ]
  },
  {
    id: "RM008",
    length: 4,
    pattern: [
      4,
      8,
      8,
      4,
      8,
      8
    ],
    tags: [
      "start",
      "syncopation",
      "loop_safe",
      "anacrusis"
    ],
    variations: [
      "RM027",
      "RM028"
    ]
  },
  {
    id: "RM010",
    length: 4,
    pattern: [
      4,
      4,
      8,
      8,
      4
    ],
    tags: [
      "middle",
      "straight",
      "bridge"
    ],
    variations: [
      "RM011",
      "RM012"
    ]
  },
  {
    id: "RM011",
    length: 4,
    pattern: [
      4,
      4,
      4,
      8,
      8
    ],
    tags: [
      "middle",
      "straight",
      "bridge"
    ],
    variations: [
      "RM012",
      "RM013"
    ]
  },
  {
    id: "RM012",
    length: 8,
    pattern: [
      8,
      8,
      4,
      4,
      8,
      8,
      4,
      4,
      4,
      4
    ],
    tags: [
      "middle",
      "syncopation",
      "bridge"
    ],
    variations: [
      "RM013",
      "RM014"
    ]
  },
  {
    id: "RM013",
    length: 8,
    pattern: [
      4,
      8,
      8,
      4,
      8,
      8,
      4,
      4,
      4,
      4
    ],
    tags: [
      "middle",
      "syncopation",
      "bridge"
    ],
    variations: [
      "RM014",
      "RM015"
    ]
  },
  {
    id: "RM014",
    length: 8,
    pattern: [
      8,
      8,
      8,
      8,
      4,
      4,
      4,
      4,
      4,
      4
    ],
    tags: [
      "middle",
      "syncopation",
      "bridge"
    ],
    variations: [
      "RM015",
      "RM016"
    ]
  },
  {
    id: "RM015",
    length: 8,
    pattern: [
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4
    ],
    tags: [
      "middle",
      "sustain",
      "open"
    ],
    variations: [
      "RM016",
      "RM017"
    ]
  },
  {
    id: "RM016",
    length: 8,
    pattern: [
      4,
      8,
      8,
      4,
      4,
      4,
      8,
      8,
      4,
      4
    ],
    tags: [
      "middle",
      "sustain",
      "open"
    ],
    variations: [
      "RM017",
      "RM018"
    ]
  },
  {
    id: "RM017",
    length: 4,
    pattern: [
      8,
      16,
      16,
      8,
      16,
      16,
      8,
      16,
      16,
      4
    ],
    tags: [
      "middle",
      "swing_hint",
      "bridge"
    ],
    variations: [
      "RM018",
      "RM029"
    ]
  },
  {
    id: "RM018",
    length: 4,
    pattern: [
      8,
      16,
      16,
      4,
      8,
      16,
      16,
      4
    ],
    tags: [
      "middle",
      "swing_hint",
      "bridge"
    ],
    variations: [
      "RM029"
    ]
  },
  {
    id: "RM023",
    length: 4,
    pattern: [
      8,
      8,
      4,
      4,
      4
    ],
    tags: [
      "end",
      "cadence"
    ],
    variations: []
  },
  {
    id: "RM026",
    length: 8,
    pattern: [
      8,
      8,
      4,
      4,
      4,
      8,
      8,
      4,
      4,
      4
    ],
    tags: [
      "end",
      "cadence",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM027",
    length: 4,
    pattern: [
      8,
      8,
      8,
      8,
      8,
      8,
      4
    ],
    tags: [
      "start",
      "staccato",
      "anacrusis"
    ],
    variations: [
      "RM028",
      "RM001"
    ]
  },
  {
    id: "RM028",
    length: 4,
    pattern: [
      8,
      8,
      8,
      8,
      4,
      8,
      8
    ],
    tags: [
      "start",
      "staccato",
      "anacrusis"
    ],
    variations: [
      "RM001",
      "RM002"
    ]
  },
  {
    id: "RM029",
    length: 8,
    pattern: [
      8,
      8,
      4,
      8,
      8,
      4,
      8,
      8,
      4,
      4,
      4
    ],
    tags: [
      "middle",
      "syncopation",
      "bridge",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM054",
    length: 4,
    pattern: [
      4,
      4,
      8,
      8,
      8,
      8
    ],
    tags: [
      "middle",
      "accented",
      "variation",
      "loop_safe"
    ],
    variations: [
      "RM055"
    ]
  },
  {
    id: "RM055",
    length: 4,
    pattern: [
      4,
      8,
      8,
      8,
      8,
      4
    ],
    tags: [
      "start",
      "accented",
      "bridge",
      "loop_safe"
    ],
    variations: [
      "RM054"
    ]
  },
  {
    id: "RM056",
    length: 4,
    pattern: [
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16
    ],
    tags: [
      "start",
      "straight",
      "texture_loop",
      "grid16",
      "loop_safe"
    ],
    variations: [
      "RM057"
    ]
  },
  {
    id: "RM057",
    length: 4,
    pattern: [
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      8,
      8,
      16,
      16,
      16,
      16,
      16
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "percussive_layer",
      "loop_safe"
    ],
    variations: [
      "RM056"
    ]
  },
  {
    id: "RM059",
    length: 4,
    pattern: [
      16,
      16,
      16,
      16,
      16,
      16,
      8,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "loop_safe",
      "percussive_layer"
    ],
    variations: [
      "RM060"
    ]
  },
  {
    id: "RM060",
    length: 4,
    pattern: [
      16,
      16,
      8,
      16,
      16,
      16,
      16,
      8,
      16,
      16,
      16,
      16,
      8
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "loop_safe",
      "syncopation"
    ],
    variations: [
      "RM059"
    ]
  },
  {
    id: "RM061",
    length: 4,
    pattern: [
      8,
      8,
      8,
      8,
      8,
      8,
      8,
      8
    ],
    tags: [
      "start",
      "middle",
      "texture_loop",
      "loop_safe",
      "straight"
    ],
    variations: [
      "RM062"
    ]
  },
  {
    id: "RM062",
    length: 4,
    pattern: [
      8,
      8,
      8,
      16,
      16,
      8,
      8,
      8,
      16,
      16
    ],
    tags: [
      "middle",
      "texture_loop",
      "loop_safe",
      "straight"
    ],
    variations: [
      "RM061"
    ]
  },
  {
    id: "RM063",
    length: 4,
    pattern: [
      16,
      16,
      16,
      16,
      8,
      16,
      16,
      16,
      16,
      8,
      16,
      16,
      16,
      16
    ],
    tags: [
      "start",
      "middle",
      "texture_loop",
      "grid16",
      "loop_safe",
      "percussive_layer"
    ],
    variations: [
      "RM064"
    ]
  },
  {
    id: "RM064",
    length: 4,
    pattern: [
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      8,
      16,
      16,
      16,
      16,
      8
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "loop_safe",
      "percussive_layer"
    ],
    variations: [
      "RM063"
    ]
  },
  {
    id: "RM065",
    length: 4,
    pattern: [
      4,
      16,
      16,
      16,
      16,
      4,
      16,
      16,
      16,
      16
    ],
    tags: [
      "start",
      "middle",
      "texture_loop",
      "loop_safe",
      "simple"
    ],
    variations: [
      "RM066"
    ]
  },
  {
    id: "RM066",
    length: 4,
    pattern: [
      4,
      16,
      16,
      16,
      16,
      8,
      8,
      16,
      16,
      16,
      16
    ],
    tags: [
      "middle",
      "texture_loop",
      "loop_safe"
    ],
    variations: [
      "RM065"
    ]
  },
  {
    id: "RM067",
    length: 4,
    pattern: [
      8,
      16,
      16,
      8,
      16,
      16,
      8,
      16,
      16,
      8,
      16,
      16
    ],
    tags: [
      "start",
      "middle",
      "texture_loop",
      "loop_safe",
      "straight"
    ],
    variations: [
      "RM068"
    ]
  },
  {
    id: "RM068",
    length: 4,
    pattern: [
      8,
      16,
      16,
      8,
      8,
      8,
      16,
      16,
      8,
      16,
      16
    ],
    tags: [
      "middle",
      "texture_loop",
      "loop_safe",
      "syncopation"
    ],
    variations: [
      "RM067"
    ]
  },
  {
    id: "RM069",
    length: 4,
    pattern: [
      16,
      16,
      8,
      16,
      16,
      8,
      16,
      16,
      8,
      16,
      16,
      8
    ],
    tags: [
      "start",
      "middle",
      "texture_loop",
      "grid16",
      "loop_safe",
      "percussive_layer"
    ],
    variations: [
      "RM070"
    ]
  },
  {
    id: "RM070",
    length: 4,
    pattern: [
      16,
      16,
      8,
      8,
      16,
      16,
      8,
      16,
      16,
      8,
      16,
      16
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "loop_safe",
      "percussive_layer"
    ],
    variations: [
      "RM069"
    ]
  },
  {
    id: "RM071",
    length: 4,
    pattern: [
      4,
      4,
      16,
      16,
      16,
      16,
      4
    ],
    tags: [
      "start",
      "middle",
      "texture_loop",
      "loop_safe",
      "accented"
    ],
    variations: [
      "RM072"
    ]
  },
  {
    id: "RM072",
    length: 4,
    pattern: [
      4,
      8,
      8,
      16,
      16,
      16,
      16,
      4
    ],
    tags: [
      "middle",
      "end",
      "texture_loop",
      "loop_safe",
      "accented"
    ],
    variations: [
      "RM071"
    ]
  },
  {
    id: "RM075",
    length: 8,
    pattern: [
      8,
      8,
      4,
      4,
      4,
      2,
      2
    ],
    tags: [
      "end",
      "cadence",
      "loop_safe",
      "ritardando"
    ],
    variations: []
  },
  {
    id: "RM077",
    length: 4,
    pattern: [
      16,
      16,
      16,
      16,
      8,
      8,
      4,
      4
    ],
    tags: [
      "start",
      "anacrusis",
      "drive",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM080",
    length: 4,
    pattern: [
      4,
      16,
      16,
      8,
      8,
      4,
      8
    ],
    tags: [
      "middle",
      "syncopation",
      "accented",
      "loop_safe"
    ],
    variations: [
      "RM082"
    ]
  },
  {
    id: "RM081",
    length: 4,
    pattern: [
      16,
      16,
      8,
      16,
      16,
      8,
      16,
      16,
      8,
      4
    ],
    tags: [
      "start",
      "syncopation",
      "staccato",
      "loop_safe"
    ],
    variations: [
      "RM082"
    ]
  },
  {
    id: "RM082",
    length: 4,
    pattern: [
      8,
      8,
      16,
      16,
      16,
      16,
      8,
      8,
      4
    ],
    tags: [
      "middle",
      "syncopation",
      "drive",
      "loop_safe"
    ],
    variations: [
      "RM080",
      "RM083"
    ]
  },
  {
    id: "RM083",
    length: 4,
    pattern: [
      4,
      8,
      16,
      16,
      8,
      8,
      4
    ],
    tags: [
      "middle",
      "syncopation",
      "bridge",
      "loop_safe"
    ],
    variations: [
      "RM082",
      "RM084"
    ]
  },
  {
    id: "RM084",
    length: 8,
    pattern: [
      8,
      16,
      16,
      8,
      16,
      16,
      4,
      4,
      8,
      16,
      16,
      8,
      16,
      16,
      4,
      4
    ],
    tags: [
      "middle",
      "syncopation",
      "drive",
      "loop_safe"
    ],
    variations: [
      "RM083",
      "RM085"
    ]
  },
  {
    id: "RM085",
    length: 8,
    pattern: [
      4,
      8,
      8,
      4,
      4,
      8,
      8,
      4,
      4,
      4
    ],
    tags: [
      "end",
      "syncopation",
      "cadence",
      "loop_safe"
    ],
    variations: [
      "RM084"
    ]
  },
  {
    id: "RM086",
    length: 8,
    pattern: [
      8,
      8,
      4,
      8,
      8,
      4,
      8,
      8,
      4,
      8,
      8,
      4
    ],
    tags: [
      "middle",
      "bridge",
      "syncopation",
      "loop_safe"
    ],
    variations: [
      "RM087",
      "RM088"
    ]
  },
  {
    id: "RM087",
    length: 8,
    pattern: [
      4,
      4,
      8,
      8,
      8,
      8,
      4,
      4,
      8,
      8,
      8,
      8
    ],
    tags: [
      "middle",
      "bridge",
      "straight",
      "loop_safe"
    ],
    variations: [
      "RM086",
      "RM089"
    ]
  },
  {
    id: "RM088",
    length: 8,
    pattern: [
      16,
      16,
      16,
      16,
      8,
      8,
      4,
      4,
      16,
      16,
      16,
      16,
      8,
      8,
      4,
      4
    ],
    tags: [
      "middle",
      "bridge",
      "drive",
      "loop_safe"
    ],
    variations: [
      "RM086",
      "RM089"
    ]
  },
  {
    id: "RM089",
    length: 8,
    pattern: [
      8,
      8,
      8,
      8,
      4,
      4,
      8,
      8,
      8,
      8,
      4,
      4
    ],
    tags: [
      "middle",
      "bridge",
      "sustain",
      "loop_safe"
    ],
    variations: [
      "RM087"
    ]
  },
  {
    id: "RM097",
    length: 4,
    pattern: [
      8,
      8,
      16,
      16,
      16,
      16,
      8,
      8,
      16,
      16,
      16,
      16
    ],
    tags: [
      "start",
      "texture_loop",
      "grid16",
      "percussive_layer",
      "loop_safe",
      "syncopation"
    ],
    variations: []
  },
  {
    id: "RM100",
    length: 4,
    pattern: [
      8,
      16,
      16,
      16,
      16,
      8,
      16,
      16,
      16,
      16,
      8,
      8
    ],
    tags: [
      "start",
      "texture_loop",
      "grid16",
      "percussive_layer",
      "loop_safe",
      "open"
    ],
    variations: []
  },
  {
    id: "RM102",
    length: 4,
    pattern: [
      8,
      16,
      16,
      16,
      16,
      8,
      8,
      16,
      16,
      16,
      16,
      8
    ],
    tags: [
      "end",
      "texture_loop",
      "grid16",
      "percussive_layer",
      "loop_safe",
      "syncopation"
    ],
    variations: []
  },
  {
    id: "RM111",
    length: 4,
    pattern: [
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "syncopation",
      "percussive_layer"
    ],
    variations: []
  },
  {
    id: "RM112",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "percussive_layer",
      "drive"
    ],
    variations: []
  },
  {
    id: "RM113",
    length: 4,
    pattern: [
      {
        value: 4,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "syncopation",
      "break"
    ],
    variations: []
  },
  {
    id: "RM114",
    length: 4,
    pattern: [
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      }
    ],
    tags: [
      "middle",
      "loop_safe",
      "grid16",
      "syncopation",
      "breakbeat"
    ],
    variations: []
  },
  {
    id: "RM115",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 4
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      }
    ],
    tags: [
      "middle",
      "loop_safe",
      "swing_hint",
      "rest_heavy",
      "lofi"
    ],
    variations: []
  },
  {
    id: "RM116",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      }
    ],
    tags: [
      "middle",
      "loop_safe",
      "syncopation",
      "grid16",
      "breakbeat"
    ],
    variations: []
  },
  {
    id: "RM117",
    length: 4,
    pattern: [
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      }
    ],
    tags: [
      "middle",
      "loop_safe",
      "grid16",
      "syncopation",
      "breakbeat",
      "variation"
    ],
    variations: []
  },
  {
    id: "RM118",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      }
    ],
    tags: [
      "middle",
      "loop_safe",
      "swing_hint",
      "rest_heavy",
      "lofi"
    ],
    variations: []
  },
  {
    id: "RM119",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "start",
      "loop_safe",
      "swing_hint",
      "rest_heavy",
      "lofi",
      "variation"
    ],
    variations: []
  },
  {
    id: "RM120",
    length: 4,
    pattern: [
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      }
    ],
    tags: [
      "middle",
      "loop_safe",
      "grid16",
      "percussive_layer",
      "syncopation"
    ],
    variations: [
      "RM121",
      "RM122"
    ]
  },
  {
    id: "RM121",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      }
    ],
    tags: [
      "middle",
      "loop_safe",
      "grid16",
      "percussive_layer",
      "variation",
      "syncopation"
    ],
    variations: [
      "RM120",
      "RM123"
    ]
  },
  {
    id: "RM122",
    length: 4,
    pattern: [
      {
        value: 4,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4,
        accent: !0
      }
    ],
    tags: [
      "end",
      "cadence",
      "loop_safe",
      "grid16",
      "percussive_layer",
      "syncopation"
    ],
    variations: [
      "RM123"
    ]
  },
  {
    id: "RM123",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 4,
        accent: !0
      }
    ],
    tags: [
      "end",
      "cadence",
      "loop_safe",
      "simple",
      "straight",
      "syncopation"
    ],
    variations: [
      "RM122"
    ]
  },
  {
    id: "RM124",
    length: 4,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 4
      }
    ],
    tags: [
      "pickup",
      "start",
      "grid16",
      "percussive_layer",
      "syncopation"
    ],
    variations: [
      "RM125"
    ]
  },
  {
    id: "RM125",
    length: 4,
    pattern: [
      {
        value: 4,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 4
      }
    ],
    tags: [
      "pickup",
      "start",
      "loop_safe",
      "rest_heavy",
      "lofi"
    ],
    variations: [
      "RM124"
    ]
  },
  {
    id: "RM126",
    length: 4,
    pattern: [
      {
        value: 4,
        rest: !0
      },
      {
        value: 4,
        accent: !0
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "loop_safe",
      "rest_heavy",
      "lofi"
    ],
    variations: []
  },
  {
    id: "RM127",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "loop_safe",
      "swing_hint",
      "rest_heavy",
      "lofi",
      "texture_loop"
    ],
    variations: []
  },
  {
    id: "RM128",
    length: 4,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "bridge",
      "rest_heavy",
      "lofi"
    ],
    variations: []
  },
  {
    id: "RM129",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 4,
        accent: !0
      },
      {
        value: 4,
        rest: !0
      },
      {
        value: 4
      }
    ],
    tags: [
      "end",
      "loop_safe",
      "rest_heavy",
      "lofi"
    ],
    variations: []
  },
  {
    id: "RM131",
    length: 4,
    pattern: [
      {
        value: 16,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      }
    ],
    tags: [
      "start",
      "loop_safe",
      "grid16",
      "syncopation",
      "breakbeat"
    ],
    variations: []
  },
  {
    id: "RM132",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 8
      }
    ],
    tags: [
      "bridge",
      "loop_safe",
      "syncopation",
      "breakbeat",
      "variation"
    ],
    variations: []
  },
  {
    id: "RM133",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 4
      }
    ],
    tags: [
      "end",
      "loop_safe",
      "syncopation",
      "breakbeat"
    ],
    variations: []
  },
  {
    id: "RM137",
    length: 4,
    pattern: [
      8,
      16,
      16,
      4,
      4,
      4
    ],
    tags: [
      "end",
      "loop_safe",
      "swing_hint",
      "cadence"
    ],
    variations: []
  },
  {
    id: "RM163",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "breakbeat",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM138",
    length: 4,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "grid16",
      "syncopation"
    ],
    variations: []
  },
  {
    id: "RM139",
    length: 4,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "grid16",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM140",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "syncopation",
      "grid16",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM141",
    length: 4,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "grid16",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM142",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "straight",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM143",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "syncopation",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM144",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "grid16",
      "syncopation",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM145",
    length: 4,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "grid16",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM146",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "grid16",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM147",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "grid16",
      "syncopation",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM148",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "syncopation",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM149",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "syncopation",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM150",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "breakbeat",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM151",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "breakbeat",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM152",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "breakbeat",
      "syncopation",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM153",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "breakbeat",
      "syncopation",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM154",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "straight",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM155",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "syncopation",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM156",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "syncopation",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM157",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "straight",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM158",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "breakbeat",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM159",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "syncopation",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM160",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "rest_heavy",
      "lofi",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM161",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "rest_heavy",
      "lofi",
      "loop_safe"
    ],
    variations: []
  },
  {
    id: "RM162",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "rest_heavy",
      "lofi",
      "loop_safe"
    ],
    variations: []
  }
], Ba = [
  {
    id: "MF001",
    pattern: [
      1,
      3,
      5
    ],
    tags: [
      "ascending",
      "scalar",
      "bright",
      "heroic",
      "start",
      "loop_safe",
      "short",
      "slide"
    ]
  },
  {
    id: "MF002",
    pattern: [
      1,
      4,
      5,
      7
    ],
    tags: [
      "ascending",
      "scalar",
      "bright",
      "heroic",
      "start",
      "loop_safe",
      "short",
      "bend"
    ]
  },
  {
    id: "MF003",
    pattern: [
      2,
      3,
      6,
      6,
      9
    ],
    tags: [
      "ascending",
      "scalar",
      "bright",
      "heroic",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF004",
    pattern: [
      1,
      3,
      6,
      6,
      7
    ],
    tags: [
      "ascending",
      "scalar",
      "bright",
      "heroic",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF005",
    pattern: [
      1,
      3,
      5,
      7,
      8
    ],
    tags: [
      "ascending",
      "scalar",
      "bright",
      "heroic",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF006",
    pattern: [
      1,
      3,
      4
    ],
    tags: [
      "ascending",
      "scalar",
      "bright",
      "heroic",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF007",
    pattern: [
      2,
      4,
      5,
      6
    ],
    tags: [
      "ascending",
      "scalar",
      "bright",
      "heroic",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF008",
    pattern: [
      1,
      2,
      5,
      5,
      8
    ],
    tags: [
      "ascending",
      "scalar",
      "bright",
      "heroic",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF009",
    pattern: [
      1,
      3,
      6,
      6,
      8
    ],
    tags: [
      "ascending",
      "scalar",
      "bright",
      "heroic",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF010",
    pattern: [
      1,
      3,
      5,
      6,
      8
    ],
    tags: [
      "ascending",
      "scalar",
      "bright",
      "heroic",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF011",
    pattern: [
      5,
      4,
      3
    ],
    tags: [
      "descending",
      "scalar",
      "dark",
      "melancholic",
      "cadence",
      "short"
    ]
  },
  {
    id: "MF012",
    pattern: [
      5,
      5,
      3,
      3
    ],
    tags: [
      "descending",
      "scalar",
      "dark",
      "melancholic",
      "cadence",
      "short"
    ]
  },
  {
    id: "MF013",
    pattern: [
      6,
      4,
      4,
      2,
      2
    ],
    tags: [
      "descending",
      "scalar",
      "dark",
      "melancholic",
      "cadence",
      "short"
    ]
  },
  {
    id: "MF014",
    pattern: [
      4,
      4,
      4,
      2,
      1
    ],
    tags: [
      "descending",
      "scalar",
      "dark",
      "melancholic",
      "cadence",
      "short"
    ]
  },
  {
    id: "MF015",
    pattern: [
      5,
      4,
      3,
      3,
      1
    ],
    tags: [
      "descending",
      "scalar",
      "dark",
      "melancholic",
      "cadence",
      "short"
    ]
  },
  {
    id: "MF016",
    pattern: [
      5,
      4,
      2
    ],
    tags: [
      "descending",
      "scalar",
      "dark",
      "melancholic",
      "cadence",
      "short"
    ]
  },
  {
    id: "MF017",
    pattern: [
      6,
      5,
      3,
      2
    ],
    tags: [
      "descending",
      "scalar",
      "dark",
      "melancholic",
      "cadence",
      "short"
    ]
  },
  {
    id: "MF018",
    pattern: [
      5,
      3,
      3,
      1,
      1
    ],
    tags: [
      "descending",
      "scalar",
      "dark",
      "melancholic",
      "cadence",
      "short"
    ]
  },
  {
    id: "MF019",
    pattern: [
      5,
      4,
      4,
      2,
      1
    ],
    tags: [
      "descending",
      "scalar",
      "dark",
      "melancholic",
      "cadence",
      "short"
    ]
  },
  {
    id: "MF020",
    pattern: [
      5,
      4,
      3,
      2,
      1
    ],
    tags: [
      "descending",
      "scalar",
      "dark",
      "melancholic",
      "cadence",
      "short"
    ]
  },
  {
    id: "MF021",
    pattern: [
      1,
      4,
      6
    ],
    tags: [
      "arch",
      "leaping",
      "bright",
      "complex",
      "middle",
      "short"
    ],
    variations: [
      "MF026"
    ]
  },
  {
    id: "MF022",
    pattern: [
      1,
      5,
      6,
      6
    ],
    tags: [
      "arch",
      "leaping",
      "bright",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF023",
    pattern: [
      2,
      4,
      7,
      5,
      4
    ],
    tags: [
      "arch",
      "leaping",
      "bright",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF024",
    pattern: [
      1,
      4,
      7,
      5,
      2
    ],
    tags: [
      "arch",
      "leaping",
      "bright",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF025",
    pattern: [
      1,
      4,
      6,
      6,
      3
    ],
    tags: [
      "arch",
      "leaping",
      "bright",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF026",
    pattern: [
      1,
      4,
      5
    ],
    tags: [
      "arch",
      "leaping",
      "bright",
      "complex",
      "middle",
      "short"
    ],
    variations: [
      "MF021"
    ]
  },
  {
    id: "MF027",
    pattern: [
      2,
      5,
      6,
      5
    ],
    tags: [
      "arch",
      "leaping",
      "bright",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF028",
    pattern: [
      1,
      3,
      6,
      4,
      3
    ],
    tags: [
      "arch",
      "leaping",
      "bright",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF029",
    pattern: [
      1,
      4,
      7,
      5,
      3
    ],
    tags: [
      "arch",
      "leaping",
      "bright",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF030",
    pattern: [
      1,
      4,
      6,
      5,
      3
    ],
    tags: [
      "arch",
      "leaping",
      "bright",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF031",
    pattern: [
      6,
      4,
      2
    ],
    tags: [
      "valley",
      "neighbor",
      "dark",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF032",
    pattern: [
      6,
      5,
      2,
      4
    ],
    tags: [
      "valley",
      "neighbor",
      "dark",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF033",
    pattern: [
      7,
      4,
      3,
      3,
      2
    ],
    tags: [
      "valley",
      "neighbor",
      "dark",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF034",
    pattern: [
      5,
      4,
      3,
      3,
      1
    ],
    tags: [
      "valley",
      "neighbor",
      "dark",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF035",
    pattern: [
      6,
      4,
      2,
      4,
      1
    ],
    tags: [
      "valley",
      "neighbor",
      "dark",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF036",
    pattern: [
      6,
      4,
      1
    ],
    tags: [
      "valley",
      "neighbor",
      "dark",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF037",
    pattern: [
      7,
      5,
      2,
      3
    ],
    tags: [
      "valley",
      "neighbor",
      "dark",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF038",
    pattern: [
      6,
      3,
      2,
      2,
      1
    ],
    tags: [
      "valley",
      "neighbor",
      "dark",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF039",
    pattern: [
      6,
      4,
      3,
      3,
      1
    ],
    tags: [
      "valley",
      "neighbor",
      "dark",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF040",
    pattern: [
      6,
      4,
      2,
      3,
      1
    ],
    tags: [
      "valley",
      "neighbor",
      "dark",
      "complex",
      "middle",
      "short"
    ]
  },
  {
    id: "MF041",
    pattern: [
      1,
      2,
      3
    ],
    tags: [
      "ascending",
      "arpeggio",
      "bright",
      "simple",
      "start",
      "short"
    ]
  },
  {
    id: "MF042",
    pattern: [
      1,
      3,
      3,
      6
    ],
    tags: [
      "ascending",
      "arpeggio",
      "bright",
      "simple",
      "start",
      "short"
    ]
  },
  {
    id: "MF043",
    pattern: [
      2,
      2,
      4,
      5,
      8
    ],
    tags: [
      "ascending",
      "arpeggio",
      "bright",
      "simple",
      "start",
      "short"
    ]
  },
  {
    id: "MF044",
    pattern: [
      1,
      2,
      4,
      5,
      6,
      6
    ],
    tags: [
      "ascending",
      "arpeggio",
      "bright",
      "simple",
      "start",
      "extended"
    ]
  },
  {
    id: "MF045",
    pattern: [
      1,
      2,
      3,
      6,
      7,
      7
    ],
    tags: [
      "ascending",
      "arpeggio",
      "bright",
      "simple",
      "start",
      "extended"
    ]
  },
  {
    id: "MF046",
    pattern: [
      1,
      2,
      2
    ],
    tags: [
      "ascending",
      "arpeggio",
      "bright",
      "simple",
      "start",
      "short"
    ]
  },
  {
    id: "MF047",
    pattern: [
      2,
      3,
      3,
      5
    ],
    tags: [
      "ascending",
      "arpeggio",
      "bright",
      "simple",
      "start",
      "short"
    ]
  },
  {
    id: "MF048",
    pattern: [
      1,
      1,
      3,
      4,
      7
    ],
    tags: [
      "ascending",
      "arpeggio",
      "bright",
      "simple",
      "start",
      "short"
    ]
  },
  {
    id: "MF049",
    pattern: [
      1,
      2,
      4,
      5,
      7,
      7
    ],
    tags: [
      "ascending",
      "arpeggio",
      "bright",
      "simple",
      "start",
      "extended"
    ]
  },
  {
    id: "MF050",
    pattern: [
      1,
      2,
      3,
      5,
      7,
      6
    ],
    tags: [
      "ascending",
      "arpeggio",
      "bright",
      "simple",
      "start",
      "extended"
    ]
  },
  {
    id: "MF051",
    pattern: [
      5,
      7,
      6
    ],
    tags: [
      "descending",
      "arpeggio",
      "dark",
      "heroic",
      "bridge",
      "short"
    ]
  },
  {
    id: "MF052",
    pattern: [
      5,
      8,
      6,
      5
    ],
    tags: [
      "descending",
      "arpeggio",
      "dark",
      "heroic",
      "bridge",
      "short"
    ]
  },
  {
    id: "MF053",
    pattern: [
      6,
      7,
      7,
      4,
      3
    ],
    tags: [
      "descending",
      "arpeggio",
      "dark",
      "heroic",
      "bridge",
      "short"
    ]
  },
  {
    id: "MF054",
    pattern: [
      4,
      7,
      7,
      4,
      1
    ],
    tags: [
      "descending",
      "arpeggio",
      "dark",
      "heroic",
      "bridge",
      "short"
    ]
  },
  {
    id: "MF055",
    pattern: [
      5,
      7,
      6,
      5,
      2
    ],
    tags: [
      "descending",
      "arpeggio",
      "dark",
      "heroic",
      "bridge",
      "short"
    ]
  },
  {
    id: "MF056",
    pattern: [
      5,
      7,
      5
    ],
    tags: [
      "descending",
      "arpeggio",
      "dark",
      "heroic",
      "bridge",
      "short"
    ]
  },
  {
    id: "MF057",
    pattern: [
      6,
      8,
      6,
      4
    ],
    tags: [
      "descending",
      "arpeggio",
      "dark",
      "heroic",
      "bridge",
      "short"
    ]
  },
  {
    id: "MF058",
    pattern: [
      5,
      6,
      6,
      3,
      2
    ],
    tags: [
      "descending",
      "arpeggio",
      "dark",
      "heroic",
      "bridge",
      "short"
    ]
  },
  {
    id: "MF059",
    pattern: [
      5,
      7,
      7,
      4,
      2
    ],
    tags: [
      "descending",
      "arpeggio",
      "dark",
      "heroic",
      "bridge",
      "short"
    ]
  },
  {
    id: "MF060",
    pattern: [
      5,
      7,
      6,
      4,
      2
    ],
    tags: [
      "descending",
      "arpeggio",
      "dark",
      "heroic",
      "bridge",
      "short"
    ]
  },
  {
    id: "MF061",
    pattern: [
      3,
      5,
      4
    ],
    tags: [
      "wave",
      "scalar",
      "peaceful",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF062",
    pattern: [
      3,
      6,
      4,
      7
    ],
    tags: [
      "wave",
      "scalar",
      "peaceful",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF063",
    pattern: [
      4,
      5,
      5,
      6,
      6
    ],
    tags: [
      "wave",
      "scalar",
      "peaceful",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF064",
    pattern: [
      2,
      5,
      5,
      6,
      4,
      3
    ],
    tags: [
      "wave",
      "scalar",
      "peaceful",
      "simple",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF065",
    pattern: [
      3,
      5,
      4,
      7,
      5,
      4
    ],
    tags: [
      "wave",
      "scalar",
      "peaceful",
      "simple",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF066",
    pattern: [
      3,
      5,
      3
    ],
    tags: [
      "wave",
      "scalar",
      "peaceful",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF067",
    pattern: [
      4,
      6,
      4,
      6
    ],
    tags: [
      "wave",
      "scalar",
      "peaceful",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF068",
    pattern: [
      3,
      4,
      4,
      5,
      5
    ],
    tags: [
      "wave",
      "scalar",
      "peaceful",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF069",
    pattern: [
      3,
      5,
      5,
      6,
      5,
      4
    ],
    tags: [
      "wave",
      "scalar",
      "peaceful",
      "simple",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF070",
    pattern: [
      3,
      5,
      4,
      6,
      5,
      3
    ],
    tags: [
      "wave",
      "scalar",
      "peaceful",
      "simple",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF071",
    pattern: [
      2,
      4,
      6
    ],
    tags: [
      "ascending",
      "sequence",
      "tense",
      "complex",
      "build",
      "short"
    ]
  },
  {
    id: "MF072",
    pattern: [
      2,
      5,
      6,
      6
    ],
    tags: [
      "ascending",
      "sequence",
      "tense",
      "complex",
      "build",
      "short"
    ]
  },
  {
    id: "MF073",
    pattern: [
      3,
      4,
      7,
      5,
      4
    ],
    tags: [
      "ascending",
      "sequence",
      "tense",
      "complex",
      "build",
      "short"
    ]
  },
  {
    id: "MF074",
    pattern: [
      1,
      4,
      7,
      5,
      2,
      1
    ],
    tags: [
      "ascending",
      "sequence",
      "tense",
      "complex",
      "build",
      "extended"
    ]
  },
  {
    id: "MF075",
    pattern: [
      2,
      4,
      6,
      6,
      3,
      2
    ],
    tags: [
      "ascending",
      "sequence",
      "tense",
      "complex",
      "build",
      "extended"
    ]
  },
  {
    id: "MF076",
    pattern: [
      2,
      4,
      5
    ],
    tags: [
      "ascending",
      "sequence",
      "tense",
      "complex",
      "build",
      "short"
    ]
  },
  {
    id: "MF077",
    pattern: [
      3,
      5,
      6,
      5
    ],
    tags: [
      "ascending",
      "sequence",
      "tense",
      "complex",
      "build",
      "short"
    ]
  },
  {
    id: "MF078",
    pattern: [
      2,
      3,
      6,
      4,
      3
    ],
    tags: [
      "ascending",
      "sequence",
      "tense",
      "complex",
      "build",
      "short"
    ]
  },
  {
    id: "MF079",
    pattern: [
      2,
      4,
      7,
      5,
      3,
      2
    ],
    tags: [
      "ascending",
      "sequence",
      "tense",
      "complex",
      "build",
      "extended"
    ]
  },
  {
    id: "MF080",
    pattern: [
      2,
      4,
      6,
      5,
      3,
      1
    ],
    tags: [
      "ascending",
      "sequence",
      "tense",
      "complex",
      "build",
      "extended"
    ]
  },
  {
    id: "MF081",
    pattern: [
      1,
      5,
      3
    ],
    tags: [
      "arch",
      "leaping",
      "upbeat",
      "bright",
      "start",
      "short"
    ]
  },
  {
    id: "MF082",
    pattern: [
      1,
      6,
      3,
      7
    ],
    tags: [
      "arch",
      "leaping",
      "upbeat",
      "bright",
      "start",
      "short"
    ]
  },
  {
    id: "MF083",
    pattern: [
      2,
      5,
      4,
      6,
      5
    ],
    tags: [
      "arch",
      "leaping",
      "upbeat",
      "bright",
      "start",
      "short"
    ]
  },
  {
    id: "MF084",
    pattern: [
      1,
      5,
      4,
      6,
      3,
      7
    ],
    tags: [
      "arch",
      "leaping",
      "upbeat",
      "bright",
      "start",
      "extended"
    ]
  },
  {
    id: "MF085",
    pattern: [
      1,
      5,
      3,
      7,
      4,
      8
    ],
    tags: [
      "arch",
      "leaping",
      "upbeat",
      "bright",
      "start",
      "extended"
    ]
  },
  {
    id: "MF086",
    pattern: [
      1,
      5,
      2
    ],
    tags: [
      "arch",
      "leaping",
      "upbeat",
      "bright",
      "start",
      "short"
    ]
  },
  {
    id: "MF087",
    pattern: [
      2,
      6,
      3,
      6
    ],
    tags: [
      "arch",
      "leaping",
      "upbeat",
      "bright",
      "start",
      "short"
    ]
  },
  {
    id: "MF088",
    pattern: [
      1,
      4,
      3,
      5,
      4
    ],
    tags: [
      "arch",
      "leaping",
      "upbeat",
      "bright",
      "start",
      "short"
    ]
  },
  {
    id: "MF089",
    pattern: [
      1,
      5,
      4,
      6,
      4,
      8
    ],
    tags: [
      "arch",
      "leaping",
      "upbeat",
      "bright",
      "start",
      "extended"
    ]
  },
  {
    id: "MF090",
    pattern: [
      1,
      5,
      3,
      6,
      4,
      7
    ],
    tags: [
      "arch",
      "leaping",
      "upbeat",
      "bright",
      "start",
      "extended"
    ]
  },
  {
    id: "MF091",
    pattern: [
      6,
      3,
      5
    ],
    tags: [
      "valley",
      "leaping",
      "tense",
      "dark",
      "cadence",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF092",
    pattern: [
      6,
      4,
      5,
      3
    ],
    tags: [
      "valley",
      "leaping",
      "tense",
      "dark",
      "cadence",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF093",
    pattern: [
      7,
      3,
      6,
      2,
      5
    ],
    tags: [
      "valley",
      "leaping",
      "tense",
      "dark",
      "cadence",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF094",
    pattern: [
      5,
      3,
      6,
      2,
      3,
      1
    ],
    tags: [
      "valley",
      "leaping",
      "tense",
      "dark",
      "cadence",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF095",
    pattern: [
      6,
      3,
      5,
      3,
      4,
      2
    ],
    tags: [
      "valley",
      "leaping",
      "tense",
      "dark",
      "cadence",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF096",
    pattern: [
      6,
      3,
      4
    ],
    tags: [
      "valley",
      "leaping",
      "tense",
      "dark",
      "cadence",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF097",
    pattern: [
      7,
      4,
      5,
      2
    ],
    tags: [
      "valley",
      "leaping",
      "tense",
      "dark",
      "cadence",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF098",
    pattern: [
      6,
      2,
      5,
      1,
      4
    ],
    tags: [
      "valley",
      "leaping",
      "tense",
      "dark",
      "cadence",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF099",
    pattern: [
      6,
      3,
      6,
      2,
      4,
      2
    ],
    tags: [
      "valley",
      "leaping",
      "tense",
      "dark",
      "cadence",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF100",
    pattern: [
      6,
      3,
      5,
      2,
      4,
      1
    ],
    tags: [
      "valley",
      "leaping",
      "tense",
      "dark",
      "cadence",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF101",
    pattern: [
      1,
      1,
      1,
      1
    ],
    tags: [
      "flat",
      "static",
      "texture_loop",
      "loop_safe",
      "simple",
      "ostinato"
    ]
  },
  {
    id: "MF102",
    pattern: [
      1,
      5,
      1,
      5
    ],
    tags: [
      "flat",
      "texture_loop",
      "loop_safe",
      "ostinato",
      "percussive_layer"
    ]
  },
  {
    id: "MF103",
    pattern: [
      1,
      1,
      1,
      1
    ],
    tags: [
      "flat",
      "static",
      "drone",
      "loop_safe",
      "simple"
    ]
  },
  {
    id: "MF104",
    pattern: [
      1,
      1,
      1,
      2,
      1
    ],
    tags: [
      "flat",
      "static",
      "drone",
      "loop_safe",
      "simple"
    ]
  },
  {
    id: "MF105",
    pattern: [
      5,
      5,
      5,
      5
    ],
    tags: [
      "flat",
      "static",
      "drone",
      "loop_safe",
      "simple"
    ]
  },
  {
    id: "MF106",
    pattern: [
      1,
      2,
      1,
      2
    ],
    tags: [
      "flat",
      "static",
      "drone",
      "loop_safe",
      "ostinato",
      "simple"
    ]
  },
  {
    id: "MF107",
    pattern: [
      3,
      3,
      3,
      3
    ],
    tags: [
      "flat",
      "static",
      "drone",
      "loop_safe",
      "simple"
    ]
  },
  {
    id: "MF108",
    pattern: [
      1,
      3,
      1,
      3
    ],
    tags: [
      "flat",
      "static",
      "drone",
      "loop_safe",
      "ostinato"
    ]
  },
  {
    id: "MF109",
    pattern: [
      1,
      1,
      5,
      1,
      1,
      5
    ],
    tags: [
      "flat",
      "static",
      "loop_safe",
      "ostinato",
      "percussive_layer"
    ]
  },
  {
    id: "MF110",
    pattern: [
      1,
      1,
      1,
      1,
      1,
      1
    ],
    tags: [
      "flat",
      "static",
      "drone",
      "loop_safe",
      "simple",
      "texture_loop"
    ]
  },
  {
    id: "MF111",
    pattern: [
      5,
      6,
      7,
      1
    ],
    tags: [
      "mysterious",
      "ascending",
      "dark",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF112",
    pattern: [
      1,
      7,
      6,
      5
    ],
    tags: [
      "mysterious",
      "descending",
      "dark",
      "middle",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF113",
    pattern: [
      3,
      1,
      6,
      5
    ],
    tags: [
      "mysterious",
      "complex",
      "dark",
      "tense",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF114",
    pattern: [
      1,
      2,
      3,
      2,
      1
    ],
    tags: [
      "playful",
      "neighbor",
      "bright",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF115",
    pattern: [
      5,
      4,
      3,
      4,
      5
    ],
    tags: [
      "playful",
      "wave",
      "bright",
      "upbeat",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF116",
    pattern: [
      1,
      3,
      5,
      3,
      1
    ],
    tags: [
      "playful",
      "arch",
      "bright",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF117",
    pattern: [
      1,
      5,
      1,
      5
    ],
    tags: [
      "epic",
      "leaping",
      "bright",
      "heroic",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF118",
    pattern: [
      5,
      6,
      7,
      1,
      2
    ],
    tags: [
      "epic",
      "ascending",
      "bright",
      "heroic",
      "build",
      "short"
    ]
  },
  {
    id: "MF119",
    pattern: [
      1,
      3,
      5,
      7,
      1
    ],
    tags: [
      "epic",
      "ascending",
      "arpeggio",
      "heroic",
      "bright",
      "short"
    ]
  },
  {
    id: "MF120",
    pattern: [
      6,
      5,
      4,
      3
    ],
    tags: [
      "mysterious",
      "descending",
      "scalar",
      "dark",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF121",
    pattern: [
      3,
      5,
      3,
      1
    ],
    tags: [
      "playful",
      "wave",
      "bright",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF122",
    pattern: [
      5,
      3,
      1,
      5
    ],
    tags: [
      "epic",
      "leaping",
      "arpeggio",
      "heroic",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF123",
    pattern: [
      1,
      6,
      5,
      1
    ],
    tags: [
      "mysterious",
      "complex",
      "dark",
      "cadence",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF124",
    pattern: [
      2,
      3,
      4,
      5
    ],
    tags: [
      "playful",
      "ascending",
      "scalar",
      "bright",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF125",
    pattern: [
      1,
      4,
      7,
      4,
      1
    ],
    tags: [
      "epic",
      "arch",
      "leaping",
      "heroic",
      "bright",
      "extended"
    ]
  },
  {
    id: "MF126",
    pattern: [
      5,
      7,
      6,
      5,
      3
    ],
    tags: [
      "mysterious",
      "complex",
      "dark",
      "descending",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF127",
    pattern: [
      1,
      1,
      3,
      3,
      5,
      5
    ],
    tags: [
      "playful",
      "sequence",
      "ascending",
      "bright",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF128",
    pattern: [
      1,
      7,
      1,
      5
    ],
    tags: [
      "epic",
      "leaping",
      "heroic",
      "bright",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF129",
    pattern: [
      3,
      2,
      1,
      6
    ],
    tags: [
      "mysterious",
      "descending",
      "dark",
      "tense",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF130",
    pattern: [
      5,
      5,
      6,
      6,
      7,
      7,
      1
    ],
    tags: [
      "epic",
      "sequence",
      "ascending",
      "heroic",
      "build",
      "extended"
    ]
  },
  {
    id: "MF131",
    pattern: [
      5,
      4,
      3,
      1
    ],
    tags: [
      "mysterious",
      "descending",
      "dark",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF132",
    pattern: [
      6,
      5,
      4,
      2
    ],
    tags: [
      "mysterious",
      "descending",
      "dark",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF133",
    pattern: [
      7,
      5,
      3,
      1
    ],
    tags: [
      "mysterious",
      "descending",
      "dark",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF134",
    pattern: [
      5,
      3,
      2,
      1
    ],
    tags: [
      "mysterious",
      "descending",
      "dark",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF135",
    pattern: [
      6,
      4,
      3,
      1
    ],
    tags: [
      "mysterious",
      "descending",
      "dark",
      "start",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF136",
    pattern: [
      1,
      2,
      3,
      5
    ],
    tags: [
      "mysterious",
      "ascending",
      "dark",
      "middle",
      "stepwise",
      "short"
    ]
  },
  {
    id: "MF137",
    pattern: [
      1,
      3,
      5,
      6
    ],
    tags: [
      "mysterious",
      "ascending",
      "dark",
      "middle",
      "stepwise",
      "short"
    ]
  },
  {
    id: "MF138",
    pattern: [
      2,
      3,
      4,
      6
    ],
    tags: [
      "mysterious",
      "ascending",
      "dark",
      "middle",
      "stepwise",
      "short"
    ]
  },
  {
    id: "MF139",
    pattern: [
      1,
      2,
      4,
      5
    ],
    tags: [
      "mysterious",
      "ascending",
      "dark",
      "middle",
      "stepwise",
      "short"
    ]
  },
  {
    id: "MF140",
    pattern: [
      3,
      4,
      5,
      7
    ],
    tags: [
      "mysterious",
      "ascending",
      "dark",
      "middle",
      "stepwise",
      "short"
    ]
  },
  {
    id: "MF141",
    pattern: [
      7,
      6,
      5,
      4,
      3
    ],
    tags: [
      "mysterious",
      "descending",
      "dark",
      "end",
      "static",
      "short"
    ]
  },
  {
    id: "MF142",
    pattern: [
      5,
      4,
      3,
      2,
      1
    ],
    tags: [
      "mysterious",
      "descending",
      "dark",
      "end",
      "static",
      "short"
    ]
  },
  {
    id: "MF143",
    pattern: [
      6,
      5,
      4,
      3,
      1
    ],
    tags: [
      "mysterious",
      "descending",
      "dark",
      "end",
      "static",
      "short"
    ]
  },
  {
    id: "MF144",
    pattern: [
      7,
      5,
      4,
      2,
      1
    ],
    tags: [
      "mysterious",
      "descending",
      "dark",
      "end",
      "static",
      "short"
    ]
  },
  {
    id: "MF145",
    pattern: [
      5,
      4,
      3,
      1
    ],
    tags: [
      "mysterious",
      "descending",
      "dark",
      "end",
      "static",
      "short"
    ]
  },
  {
    id: "MF146",
    pattern: [
      1,
      2,
      1,
      3,
      1
    ],
    tags: [
      "mysterious",
      "texture_loop",
      "ostinato",
      "loop_safe",
      "short",
      "dark"
    ]
  },
  {
    id: "MF147",
    pattern: [
      5,
      6,
      5,
      7,
      5
    ],
    tags: [
      "mysterious",
      "texture_loop",
      "ostinato",
      "loop_safe",
      "short",
      "dark"
    ]
  },
  {
    id: "MF148",
    pattern: [
      1,
      3,
      1,
      2,
      1
    ],
    tags: [
      "mysterious",
      "texture_loop",
      "ostinato",
      "loop_safe",
      "short",
      "dark"
    ]
  },
  {
    id: "MF149",
    pattern: [
      5,
      7,
      5,
      6,
      5
    ],
    tags: [
      "mysterious",
      "texture_loop",
      "ostinato",
      "loop_safe",
      "short",
      "dark"
    ]
  },
  {
    id: "MF150",
    pattern: [
      1,
      4,
      1,
      3,
      1
    ],
    tags: [
      "mysterious",
      "texture_loop",
      "ostinato",
      "loop_safe",
      "short",
      "dark"
    ]
  },
  {
    id: "MF151",
    pattern: [
      1,
      4,
      6,
      5,
      7,
      6,
      4
    ],
    tags: [
      "breakbeat",
      "tense",
      "leaping",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF152",
    pattern: [
      5,
      3,
      6,
      4,
      7,
      5
    ],
    tags: [
      "breakbeat",
      "tense",
      "sequence",
      "loop_safe",
      "short",
      "variation"
    ]
  },
  {
    id: "MF153",
    pattern: [
      1,
      5,
      4,
      6,
      3,
      7,
      5
    ],
    tags: [
      "breakbeat",
      "upbeat",
      "leaping",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF154",
    pattern: [
      1,
      1,
      3,
      2,
      1
    ],
    tags: [
      "lofi",
      "peaceful",
      "stepwise",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF155",
    pattern: [
      5,
      4,
      4,
      3,
      2,
      2
    ],
    tags: [
      "lofi",
      "peaceful",
      "descending",
      "loop_safe",
      "long"
    ]
  },
  {
    id: "MF156",
    pattern: [
      1,
      3,
      2,
      5,
      4,
      3,
      1
    ],
    tags: [
      "lofi",
      "melancholic",
      "stepwise",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF157",
    pattern: [
      1,
      3,
      5,
      6,
      5,
      3,
      2,
      1
    ],
    tags: [
      "bright",
      "ascending",
      "arch",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF158",
    pattern: [
      5,
      6,
      5,
      3,
      4,
      3,
      2,
      1
    ],
    tags: [
      "bright",
      "sequence",
      "stepwise",
      "loop_safe",
      "variation"
    ]
  },
  {
    id: "MF159",
    pattern: [
      1,
      5,
      4,
      2,
      6,
      5,
      3,
      1
    ],
    tags: [
      "dark",
      "leaping",
      "tense",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF160",
    pattern: [
      6,
      5,
      3,
      2,
      4,
      3,
      2,
      1
    ],
    tags: [
      "dark",
      "descending",
      "cadence",
      "loop_safe",
      "long"
    ]
  },
  {
    id: "MF161",
    pattern: [
      1,
      2,
      3,
      5,
      3,
      2,
      1
    ],
    tags: [
      "simple",
      "bright",
      "stepwise",
      "peaceful",
      "loop_safe"
    ]
  },
  {
    id: "MF162",
    pattern: [
      3,
      2,
      1,
      2,
      4,
      3,
      1
    ],
    tags: [
      "simple",
      "arch",
      "peaceful",
      "texture_loop",
      "short"
    ]
  },
  {
    id: "MF163",
    pattern: [
      1,
      4,
      7,
      6,
      4,
      5,
      3,
      1
    ],
    tags: [
      "complex",
      "leaping",
      "dark",
      "breakbeat",
      "loop_safe"
    ]
  },
  {
    id: "MF164",
    pattern: [
      1,
      1,
      3,
      5,
      4,
      3,
      1
    ],
    tags: [
      "ostinato",
      "bright",
      "texture_loop",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF165",
    pattern: [
      5,
      4,
      3,
      2,
      1
    ],
    tags: [
      "descending",
      "simple",
      "cadence",
      "loop_safe",
      "peaceful",
      "short"
    ]
  },
  {
    id: "MF166",
    pattern: [
      1,
      3,
      1,
      2,
      1
    ],
    tags: [
      "ostinato",
      "lofi",
      "rest_heavy",
      "texture_loop",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF167",
    pattern: [
      1,
      5,
      6,
      5,
      3,
      1
    ],
    tags: [
      "leaping",
      "retro",
      "bright",
      "loop_safe",
      "hook",
      "short"
    ]
  },
  {
    id: "MF168",
    pattern: [
      1,
      6,
      5,
      2,
      1,
      -1,
      1
    ],
    tags: [
      "leaping",
      "dark",
      "tense",
      "battle",
      "syncopated",
      "loop_safe"
    ]
  },
  {
    id: "MF169",
    pattern: [
      3,
      2,
      1,
      1,
      2,
      1
    ],
    tags: [
      "simple",
      "peaceful",
      "cadence",
      "legato",
      "loop_safe"
    ]
  },
  {
    id: "MF170",
    pattern: [
      1,
      4,
      2,
      6,
      4,
      1
    ],
    tags: [
      "complex",
      "breakbeat",
      "dark",
      "syncopated",
      "variation",
      "short"
    ]
  },
  {
    id: "MF171",
    pattern: [
      3,
      2,
      1,
      2,
      1
    ],
    tags: [
      "lofi",
      "peaceful",
      "descending",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF172",
    pattern: [
      5,
      4,
      3,
      2
    ],
    tags: [
      "lofi",
      "dark",
      "descending",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF173",
    pattern: [
      1,
      2,
      3,
      2,
      3,
      2
    ],
    tags: [
      "lofi",
      "peaceful",
      "wave",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF174",
    pattern: [
      1,
      2,
      4,
      3,
      2,
      1
    ],
    tags: [
      "lofi",
      "dark",
      "arch",
      "simple",
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "MF175",
    pattern: [
      5,
      3,
      2,
      1
    ],
    tags: [
      "lofi",
      "dark",
      "descending",
      "leaping",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF176",
    pattern: [
      2,
      1,
      3,
      2,
      1
    ],
    tags: [
      "lofi",
      "peaceful",
      "neighbor",
      "simple",
      "loop_safe",
      "short"
    ]
  },
  {
    id: "MF177",
    pattern: [
      1,
      3,
      2,
      1,
      2,
      1
    ],
    tags: [
      "lofi",
      "melancholic",
      "descending",
      "simple",
      "loop_safe",
      "short"
    ]
  }
], Ea = [
  {
    id: "MR001",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      }
    ],
    tags: [
      "start",
      "simple",
      "drive",
      "loop_safe"
    ]
  },
  {
    id: "MR002",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "syncopated",
      "drive"
    ]
  },
  {
    id: "MR003",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "legato",
      "simple"
    ]
  },
  {
    id: "MR004",
    length: 4,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "rest_heavy",
      "staccato"
    ]
  },
  {
    id: "MR005",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "syncopated",
      "drive"
    ]
  },
  {
    id: "MR006",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "legato",
      "rest_heavy"
    ]
  },
  {
    id: "MR007",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "start",
      "staccato",
      "drive"
    ]
  },
  {
    id: "MR008",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "bridge",
      "legato"
    ]
  },
  {
    id: "MR009",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "end",
      "legato",
      "loop_safe",
      "cadence"
    ]
  },
  {
    id: "MR010",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "end",
      "syncopated",
      "staccato",
      "loop_safe",
      "cadence"
    ]
  },
  {
    id: "MR011",
    length: 4,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "legato",
      "rest_heavy",
      "loop_safe"
    ]
  },
  {
    id: "MR012",
    length: 4,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "staccato",
      "drive",
      "syncopated"
    ]
  },
  {
    id: "MR013",
    length: 4,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "rest_heavy",
      "simple"
    ]
  },
  {
    id: "MR014",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 4
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "syncopated",
      "drive",
      "accented"
    ]
  },
  {
    id: "MR015",
    length: 4,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "end",
      "legato",
      "rest_heavy",
      "loop_safe"
    ]
  },
  {
    id: "MR016",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "bridge",
      "legato",
      "rest_heavy"
    ]
  },
  {
    id: "MR017",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "bridge",
      "syncopated",
      "drive"
    ]
  },
  {
    id: "MR018",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "end",
      "legato",
      "loop_safe",
      "cadence"
    ]
  },
  {
    id: "MR019",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "start",
      "drive",
      "accented"
    ]
  },
  {
    id: "MR020",
    length: 4,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "rest_heavy",
      "simple"
    ]
  },
  {
    id: "MR021",
    length: 4,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "staccato",
      "drive",
      "syncopated"
    ]
  },
  {
    id: "MR022",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      }
    ],
    tags: [
      "end",
      "legato",
      "loop_safe"
    ]
  },
  {
    id: "MR023",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      }
    ],
    tags: [
      "bridge",
      "syncopated",
      "drive",
      "accented"
    ]
  },
  {
    id: "MR024",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "bridge",
      "legato",
      "rest_heavy"
    ]
  },
  {
    id: "MR025",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "end",
      "legato",
      "loop_safe",
      "cadence"
    ]
  },
  {
    id: "MR026",
    length: 4,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "start",
      "texture_loop",
      "grid16",
      "drive",
      "loop_safe"
    ]
  },
  {
    id: "MR027",
    length: 4,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "loop_safe",
      "percussive_layer"
    ]
  },
  {
    id: "MR028",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "start",
      "middle",
      "texture_loop",
      "simple",
      "loop_safe",
      "percussive_layer"
    ]
  },
  {
    id: "MR029",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "texture_loop",
      "loop_safe",
      "percussive_layer"
    ]
  },
  {
    id: "MR030",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 4
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "start",
      "middle",
      "texture_loop",
      "loop_safe",
      "percussive_layer"
    ]
  },
  {
    id: "MR031",
    length: 4,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      }
    ],
    tags: [
      "start",
      "middle",
      "texture_loop",
      "grid16",
      "loop_safe",
      "percussive_layer"
    ]
  },
  {
    id: "MR032",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "texture_loop",
      "loop_safe",
      "percussive_layer",
      "syncopated"
    ]
  },
  {
    id: "MR033",
    length: 4,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      }
    ],
    tags: [
      "start",
      "middle",
      "texture_loop",
      "grid16",
      "loop_safe",
      "percussive_layer"
    ]
  },
  {
    id: "MR034",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 4
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "end",
      "staccato",
      "rest_heavy",
      "percussive_layer",
      "loop_safe"
    ]
  },
  {
    id: "MR035",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      }
    ],
    tags: [
      "start",
      "middle",
      "staccato",
      "rest_heavy",
      "percussive_layer",
      "loop_safe"
    ]
  },
  {
    id: "MR036",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "start",
      "middle",
      "rest_heavy",
      "loop_safe",
      "simple"
    ]
  },
  {
    id: "MR037",
    length: 4,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "end",
      "texture_loop",
      "grid16",
      "loop_safe",
      "percussive_layer"
    ]
  },
  {
    id: "MR038",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "drive",
      "syncopated"
    ]
  },
  {
    id: "MR039",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "simple",
      "drive"
    ]
  },
  {
    id: "MR040",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      }
    ],
    tags: [
      "start",
      "legato",
      "rest_heavy"
    ]
  },
  {
    id: "MR041",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "syncopated",
      "drive"
    ]
  },
  {
    id: "MR042",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "simple",
      "legato"
    ]
  },
  {
    id: "MR043",
    length: 8,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "staccato",
      "drive"
    ]
  },
  {
    id: "MR044",
    length: 8,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "rest_heavy",
      "simple"
    ]
  },
  {
    id: "MR045",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "syncopated",
      "accented"
    ]
  },
  {
    id: "MR046",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "drive",
      "syncopated"
    ]
  },
  {
    id: "MR047",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "simple",
      "legato"
    ]
  },
  {
    id: "MR048",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "staccato",
      "drive"
    ]
  },
  {
    id: "MR049",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "rest_heavy",
      "legato"
    ]
  },
  {
    id: "MR050",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "syncopated",
      "accented"
    ]
  },
  {
    id: "MR051",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "simple",
      "drive"
    ]
  },
  {
    id: "MR052",
    length: 8,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "staccato",
      "syncopated"
    ]
  },
  {
    id: "MR053",
    length: 8,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "rest_heavy",
      "staccato"
    ]
  },
  {
    id: "MR054",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "end",
      "legato",
      "loop_safe",
      "cadence"
    ]
  },
  {
    id: "MR055",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "end",
      "syncopated",
      "loop_safe",
      "cadence"
    ]
  },
  {
    id: "MR056",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "end",
      "simple",
      "loop_safe",
      "cadence"
    ]
  },
  {
    id: "MR057",
    length: 8,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "loop_safe",
      "percussive_layer"
    ]
  },
  {
    id: "MR058",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "texture_loop",
      "simple",
      "loop_safe",
      "percussive_layer"
    ]
  },
  {
    id: "MR059",
    length: 8,
    pattern: [
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "loop_safe",
      "percussive_layer"
    ]
  },
  {
    id: "MR060",
    length: 8,
    pattern: [
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "end",
      "texture_loop",
      "loop_safe",
      "percussive_layer"
    ]
  },
  {
    id: "MR061",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 4
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 4
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 4
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "loop_safe",
      "percussive_layer"
    ]
  },
  {
    id: "MR062",
    length: 4,
    pattern: [
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "syncopated",
      "drive"
    ]
  },
  {
    id: "MR063",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "middle",
      "texture_loop",
      "grid16",
      "percussive_layer",
      "ostinato"
    ]
  },
  {
    id: "MR064",
    length: 4,
    pattern: [
      {
        value: 4,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 16
      }
    ],
    tags: [
      "start",
      "texture_loop",
      "grid16",
      "percussive_layer",
      "loop_safe"
    ]
  },
  {
    id: "MR065",
    length: 4,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "simple",
      "drive",
      "loop_safe",
      "bright"
    ]
  },
  {
    id: "MR066",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "syncopated",
      "drive",
      "staccato",
      "variation"
    ]
  },
  {
    id: "MR067",
    length: 4,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 2,
        accent: !0
      }
    ],
    tags: [
      "end",
      "legato",
      "cadence",
      "loop_safe",
      "peaceful",
      "simple"
    ]
  },
  {
    id: "MR068",
    length: 4,
    pattern: [
      {
        value: 4,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "rest_heavy",
      "legato",
      "texture_loop",
      "simple"
    ]
  },
  {
    id: "MR069",
    length: 8,
    pattern: [
      {
        value: 4,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "drive",
      "syncopated",
      "heroic",
      "loop_safe"
    ]
  },
  {
    id: "MR070",
    length: 8,
    pattern: [
      {
        value: 4,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "syncopated",
      "drive",
      "call_response",
      "variation"
    ]
  },
  {
    id: "MR071",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      },
      {
        value: 2,
        accent: !0
      },
      {
        value: 4
      }
    ],
    tags: [
      "end",
      "cadence",
      "loop_safe",
      "legato",
      "rest_heavy"
    ]
  },
  {
    id: "MR072",
    length: 8,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 16
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 2,
        accent: !0
      }
    ],
    tags: [
      "middle",
      "syncopated",
      "staccato",
      "percussive_layer",
      "breakbeat"
    ]
  },
  {
    id: "MR073",
    length: 4,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4,
        accent: !0
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "loop_safe",
      "texture_loop",
      "grid16",
      "simple",
      "syncopated"
    ]
  },
  {
    id: "MR075",
    length: 4,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      }
    ],
    tags: [
      "pickup",
      "start",
      "syncopated",
      "drive",
      "staccato"
    ]
  },
  {
    id: "MR076",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4,
        rest: !0
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 4
      },
      {
        value: 2,
        accent: !0
      }
    ],
    tags: [
      "start",
      "middle",
      "rest_heavy",
      "lofi",
      "swing_hint",
      "loop_safe"
    ]
  },
  {
    id: "MR077",
    length: 8,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      }
    ],
    tags: [
      "middle",
      "syncopated",
      "breakbeat",
      "grid16",
      "percussive_layer",
      "variation"
    ]
  },
  {
    id: "MR078",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4,
        accent: !0
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "texture_loop",
      "retro",
      "loop_safe",
      "simple"
    ]
  },
  {
    id: "MR079",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4,
        accent: !0
      }
    ],
    tags: [
      "end",
      "cadence",
      "loop_safe",
      "syncopated",
      "staccato",
      "drive"
    ]
  },
  {
    id: "MR080",
    length: 4,
    pattern: [
      {
        value: 4,
        rest: !0
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "rest_heavy",
      "lofi",
      "loop_safe"
    ]
  },
  {
    id: "MR081",
    length: 4,
    pattern: [
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "middle",
      "rest_heavy",
      "lofi",
      "swing_hint",
      "loop_safe"
    ]
  },
  {
    id: "MR082",
    length: 4,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 2
      }
    ],
    tags: [
      "end",
      "legato",
      "lofi",
      "rest_heavy",
      "loop_safe"
    ]
  },
  {
    id: "MR083",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4,
        rest: !0
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 4
      },
      {
        value: 2
      }
    ],
    tags: [
      "start",
      "middle",
      "rest_heavy",
      "lofi",
      "swing_hint",
      "legato",
      "loop_safe"
    ]
  },
  {
    id: "MR084",
    length: 4,
    pattern: [
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      }
    ],
    tags: [
      "bridge",
      "rest_heavy",
      "lofi",
      "swing_hint"
    ]
  },
  {
    id: "MR085",
    length: 4,
    pattern: [
      {
        value: 16,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 8
      }
    ],
    tags: [
      "start",
      "syncopated",
      "staccato",
      "breakbeat",
      "percussive_layer"
    ]
  },
  {
    id: "MR086",
    length: 4,
    pattern: [
      {
        value: 8,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8,
        accent: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 4
      }
    ],
    tags: [
      "end",
      "syncopated",
      "breakbeat",
      "loop_safe"
    ]
  },
  {
    id: "MR087",
    length: 4,
    pattern: [
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16,
        rest: !0
      },
      {
        value: 16,
        accent: !0
      },
      {
        value: 16
      },
      {
        value: 16,
        rest: !0
      }
    ],
    tags: [
      "bridge",
      "syncopated",
      "breakbeat",
      "grid16",
      "percussive_layer"
    ]
  },
  {
    id: "MR088",
    length: 8,
    pattern: [
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 2
      },
      {
        value: 4
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 4
      }
    ],
    tags: [
      "start",
      "middle",
      "peaceful",
      "simple",
      "legato",
      "lofi",
      "texture_loop",
      "loop_safe"
    ]
  },
  {
    id: "MR089",
    length: 8,
    pattern: [
      {
        value: 2
      },
      {
        value: 8,
        rest: !0
      },
      {
        value: 8
      },
      {
        value: 4
      },
      {
        value: 8
      },
      {
        value: 8
      },
      {
        value: 4,
        rest: !0
      },
      {
        value: 2,
        accent: !0
      }
    ],
    tags: [
      "middle",
      "end",
      "peaceful",
      "simple",
      "legato",
      "lofi",
      "cadence",
      "loop_safe"
    ]
  }
], Ta = [
  {
    id: "DP001",
    length_beats: 4,
    type: "beat",
    pattern: "K-H-S-H-K-H-S-H-",
    tags: [
      "loop_safe"
    ]
  },
  {
    id: "DP002",
    length_beats: 4,
    type: "beat",
    pattern: "H-S-H-K-H-S-H-K-",
    tags: [
      "loop_safe",
      "variation"
    ]
  },
  {
    id: "DP003",
    length_beats: 4,
    type: "beat",
    pattern: "K---S---K-H-S-H",
    tags: [
      "bridge"
    ]
  },
  {
    id: "DP004",
    length_beats: 4,
    type: "beat",
    pattern: "--S---K-H-S-HK-",
    tags: [
      "bridge",
      "variation"
    ]
  },
  {
    id: "DP005",
    length_beats: 4,
    type: "beat",
    pattern: "K-H-K---S-H-K---",
    tags: [
      "build"
    ]
  },
  {
    id: "DP006",
    length_beats: 4,
    type: "beat",
    pattern: "H-K---S-H-K---K-",
    tags: [
      "build",
      "variation"
    ]
  },
  {
    id: "DP007",
    length_beats: 4,
    type: "beat",
    pattern: "K---S-H-K---S-H-",
    tags: [
      "straight"
    ]
  },
  {
    id: "DP008",
    length_beats: 4,
    type: "beat",
    pattern: "--S-H-K---S-H-K-",
    tags: [
      "straight",
      "variation"
    ]
  },
  {
    id: "DP009",
    length_beats: 4,
    type: "beat",
    pattern: "K-H---S-K-H---S-",
    tags: [
      "syncopation"
    ]
  },
  {
    id: "DP010",
    length_beats: 4,
    type: "beat",
    pattern: "H---S-K-H---S-K-",
    tags: [
      "syncopation",
      "variation"
    ]
  },
  {
    id: "DP011",
    length_beats: 4,
    type: "beat",
    pattern: "K---H-K-S---H-K-",
    tags: [
      "open"
    ]
  },
  {
    id: "DP012",
    length_beats: 4,
    type: "beat",
    pattern: "--H-K-S---H-K-K-",
    tags: [
      "open",
      "variation"
    ]
  },
  {
    id: "DP014",
    length_beats: 4,
    type: "beat",
    pattern: "H-K-H-S-H-K-H-K-",
    tags: [
      "loop_safe",
      "variation"
    ]
  },
  {
    id: "DP015",
    length_beats: 4,
    type: "beat",
    pattern: "K---S---K---H---",
    tags: [
      "simple"
    ]
  },
  {
    id: "DP016",
    length_beats: 4,
    type: "beat",
    pattern: "--S---K---H---K-",
    tags: [
      "simple",
      "variation"
    ]
  },
  {
    id: "DP017",
    length_beats: 4,
    type: "beat",
    pattern: "K-H---K-S-H---K-",
    tags: [
      "bridge"
    ]
  },
  {
    id: "DP018",
    length_beats: 4,
    type: "beat",
    pattern: "H---K-S-H---K-K-",
    tags: [
      "bridge",
      "variation"
    ]
  },
  {
    id: "DP019",
    length_beats: 4,
    type: "beat",
    pattern: "K--H-K--S-H-K--",
    tags: [
      "swing_hint"
    ]
  },
  {
    id: "DP020",
    length_beats: 4,
    type: "beat",
    pattern: "-H-K--S-H-K--K-",
    tags: [
      "swing_hint",
      "variation"
    ]
  },
  {
    id: "DP021",
    length_beats: 4,
    type: "fill",
    pattern: "S-S-S-S-S-S-O---",
    tags: [
      "cadence"
    ]
  },
  {
    id: "DP022",
    length_beats: 4,
    type: "fill",
    pattern: "S-S-S-S-O---S-S-",
    tags: [
      "cadence",
      "variation"
    ]
  },
  {
    id: "DP023",
    length_beats: 8,
    type: "fill",
    pattern: "S-S-S-S-S-S-O---S-S-S-S-S-S-O---",
    tags: [
      "cadence",
      "extended"
    ]
  },
  {
    id: "DP024",
    length_beats: 4,
    type: "fill",
    pattern: "KSKO-KSKO-KSKO-K",
    tags: [
      "build"
    ]
  },
  {
    id: "DP025",
    length_beats: 4,
    type: "fill",
    pattern: "-KSKO-KSKO-KKSKO",
    tags: [
      "build",
      "variation"
    ]
  },
  {
    id: "DP026",
    length_beats: 8,
    type: "fill",
    pattern: "KSKO-KSKO-KSKO-KKSKO-KSKO-KSKO-K",
    tags: [
      "build",
      "extended"
    ]
  },
  {
    id: "DP027",
    length_beats: 4,
    type: "fill",
    pattern: "S-HS-HS-HS-HS-HS",
    tags: [
      "bridge"
    ]
  },
  {
    id: "DP028",
    length_beats: 4,
    type: "fill",
    pattern: "-HS-HS-HS-HSS-HS",
    tags: [
      "bridge",
      "variation"
    ]
  },
  {
    id: "DP029",
    length_beats: 8,
    type: "fill",
    pattern: "S-HS-HS-HS-HS-HSS-HS-HS-HS-HS-HS",
    tags: [
      "bridge",
      "extended"
    ]
  },
  {
    id: "DP030",
    length_beats: 4,
    type: "fill",
    pattern: "K-SK-SK-SK-SK-SK",
    tags: [
      "build"
    ]
  },
  {
    id: "DP031",
    length_beats: 4,
    type: "fill",
    pattern: "-SK-SK-SK-SKK-SK",
    tags: [
      "build",
      "variation"
    ]
  },
  {
    id: "DP032",
    length_beats: 8,
    type: "fill",
    pattern: "K-SK-SK-SK-SK-SKK-SK-SK-SK-SK-SK",
    tags: [
      "build",
      "extended"
    ]
  },
  {
    id: "DP033",
    length_beats: 4,
    type: "fill",
    pattern: "S--S-HHS--S-HHS-",
    tags: [
      "break"
    ]
  },
  {
    id: "DP034",
    length_beats: 4,
    type: "fill",
    pattern: "-HHS--S-HHS-S--S",
    tags: [
      "break",
      "variation"
    ]
  },
  {
    id: "DP035",
    length_beats: 8,
    type: "fill",
    pattern: "S--S-HHS--S-HHS-S--S-HHS--S-HHS-",
    tags: [
      "break",
      "extended"
    ]
  },
  {
    id: "DP036",
    length_beats: 4,
    type: "fill",
    pattern: "K-K-K-K-S-S-S-S-",
    tags: [
      "cadence"
    ]
  },
  {
    id: "DP037",
    length_beats: 4,
    type: "fill",
    pattern: "K-K-S-S-S-S-K-K-",
    tags: [
      "cadence",
      "variation"
    ]
  },
  {
    id: "DP038",
    length_beats: 8,
    type: "fill",
    pattern: "K-K-K-K-S-S-S-S-K-K-K-K-S-S-S-S-",
    tags: [
      "cadence",
      "extended"
    ]
  },
  {
    id: "DP039",
    length_beats: 4,
    type: "fill",
    pattern: "S-S-H-H-S-S-H-H-",
    tags: [
      "bridge"
    ]
  },
  {
    id: "DP040",
    length_beats: 4,
    type: "fill",
    pattern: "H-H-S-S-H-H-S-S-",
    tags: [
      "bridge",
      "variation"
    ]
  },
  {
    id: "DP041",
    length_beats: 8,
    type: "fill",
    pattern: "S-S-H-H-S-S-H-H-S-S-H-H-S-S-H-H-",
    tags: [
      "bridge",
      "extended"
    ]
  },
  {
    id: "DP042",
    length_beats: 4,
    type: "fill",
    pattern: "KSTK-KSTK-KSTK-K",
    tags: [
      "toms"
    ]
  },
  {
    id: "DP043",
    length_beats: 4,
    type: "fill",
    pattern: "-KSTK-KSTK-KKSTK",
    tags: [
      "toms",
      "variation"
    ]
  },
  {
    id: "DP044",
    length_beats: 8,
    type: "fill",
    pattern: "KSTK-KSTK-KSTK-KKSTK-KSTK-KSTK-K",
    tags: [
      "toms",
      "extended"
    ]
  },
  {
    id: "DP045",
    length_beats: 4,
    type: "fill",
    pattern: "S--S--S--S--S--S",
    tags: [
      "loop_safe"
    ]
  },
  {
    id: "DP046",
    length_beats: 4,
    type: "fill",
    pattern: "--S--S--S--SS--S",
    tags: [
      "loop_safe",
      "variation"
    ]
  },
  {
    id: "DP047",
    length_beats: 8,
    type: "fill",
    pattern: "S--S--S--S--S--SS--S--S--S--S--S",
    tags: [
      "loop_safe",
      "extended"
    ]
  },
  {
    id: "DP048",
    length_beats: 4,
    type: "fill",
    pattern: "K-S-H-K-S-H-K-S-",
    tags: [
      "bridge"
    ]
  },
  {
    id: "DP049",
    length_beats: 4,
    type: "fill",
    pattern: "H-K-S-H-K-S-K-S-",
    tags: [
      "bridge",
      "variation"
    ]
  },
  {
    id: "DP050",
    length_beats: 8,
    type: "fill",
    pattern: "K-S-H-K-S-H-K-S-K-S-H-K-S-H-K-S-",
    tags: [
      "bridge",
      "extended"
    ]
  },
  {
    id: "DP051",
    length_beats: 4,
    type: "beat",
    pattern: "K-H-K-H-K-H-K-H-",
    tags: [
      "loop_safe",
      "four_on_floor",
      "straight",
      "percussive_layer",
      "texture_loop"
    ]
  },
  {
    id: "DP052",
    length_beats: 4,
    type: "beat",
    pattern: "K-HO-K-H-K-O-K-H-",
    tags: [
      "loop_safe",
      "four_on_floor",
      "straight",
      "variation",
      "percussive_layer"
    ]
  },
  {
    id: "DP053",
    length_beats: 4,
    type: "beat",
    pattern: "K-HH-K-HH-K-HH-K-HH",
    tags: [
      "loop_safe",
      "grid16",
      "texture_loop",
      "percussive_layer"
    ]
  },
  {
    id: "DP054",
    length_beats: 4,
    type: "beat",
    pattern: "K--S--K-K--S--K-",
    tags: [
      "rock",
      "drive",
      "loop_safe"
    ]
  },
  {
    id: "DP055",
    length_beats: 4,
    type: "beat",
    pattern: "K-K-S---K-K-S-K-",
    tags: [
      "dance",
      "syncopation",
      "loop_safe"
    ]
  },
  {
    id: "DP056",
    length_beats: 4,
    type: "beat",
    pattern: "K-----S-K-----S-",
    tags: [
      "ballad",
      "simple",
      "loop_safe"
    ]
  },
  {
    id: "DP057",
    length_beats: 4,
    type: "beat",
    pattern: "K-H-S-K-K-H-S-H-",
    tags: [
      "rock",
      "energetic",
      "loop_safe",
      "variation"
    ]
  },
  {
    id: "DP058",
    length_beats: 4,
    type: "beat",
    pattern: "K-S-K-S-K-S-K-S-",
    tags: [
      "dance",
      "four_on_floor",
      "loop_safe"
    ]
  },
  {
    id: "DP059",
    length_beats: 4,
    type: "beat",
    pattern: "K---S-K-K---S---",
    tags: [
      "syncopation",
      "upbeat",
      "loop_safe"
    ]
  },
  {
    id: "DP060",
    length_beats: 4,
    type: "beat",
    pattern: "K-H-S-H-K---S-H-",
    tags: [
      "rock",
      "variation",
      "loop_safe"
    ]
  },
  {
    id: "DP061",
    length_beats: 4,
    type: "beat",
    pattern: "K-K---S-K-K-S---",
    tags: [
      "dance",
      "syncopation",
      "tense",
      "loop_safe"
    ]
  },
  {
    id: "DP062",
    length_beats: 4,
    type: "beat",
    pattern: "K-H-S---K-H-S-K-",
    tags: [
      "rock",
      "drive",
      "loop_safe",
      "variation"
    ]
  },
  {
    id: "DP063",
    length_beats: 4,
    type: "beat",
    pattern: "K-----S---K-S---",
    tags: [
      "ballad",
      "peaceful",
      "simple",
      "loop_safe"
    ]
  },
  {
    id: "DP064",
    length_beats: 4,
    type: "beat",
    pattern: "K-K-S-K-K-K-S-K-",
    tags: [
      "dance",
      "energetic",
      "drive",
      "loop_safe"
    ]
  },
  {
    id: "DP065",
    length_beats: 4,
    type: "beat",
    pattern: "K-H-S-K---H-S-H-",
    tags: [
      "syncopation",
      "rock",
      "variation",
      "loop_safe"
    ]
  },
  {
    id: "DP066",
    length_beats: 4,
    type: "beat",
    pattern: "K---S---K-K-S-K-",
    tags: [
      "dance",
      "syncopation",
      "build",
      "loop_safe"
    ]
  },
  {
    id: "DP067",
    length_beats: 4,
    type: "beat",
    pattern: "K-H-S-H-K-H-S---",
    tags: [
      "rock",
      "cadence",
      "loop_safe"
    ]
  },
  {
    id: "DP068",
    length_beats: 4,
    type: "beat",
    pattern: "K-K-K-K-S-S-S-S-",
    tags: [
      "experimental",
      "build",
      "tense",
      "loop_safe"
    ]
  },
  {
    id: "DP069",
    length_beats: 4,
    type: "beat",
    pattern: "K-HO-K-HO-K-HO-K-HO",
    tags: [
      "loop_safe",
      "four_on_floor",
      "texture_loop",
      "percussive_layer",
      "variation"
    ]
  },
  {
    id: "DP070",
    length_beats: 4,
    type: "beat",
    pattern: "K-HS-K-HK-HS-K-HK-HS",
    tags: [
      "loop_safe",
      "four_on_floor",
      "grid16",
      "percussive_layer",
      "texture_loop"
    ]
  },
  {
    id: "DP071",
    length_beats: 4,
    type: "beat",
    pattern: "K-H-K-S-K-H-O-S-",
    tags: [
      "loop_safe",
      "four_on_floor",
      "syncopation",
      "percussive_layer",
      "variation"
    ]
  },
  {
    id: "DP072",
    length_beats: 4,
    type: "beat",
    pattern: "K-HH-K-S-K-HH-K-S",
    tags: [
      "loop_safe",
      "four_on_floor",
      "grid16",
      "percussive_layer",
      "build"
    ]
  },
  {
    id: "DP073",
    length_beats: 4,
    type: "beat",
    pattern: "KH-HSHKHOHSHKHSH",
    tags: [
      "loop_safe",
      "grid16",
      "syncopation",
      "breakbeat",
      "percussive_layer"
    ]
  },
  {
    id: "DP074",
    length_beats: 4,
    type: "beat",
    pattern: "KH-HSH-KHSOHK-SH",
    tags: [
      "loop_safe",
      "grid16",
      "syncopation",
      "breakbeat",
      "variation",
      "percussive_layer"
    ]
  },
  {
    id: "DP075",
    length_beats: 4,
    type: "fill",
    pattern: "KHSHKHSHKTSHKHSH",
    tags: [
      "break",
      "breakbeat",
      "drum_fill",
      "grid16",
      "syncopation"
    ]
  },
  {
    id: "DP076",
    length_beats: 4,
    type: "beat",
    pattern: "K--H-K--S-H--H--",
    tags: [
      "loop_safe",
      "swing_hint",
      "simple",
      "rest_heavy",
      "lofi"
    ]
  },
  {
    id: "DP077",
    length_beats: 4,
    type: "beat",
    pattern: "K-H--K-HS--H--H-",
    tags: [
      "loop_safe",
      "swing_hint",
      "rest_heavy",
      "lofi",
      "variation"
    ]
  },
  {
    id: "DP078",
    length_beats: 4,
    type: "beat",
    pattern: "K-HS-K-HSK-H-SH-",
    tags: [
      "loop_safe",
      "grid16",
      "syncopation",
      "breakbeat",
      "percussive_layer"
    ]
  },
  {
    id: "DP079",
    length_beats: 4,
    type: "beat",
    pattern: "K-HO-KS-HK-S-HO-",
    tags: [
      "loop_safe",
      "grid16",
      "syncopation",
      "breakbeat",
      "percussive_layer",
      "variation"
    ]
  },
  {
    id: "DP080",
    length_beats: 4,
    type: "fill",
    pattern: "KHSHKHSKTSHKHSS-",
    tags: [
      "break",
      "breakbeat",
      "drum_fill",
      "grid16",
      "syncopation"
    ]
  },
  {
    id: "DP081",
    length_beats: 4,
    type: "beat",
    pattern: "K---H---S-H-----",
    tags: [
      "loop_safe",
      "swing_hint",
      "rest_heavy",
      "lofi"
    ]
  },
  {
    id: "DP082",
    length_beats: 4,
    type: "beat",
    pattern: "K--H---HS--H-K--",
    tags: [
      "loop_safe",
      "swing_hint",
      "rest_heavy",
      "lofi",
      "variation"
    ]
  },
  {
    id: "DP083",
    length_beats: 4,
    type: "fill",
    pattern: "N---S---N---H---",
    tags: [
      "lofi",
      "drum_fill",
      "rest_heavy",
      "transition"
    ]
  },
  {
    id: "DP084",
    length_beats: 4,
    type: "beat",
    pattern: "KHHH-HSHKH-HSHK-",
    tags: [
      "loop_safe",
      "grid16",
      "syncopation",
      "breakbeat",
      "percussive_layer"
    ]
  },
  {
    id: "DP085",
    length_beats: 4,
    type: "beat",
    pattern: "KH-HKHSH-HSHKHSO",
    tags: [
      "loop_safe",
      "grid16",
      "syncopation",
      "breakbeat",
      "percussive_layer",
      "variation"
    ]
  },
  {
    id: "DP086",
    length_beats: 4,
    type: "beat",
    pattern: "K-HHKSH-HK-SHH-H",
    tags: [
      "loop_safe",
      "grid16",
      "syncopation",
      "breakbeat",
      "percussive_layer"
    ]
  },
  {
    id: "DP087",
    length_beats: 4,
    type: "beat",
    pattern: "KHHSHK-HSHK-SHOH",
    tags: [
      "loop_safe",
      "grid16",
      "syncopation",
      "breakbeat",
      "percussive_layer",
      "variation"
    ]
  },
  {
    id: "DP088",
    length_beats: 4,
    type: "fill",
    pattern: "KHSHSHKTSHSHKSH-",
    tags: [
      "break",
      "breakbeat",
      "drum_fill",
      "grid16",
      "syncopation"
    ]
  },
  {
    id: "DP089",
    length_beats: 4,
    type: "fill",
    pattern: "KHSKHSKTSHSKHSKO",
    tags: [
      "break",
      "breakbeat",
      "drum_fill",
      "grid16",
      "syncopation",
      "variation"
    ]
  },
  {
    id: "DP090",
    length_beats: 4,
    type: "beat",
    pattern: "K--HSHK--H-SH-K-",
    tags: [
      "loop_safe",
      "grid16",
      "breakbeat",
      "syncopation",
      "percussive_layer"
    ]
  },
  {
    id: "DP091",
    length_beats: 4,
    type: "beat",
    pattern: "KH--S-HK--HSH--O",
    tags: [
      "loop_safe",
      "grid16",
      "breakbeat",
      "syncopation",
      "variation"
    ]
  },
  {
    id: "DP092",
    length_beats: 4,
    type: "beat",
    pattern: "K---H---S---H---",
    tags: [
      "loop_safe",
      "texture_loop",
      "straight",
      "retro",
      "simple"
    ]
  },
  {
    id: "DP093",
    length_beats: 4,
    type: "beat",
    pattern: "K-H-K-H-S-H-K-H-",
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer",
      "retro",
      "grid16"
    ]
  },
  {
    id: "DP094",
    length_beats: 4,
    type: "beat",
    pattern: "K---H-----S-H---",
    tags: [
      "loop_safe",
      "lofi",
      "rest_heavy",
      "swing_hint",
      "texture_loop"
    ]
  },
  {
    id: "DP095",
    length_beats: 4,
    type: "beat",
    pattern: "K--H---S--H---H-",
    tags: [
      "loop_safe",
      "lofi",
      "rest_heavy",
      "swing_hint",
      "variation"
    ]
  },
  {
    id: "DP096",
    length_beats: 4,
    type: "fill",
    pattern: "K-S-H-S-KTS-H-S-",
    tags: [
      "drum_fill",
      "build",
      "grid16",
      "transition"
    ]
  },
  {
    id: "DP097",
    length_beats: 4,
    type: "fill",
    pattern: "N---S-H-N---S-H-",
    tags: [
      "drum_fill",
      "noise_fx",
      "section_end",
      "loop_safe"
    ]
  },
  {
    id: "DP098",
    length_beats: 4,
    type: "fill",
    pattern: "S-HSK-HSS-HSK-HO",
    tags: [
      "break",
      "breakbeat",
      "drum_fill",
      "grid16",
      "syncopation",
      "variation"
    ]
  },
  {
    id: "DP099",
    length_beats: 4,
    type: "beat",
    pattern: "K---H---S-----H-",
    tags: [
      "loop_safe",
      "lofi",
      "rest_heavy",
      "swing_hint",
      "simple",
      "open"
    ]
  },
  {
    id: "DP100",
    length_beats: 4,
    type: "beat",
    pattern: "K--H---S--H-----",
    tags: [
      "loop_safe",
      "lofi",
      "rest_heavy",
      "swing_hint",
      "variation"
    ]
  },
  {
    id: "DP101",
    length_beats: 4,
    type: "fill",
    pattern: "N-------S---H---",
    tags: [
      "drum_fill",
      "noise_fx",
      "lofi",
      "rest_heavy",
      "section_end"
    ]
  },
  {
    id: "DP102",
    length_beats: 4,
    type: "fill",
    pattern: "N---H---N---S---",
    tags: [
      "drum_fill",
      "noise_fx",
      "lofi",
      "transition",
      "rest_heavy"
    ]
  },
  {
    id: "DP103",
    length_beats: 4,
    type: "beat",
    pattern: "KH-HS-H-KH-HS-H-",
    tags: [
      "loop_safe",
      "grid16",
      "percussive_layer",
      "four_on_floor",
      "drive"
    ]
  },
  {
    id: "DP104",
    length_beats: 4,
    type: "beat",
    pattern: "KHH-S-H-K-HHS-H-",
    tags: [
      "loop_safe",
      "grid16",
      "percussive_layer",
      "breakbeat",
      "syncopation"
    ]
  },
  {
    id: "DP105",
    length_beats: 4,
    type: "fill",
    pattern: "S-HSK-HSS-HSK-H-",
    tags: [
      "break",
      "breakbeat",
      "drum_fill",
      "grid16",
      "syncopation",
      "percussive_layer"
    ]
  },
  {
    id: "DP106",
    length_beats: 4,
    type: "beat",
    pattern: "K---H---S---H-H-",
    tags: [
      "loop_safe",
      "retro",
      "texture_loop",
      "grid16",
      "simple"
    ]
  }
], Pa = [
  {
    id: "BP_STEADY_ROOT_DRIVE",
    texture: "steady",
    steps: [
      "root",
      "root",
      "fifth",
      "root",
      "fifth",
      "root",
      "fifth",
      "approach"
    ],
    tags: [
      "default",
      "loop_safe"
    ]
  },
  {
    id: "BP_STEADY_UPWARD_WALK",
    texture: "steady",
    steps: [
      "root",
      "fifth",
      "root",
      "octave",
      "fifth",
      "root",
      "octave",
      "approach"
    ],
    tags: [
      "variation",
      "section_end"
    ]
  },
  {
    id: "BP_BROKEN_TRIAD_LIFT",
    texture: "broken",
    steps: [
      "root",
      "fifth",
      "root",
      "octave",
      "root",
      "fifth",
      "root",
      "approach"
    ],
    tags: [
      "default"
    ]
  },
  {
    id: "BP_BROKEN_PICKUP_DROP",
    texture: "broken",
    steps: [
      "root",
      "octave",
      "fifth",
      "octaveHigh",
      "root",
      "fifth",
      "octave",
      "approach"
    ],
    tags: [
      "variation",
      "pickup",
      "section_end"
    ]
  },
  {
    id: "BP_BREAK_OFFBEAT_DRIVE",
    texture: "broken",
    steps: [
      "root",
      "rest",
      "octave",
      "rest",
      "fifth",
      "approach",
      "lowFifth",
      "approach"
    ],
    tags: [
      "loop_safe",
      "syncopated",
      "breakbeat",
      "variation",
      "default"
    ]
  },
  {
    id: "BP_BREAK_GHOST_RIDE",
    texture: "broken",
    steps: [
      "root",
      "octave",
      "rest",
      "fifth",
      "rest",
      "octave",
      "lowFifth",
      "approach"
    ],
    tags: [
      "loop_safe",
      "breakbeat",
      "syncopated",
      "drive",
      "default"
    ]
  },
  {
    id: "BP_BREAK_SLIDE_UP",
    texture: "broken",
    steps: [
      "root",
      "approach",
      "fifth",
      "rest",
      "root",
      "octave",
      "rest",
      "approach"
    ],
    tags: [
      "loop_safe",
      "breakbeat",
      "variation"
    ]
  },
  {
    id: "BP_LOFI_SWUNG_ROOT",
    texture: "steady",
    steps: [
      "root",
      "rest",
      "rest",
      "root",
      "rest",
      "fifth",
      "rest",
      "approach"
    ],
    tags: [
      "loop_safe",
      "rest_heavy",
      "swing_hint",
      "lofi"
    ]
  },
  {
    id: "BP_LOFI_DUSTY_STEP",
    texture: "steady",
    steps: [
      "root",
      "rest",
      "rest",
      "fifth",
      "rest",
      "rest",
      "root",
      "approach"
    ],
    tags: [
      "loop_safe",
      "lofi",
      "rest_heavy",
      "swing_hint"
    ]
  },
  {
    id: "BP_LOFI_WALKDOWN",
    texture: "steady",
    steps: [
      "root",
      "rest",
      "third",
      "rest",
      "second",
      "rest",
      "root",
      "approach"
    ],
    tags: [
      "loop_safe",
      "lofi",
      "rest_heavy",
      "variation"
    ]
  },
  {
    id: "BP_ARPEGGIO_GLIDE",
    texture: "arpeggio",
    steps: [
      "root",
      "octave",
      "fifth",
      "octaveHigh",
      "root",
      "fifth",
      "octave",
      "approach"
    ],
    tags: [
      "default",
      "loop_safe"
    ]
  },
  {
    id: "BP_ARPEGGIO_PULSE",
    texture: "arpeggio",
    steps: [
      "root",
      "fifth",
      "octave",
      "octaveHigh",
      "root",
      "fifth",
      "octave",
      "approach"
    ],
    tags: [
      "variation",
      "transition",
      "section_end"
    ]
  },
  {
    id: "BP_STEADY_OFFBEAT_PUSH",
    texture: "steady",
    steps: [
      "root",
      "fifth",
      "root",
      "approach",
      "fifth",
      "root",
      "octave",
      "approach"
    ],
    tags: [
      "variation",
      "syncopated",
      "loop_safe"
    ]
  },
  {
    id: "BP_BROKEN_LOW_SWING",
    texture: "broken",
    steps: [
      "root",
      "lowFifth",
      "root",
      "fifth",
      "root",
      "lowFifth",
      "root",
      "approach"
    ],
    tags: [
      "variation",
      "loop_safe"
    ]
  },
  {
    id: "BP_ARPEGGIO_SPREAD",
    texture: "arpeggio",
    steps: [
      "root",
      "octave",
      "fifth",
      "octaveHigh",
      "fifth",
      "octave",
      "octaveHigh",
      "approach"
    ],
    tags: [
      "variation",
      "loop_safe"
    ]
  },
  {
    id: "BP_STEADY_SUB_GRID",
    texture: "steady",
    steps: [
      "root",
      "root",
      "root",
      "root",
      "root",
      "root",
      "root",
      "root"
    ],
    tags: [
      "loop_safe",
      "percussive_layer",
      "four_on_floor",
      "static"
    ]
  },
  {
    id: "BP_STEADY_SUB_OFFSET",
    texture: "steady",
    steps: [
      "root",
      "root",
      "root",
      "fifth",
      "root",
      "root",
      "root",
      "approach"
    ],
    tags: [
      "loop_safe",
      "percussive_layer",
      "variation"
    ]
  },
  {
    id: "BP_FOUR_ON_FLOOR_CLASSIC",
    texture: "steady",
    steps: [
      "root",
      "root",
      "root",
      "root",
      "root",
      "fifth",
      "root",
      "root"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer",
      "static",
      "drone"
    ]
  },
  {
    id: "BP_FOUR_ON_FLOOR_GHOST",
    texture: "steady",
    steps: [
      "root",
      "root",
      "fifth",
      "root",
      "root",
      "root",
      "fifth",
      "root"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer"
    ]
  },
  {
    id: "BP_FOUR_ON_FLOOR_OFFBEAT",
    texture: "steady",
    steps: [
      "root",
      "fifth",
      "root",
      "root",
      "root",
      "fifth",
      "root",
      "root"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer",
      "syncopated"
    ]
  },
  {
    id: "BP_FOUR_ON_FLOOR_OCTAVE_HIT",
    texture: "steady",
    steps: [
      "root",
      "root",
      "root",
      "octave",
      "root",
      "root",
      "root",
      "octave"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer"
    ]
  },
  {
    id: "BP_FOUR_ON_FLOOR_ROLLING",
    texture: "steady",
    steps: [
      "root",
      "root",
      "root",
      "fifth",
      "root",
      "root",
      "root",
      "fifth"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer"
    ]
  },
  {
    id: "BP_DRONE_STATIC_ROOT",
    texture: "steady",
    steps: [
      "root",
      "root",
      "root",
      "root",
      "root",
      "fifth",
      "root",
      "approach"
    ],
    tags: [
      "loop_safe",
      "static",
      "drone",
      "four_on_floor",
      "percussive_layer"
    ]
  },
  {
    id: "BP_DRONE_LOW_PULSE",
    texture: "steady",
    steps: [
      "root",
      "lowFifth",
      "root",
      "lowFifth",
      "root",
      "lowFifth",
      "root",
      "lowFifth"
    ],
    tags: [
      "loop_safe",
      "drone",
      "percussive_layer"
    ]
  },
  {
    id: "BP_DRONE_ACCENT_SPARK",
    texture: "steady",
    steps: [
      "root",
      "rest",
      "octave",
      "root",
      "rest",
      "fifth",
      "root",
      "approach"
    ],
    tags: [
      "loop_safe",
      "drone",
      "accent"
    ]
  },
  {
    id: "BP_TECHNO_BOUNCE",
    texture: "broken",
    steps: [
      "root",
      "root",
      "octave",
      "root",
      "root",
      "root",
      "octave",
      "root"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer"
    ]
  },
  {
    id: "BP_TECHNO_SUB_EMPHASIS",
    texture: "steady",
    steps: [
      "root",
      "root",
      "root",
      "lowFifth",
      "root",
      "root",
      "root",
      "lowFifth"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer"
    ]
  },
  {
    id: "BP_MINIMAL_BREATH",
    texture: "steady",
    steps: [
      "root",
      "root",
      "root",
      "root",
      "fifth",
      "root",
      "root",
      "root"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer",
      "static"
    ]
  },
  {
    id: "BP_WALKING_BASS",
    texture: "broken",
    steps: [
      "root",
      "second",
      "third",
      "fifth",
      "root",
      "seventh",
      "octave",
      "approach"
    ],
    tags: [
      "variation",
      "walking",
      "jazz_hint"
    ]
  },
  {
    id: "BP_OCTAVE_JUMP",
    texture: "broken",
    steps: [
      "root",
      "octave",
      "root",
      "octave",
      "fifth",
      "octaveHigh",
      "fifth",
      "approach"
    ],
    tags: [
      "variation",
      "energetic",
      "jump"
    ]
  },
  {
    id: "BP_CHROMATIC_WALK",
    texture: "broken",
    steps: [
      "root",
      "flatSecond",
      "second",
      "third",
      "fifth",
      "sixth",
      "seventh",
      "approach"
    ],
    tags: [
      "variation",
      "chromatic",
      "tense"
    ]
  },
  {
    id: "BP_SYNCOPATED_GROOVE",
    texture: "broken",
    steps: [
      "root",
      "fifth",
      "octave",
      "root",
      "fifth",
      "octave",
      "fifth",
      "approach"
    ],
    tags: [
      "variation",
      "syncopation",
      "groove"
    ]
  },
  {
    id: "BP_PEDAL_FIFTH",
    texture: "steady",
    steps: [
      "root",
      "fifth",
      "root",
      "fifth",
      "root",
      "fifth",
      "root",
      "fifth"
    ],
    tags: [
      "loop_safe",
      "simple",
      "rock"
    ]
  },
  {
    id: "BP_ARPEGGIO_CASCADE",
    texture: "arpeggio",
    steps: [
      "root",
      "third",
      "fifth",
      "octave",
      "fifth",
      "third",
      "root",
      "approach"
    ],
    tags: [
      "variation",
      "cascade",
      "bright"
    ]
  },
  {
    id: "BP_BOUNCY_RHYTHM",
    texture: "broken",
    steps: [
      "root",
      "root",
      "fifth",
      "fifth",
      "octave",
      "octave",
      "fifth",
      "approach"
    ],
    tags: [
      "variation",
      "playful",
      "bounce"
    ]
  },
  {
    id: "BP_BROKEN_SYNCO_JUMP",
    texture: "broken",
    steps: [
      "root",
      "rest",
      "octave",
      "root",
      "fifth",
      "rest",
      "octave",
      "root"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer",
      "syncopated",
      "default"
    ]
  },
  {
    id: "BP_BROKEN_GRID_PULSE",
    texture: "broken",
    steps: [
      "root",
      "root",
      "rest",
      "root",
      "octave",
      "root",
      "rest",
      "root"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer",
      "grid16"
    ]
  },
  {
    id: "BP_BROKEN_TEXTURE_WAVE",
    texture: "broken",
    steps: [
      "root",
      "octave",
      "fifth",
      "root",
      "root",
      "octave",
      "fifth",
      "approach"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer",
      "texture_loop"
    ]
  },
  {
    id: "BP_BROKEN_DOUBLE_HIT",
    texture: "broken",
    steps: [
      "root",
      "root",
      "octave",
      "octave",
      "fifth",
      "fifth",
      "octave",
      "root"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer"
    ]
  },
  {
    id: "BP_BROKEN_OFFBEAT_DRIVE",
    texture: "broken",
    steps: [
      "rest",
      "root",
      "rest",
      "octave",
      "rest",
      "fifth",
      "rest",
      "root"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer"
    ]
  },
  {
    id: "BP_BROKEN_SUB_BOUNCE",
    texture: "broken",
    steps: [
      "root",
      "lowFifth",
      "octave",
      "root",
      "root",
      "lowFifth",
      "octave",
      "root"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer",
      "static"
    ]
  },
  {
    id: "BP_BROKEN_LIFT_DROP",
    texture: "broken",
    steps: [
      "root",
      "fifth",
      "octave",
      "octaveHigh",
      "fifth",
      "root",
      "octave",
      "approach"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer",
      "variation"
    ]
  },
  {
    id: "BP_BROKEN_STEADY_GRID",
    texture: "broken",
    steps: [
      "root",
      "root",
      "root",
      "octave",
      "root",
      "root",
      "root",
      "octave"
    ],
    tags: [
      "loop_safe",
      "four_on_floor",
      "percussive_layer",
      "default"
    ]
  },
  {
    id: "BP_OVERWORLD_EIGHTH_LIFT",
    texture: "steady",
    steps: [
      "root",
      "fifth",
      "root",
      "octave",
      "root",
      "fifth",
      "octave",
      "approach"
    ],
    tags: [
      "loop_safe",
      "bright",
      "overworld",
      "variation"
    ]
  },
  {
    id: "BP_OVERWORLD_ROOT_SKIP",
    texture: "broken",
    steps: [
      "root",
      "rest",
      "fifth",
      "root",
      "octave",
      "rest",
      "fifth",
      "approach"
    ],
    tags: [
      "loop_safe",
      "bright",
      "syncopated",
      "overworld"
    ]
  },
  {
    id: "BP_BATTLE_OCTAVE_CHARGE",
    texture: "broken",
    steps: [
      "root",
      "octave",
      "root",
      "octave",
      "lowFifth",
      "octave",
      "fifth",
      "approach"
    ],
    tags: [
      "loop_safe",
      "tense",
      "energetic",
      "syncopated",
      "variation"
    ]
  },
  {
    id: "BP_BATTLE_LOW_GRIND",
    texture: "steady",
    steps: [
      "root",
      "lowFifth",
      "root",
      "rest",
      "root",
      "lowFifth",
      "fifth",
      "approach"
    ],
    tags: [
      "loop_safe",
      "tense",
      "percussive_layer",
      "breakbeat"
    ]
  },
  {
    id: "BP_PEACEFUL_PEDAL_AIR",
    texture: "steady",
    steps: [
      "root",
      "rest",
      "rest",
      "fifth",
      "root",
      "rest",
      "rest",
      "root"
    ],
    tags: [
      "loop_safe",
      "drone",
      "static",
      "rest_heavy",
      "peaceful"
    ]
  },
  {
    id: "BP_BREAKBEAT_OFFGRID_SUB",
    texture: "broken",
    steps: [
      "rest",
      "root",
      "lowFifth",
      "rest",
      "octave",
      "root",
      "rest",
      "approach"
    ],
    tags: [
      "loop_safe",
      "breakbeat",
      "syncopated",
      "percussive_layer",
      "variation",
      "pickup",
      "section_end"
    ]
  },
  {
    id: "BP_LOFI_DUST_PEDAL",
    texture: "steady",
    steps: [
      "root",
      "rest",
      "rest",
      "root",
      "rest",
      "fifth",
      "rest",
      "root"
    ],
    tags: [
      "loop_safe",
      "lofi",
      "rest_heavy",
      "swing_hint",
      "drone",
      "static"
    ]
  },
  {
    id: "BP_LOFI_STATIC_SKIP",
    texture: "broken",
    steps: [
      "root",
      "rest",
      "fifth",
      "rest",
      "root",
      "rest",
      "rest",
      "approach"
    ],
    tags: [
      "loop_safe",
      "lofi",
      "rest_heavy",
      "swing_hint",
      "variation"
    ]
  },
  {
    id: "BP_DRONE_SECTION_END",
    texture: "steady",
    steps: [
      "root",
      "rest",
      "root",
      "rest",
      "fifth",
      "rest",
      "root",
      "root"
    ],
    tags: [
      "loop_safe",
      "section_end",
      "drone",
      "static",
      "rest_heavy",
      "lofi"
    ]
  },
  {
    id: "BP_PICKUP_ROOT_SLIDE",
    texture: "broken",
    steps: [
      "rest",
      "approach",
      "root",
      "fifth",
      "rest",
      "octave",
      "fifth",
      "approach"
    ],
    tags: [
      "loop_safe",
      "pickup",
      "syncopated",
      "variation"
    ]
  },
  {
    id: "BP_BATTLE_SECTION_END",
    texture: "broken",
    steps: [
      "root",
      "octave",
      "lowFifth",
      "root",
      "fifth",
      "approach",
      "lowFifth",
      "root"
    ],
    tags: [
      "loop_safe",
      "section_end",
      "tense",
      "breakbeat",
      "percussive_layer"
    ]
  },
  {
    id: "BP_BREAKBEAT_PICKUP_CHOP",
    texture: "broken",
    steps: [
      "rest",
      "root",
      "rest",
      "octave",
      "lowFifth",
      "rest",
      "fifth",
      "approach"
    ],
    tags: [
      "loop_safe",
      "pickup",
      "breakbeat",
      "syncopated",
      "variation",
      "section_end"
    ]
  },
  {
    id: "BP_TENSE_PULSE",
    texture: "steady",
    steps: [
      "root",
      "rest",
      "root",
      "rest",
      "fifth",
      "rest",
      "root",
      "rest"
    ],
    tags: [
      "loop_safe",
      "tense",
      "percussive_layer",
      "syncopated"
    ]
  },
  {
    id: "BP_TENSE_SYNCOPATE",
    texture: "broken",
    steps: [
      "root",
      "fifth",
      "rest",
      "root",
      "rest",
      "lowFifth",
      "root",
      "approach"
    ],
    tags: [
      "loop_safe",
      "tense",
      "syncopated",
      "variation"
    ]
  },
  {
    id: "BP_TENSE_CHROMATIC_DESCENT",
    texture: "steady",
    steps: [
      "root",
      "seventh",
      "rest",
      "sixth",
      "fifth",
      "rest",
      "flatSecond",
      "root"
    ],
    tags: [
      "loop_safe",
      "tense",
      "chromatic",
      "dark"
    ]
  },
  {
    id: "BP_TENSE_OFFBEAT",
    texture: "broken",
    steps: [
      "rest",
      "root",
      "fifth",
      "rest",
      "root",
      "fifth",
      "rest",
      "approach"
    ],
    tags: [
      "loop_safe",
      "tense",
      "syncopated",
      "drive"
    ]
  },
  {
    id: "BP_ARPEGGIO_WAVE",
    texture: "arpeggio",
    steps: [
      "root",
      "fifth",
      "octave",
      "fifth",
      "root",
      "fifth",
      "octave",
      "approach"
    ],
    tags: [
      "loop_safe",
      "smooth"
    ]
  },
  {
    id: "BP_ARPEGGIO_STAIRS",
    texture: "arpeggio",
    steps: [
      "root",
      "octave",
      "octaveHigh",
      "octave",
      "root",
      "fifth",
      "octave",
      "approach"
    ],
    tags: [
      "loop_safe",
      "rising"
    ]
  },
  {
    id: "BP_ARPEGGIO_DIP",
    texture: "arpeggio",
    steps: [
      "root",
      "lowFifth",
      "root",
      "fifth",
      "octave",
      "fifth",
      "root",
      "approach"
    ],
    tags: [
      "loop_safe",
      "variation"
    ]
  },
  {
    id: "BP_ARPEGGIO_SYNC",
    texture: "arpeggio",
    steps: [
      "root",
      "rest",
      "fifth",
      "rest",
      "octave",
      "rest",
      "fifth",
      "approach"
    ],
    tags: [
      "syncopated",
      "sparse"
    ]
  },
  {
    id: "BP_ARPEGGIO_OCTAVE_BOUNCE",
    texture: "arpeggio",
    steps: [
      "root",
      "octave",
      "root",
      "octave",
      "root",
      "octaveHigh",
      "root",
      "approach"
    ],
    tags: [
      "loop_safe",
      "energetic"
    ]
  }
], Aa = {
  patterns: Pa
}, Oa = [
  {
    id: "TR_SECTION_NOISE_SWELL",
    pattern: "N---N---N---NNS-",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "noise_fx"
    ],
    channel: "noise"
  },
  {
    id: "TR_SECTION_SNARE_RUSH",
    pattern: "--S-S-S-S-S-S-S-",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOOP_TIGHTENER",
    pattern: "K-HS-HK-HS-HK-H-",
    length_beats: 4,
    tags: [
      "transition",
      "loop_out",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_SECTION_GHOST_ECHO",
    pattern: "N---S---N---S---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "loop_out",
      "noise_fx"
    ],
    channel: "noise"
  },
  {
    id: "TR_BUILD_STUTTER_FILL",
    pattern: "K-SK-SK-SK-SK-S-",
    length_beats: 4,
    tags: [
      "transition",
      "build",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_BREAKBEAT_SNARE_CHOP",
    pattern: "S--S-HS-S-HS-S--",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "break",
      "breakbeat",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOFI_TAPE_SWELL",
    pattern: "N---H---S---H---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "lofi",
      "noise_fx",
      "rest_heavy"
    ],
    channel: "noise"
  },
  {
    id: "TR_RETRO_TOM_LIFT",
    pattern: "T---H---T---S---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "drum_fill",
      "retro",
      "loop_out"
    ],
    channel: "noise"
  },
  {
    id: "TR_BREAKBEAT_CRUSH_FILL",
    pattern: "K-SHSHKTSH-SHSH-",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "breakbeat",
      "drum_fill",
      "grid16"
    ],
    channel: "noise"
  },
  {
    id: "TR_BUILD_NOISE_GATE",
    pattern: "N---N-H-N-S-N-H-",
    length_beats: 4,
    tags: [
      "transition",
      "build",
      "noise_fx",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOFI_DUST_DROP",
    pattern: "N-------S---H---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "lofi",
      "noise_fx",
      "rest_heavy",
      "loop_out"
    ],
    channel: "noise"
  },
  {
    id: "TR_RETRO_LOOP_BLIP",
    pattern: "K---H---T---H---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "retro",
      "texture_loop",
      "loop_out",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOFI_ROOM_BREATH",
    pattern: "N-------H---S---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "lofi",
      "noise_fx",
      "rest_heavy",
      "loop_out"
    ],
    channel: "noise"
  },
  {
    id: "TR_BREAKBEAT_GRID_THROW",
    pattern: "S-HSK-HSS-HSK-H-",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "breakbeat",
      "drum_fill",
      "grid16",
      "break"
    ],
    channel: "noise"
  },
  {
    id: "TR_BATTLE_GATE_RUSH",
    pattern: "K-S-N-S-K-S-N-S-",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "noise_fx",
      "drum_fill",
      "tense",
      "build"
    ],
    channel: "noise"
  },
  {
    id: "TR_PEACEFUL_DUST_TURN",
    pattern: "N-------S-------",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "lofi",
      "peaceful",
      "noise_fx",
      "rest_heavy"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOOP_FADE_HIT",
    pattern: "K---H---S---K---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "loop_out",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOOP_SNAP_FILL",
    pattern: "S---K-S-K-S-KSK-",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "loop_out",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOOP_TICK_DOWN",
    pattern: "H---T---H---T---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "loop_out",
      "retro"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOOP_CHOP_CUT",
    pattern: "S-HS-HK-HS-HKSH-",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "loop_out",
      "breakbeat",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOOP_HISS_HOLD",
    pattern: "N-------N---N---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "loop_out",
      "noise_fx"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOFI_VINYL_SKIP",
    pattern: "N-----------H---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "lofi",
      "noise_fx",
      "rest_heavy"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOFI_CRACKLE_DIP",
    pattern: "N---S---N---H---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "lofi",
      "noise_fx"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOFI_TAPE_HUM",
    pattern: "N-----------S---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "lofi",
      "noise_fx",
      "loop_out"
    ],
    channel: "noise"
  },
  {
    id: "TR_LOFI_DUST_TAIL",
    pattern: "S-----------S---",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "lofi",
      "rest_heavy"
    ],
    channel: "noise"
  },
  {
    id: "TR_BREAKBEAT_HAT_STUTTER",
    pattern: "H-HHSH-HH-HHSH--",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "breakbeat",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_BREAKBEAT_KICK_SCATTER",
    pattern: "K--KS-K--KS-K-S-",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "breakbeat",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_BREAKBEAT_ROLL_DOWN",
    pattern: "S-S-SHSHS-S-SHSH",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "breakbeat",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_BREAKBEAT_LOOP_CUT",
    pattern: "K-S-H-SK-S-H-SK-",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "breakbeat",
      "loop_out",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_BUILD_SNARE_RAMP",
    pattern: "--S----S--S-S-SS",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "build",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_BUILD_NOISE_LIFT",
    pattern: "N-------N---NNN-",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "build",
      "noise_fx"
    ],
    channel: "noise"
  },
  {
    id: "TR_BUILD_KICK_SWELL",
    pattern: "K-------K---K-K-",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "build",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_BUILD_HAT_STORM",
    pattern: "H---H-HHH-HHHHHH",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "build",
      "drum_fill"
    ],
    channel: "noise"
  },
  {
    id: "TR_BUILD_CRASH_GATE",
    pattern: "N-S-N-S-NSNSNSS-",
    length_beats: 4,
    tags: [
      "transition",
      "section_end",
      "build",
      "noise_fx"
    ],
    channel: "noise"
  }
], Ia = {
  transitions: Oa
}, Te = Ra;
new Map(Te.map((t) => [t.id, t]));
const Y = Ba, be = new Map(Y.map((t) => [t.id, t])), Se = Ea, We = new Map(Se.map((t) => [t.id, t])), w = Ta, Da = new Map(w.map((t) => [t.id, t])), Me = Aa.patterns ?? [], je = Me.reduce(
  (t, e) => {
    const a = t.get(e.texture) ?? [];
    return a.push(e), t.set(e.texture, a), t;
  },
  /* @__PURE__ */ new Map()
), Q = Ia.transitions ?? [];
function Pe(t) {
  switch (t) {
    case 2:
      return 2;
    case 4:
      return 1;
    case 8:
      return 0.5;
    case 16:
      return 0.25;
    default:
      return 0.25;
  }
}
function yt(t) {
  const e = t.pattern.map((a) => ({
    durationBeats: Pe(typeof a == "number" ? a : a.value)
  }));
  return bt(t.id, t.length, e), e;
}
function Fa(t) {
  const e = t.pattern.map((a) => ({
    durationBeats: Pe(a.value),
    rest: !!a.rest,
    accent: a.accent
  }));
  return bt(t.id, t.length, e), e;
}
function bt(t, e, a) {
  const s = a.reduce((n, o) => n + o.durationBeats, 0);
  if (Math.abs(s - e) > 1e-6)
    throw new Error(`${t} length mismatch. expected=${e}, got=${s}`);
}
const Ae = [
  "root",
  "root",
  "fifth",
  "root",
  "fifth",
  "root",
  "fifth",
  "approach"
], xa = {
  id: "BP_FALLBACK_STEADY",
  texture: "steady",
  steps: Ae,
  tags: ["fallback"]
}, Ca = {
  upbeat: ["straight", "syncopation"],
  sad: ["simple", "rest_heavy"],
  // "straight" removed: was shared with peaceful (79% overlap)
  tense: ["syncopation", "accented"],
  peaceful: ["open", "rest_heavy"]
  // "straight" removed: was shared with sad
}, Ha = {
  upbeat: ["bright", "ascending"],
  sad: ["descending", "legato"],
  // "dark" removed: was shared with tense (95% overlap)
  tense: ["leaping", "complex"],
  // "dark" removed: was shared with sad
  peaceful: ["simple", "arch", "bright"]
}, wa = {
  upbeat: ["syncopated", "drive"],
  sad: ["legato", "rest_heavy"],
  tense: ["syncopated", "staccato"],
  peaceful: ["legato", "simple"]
}, ka = {
  minimalTechno: {
    rhythm: ["texture_loop", "straight", "grid16"],
    melody: ["ostinato", "static", "short", "texture_loop"],
    melodyRhythm: ["texture_loop", "grid16", "simple"],
    bass: ["four_on_floor", "static", "drone", "loop_safe"],
    drumsBeat: ["four_on_floor", "texture_loop", "simple"],
    drumsFill: ["noise_fx", "transition"],
    transitions: ["build", "noise_fx"]
  },
  progressiveHouse: {
    rhythm: ["drive", "syncopation", "accented"],
    melody: ["ascending", "bright", "arch"],
    melodyRhythm: ["drive", "syncopated", "loop_safe"],
    bass: ["four_on_floor", "percussive_layer", "variation"],
    drumsBeat: ["four_on_floor", "percussive_layer", "grid16"],
    drumsFill: ["build", "drum_fill", "transition"],
    transitions: ["build", "drum_fill", "noise_fx"]
  },
  retroLoopwave: {
    rhythm: ["loop_safe", "grid16", "straight"],
    melody: ["bright", "ostinato", "texture_loop", "loop_safe"],
    melodyRhythm: ["loop_safe", "drive", "simple"],
    bass: ["bright", "overworld", "loop_safe"],
    drumsBeat: ["retro", "loop_safe", "grid16"],
    drumsFill: ["transition", "drum_fill"],
    transitions: ["retro", "loop_out", "drum_fill"]
  },
  breakbeatJungle: {
    rhythm: ["syncopation", "accented", "grid16"],
    melody: ["breakbeat", "complex", "leaping", "dark"],
    melodyRhythm: ["syncopated", "staccato", "breakbeat"],
    bass: ["breakbeat", "syncopated", "tense"],
    drumsBeat: ["breakbeat", "syncopation", "grid16"],
    drumsFill: ["break", "breakbeat", "drum_fill"],
    transitions: ["breakbeat", "drum_fill", "grid16"]
  },
  lofiChillhop: {
    rhythm: ["rest_heavy", "simple", "texture_loop"],
    melody: ["lofi", "peaceful", "stepwise", "simple"],
    melodyRhythm: ["rest_heavy", "legato", "simple"],
    bass: ["lofi", "rest_heavy", "drone", "static"],
    drumsBeat: ["lofi", "rest_heavy", "swing_hint"],
    drumsFill: ["lofi", "noise_fx", "rest_heavy"],
    transitions: ["lofi", "noise_fx", "rest_heavy"]
  }
};
function V(t, e) {
  var a;
  return t ? ((a = ka[t]) == null ? void 0 : a[e]) ?? [] : [];
}
const se = new Map(Te.map((t) => [t.id, t])), Ka = {
  dualBass: {
    preferBeatTags: ["percussive_layer", "syncopation"],
    preferFillTags: ["drum_fill", "build"]
  },
  bassLed: {
    preferBeatTags: ["four_on_floor", "drive"],
    preferFillTags: ["build"],
    earlySparseMeasures: 1
  },
  layeredBass: {
    preferBeatTags: ["four_on_floor", "loop_safe"],
    preferFillTags: ["drum_fill"]
  },
  minimal: {
    preferBeatTags: ["simple", "open"],
    preferFillTags: ["noise_fx"],
    avoidTags: ["build", "drive"],
    earlySparseMeasures: 2
  },
  breakLayered: {
    preferBeatTags: ["breakbeat", "percussive_layer", "grid16"],
    preferFillTags: ["break", "drum_fill", "breakbeat"],
    avoidTags: ["four_on_floor"]
  },
  lofiPadLead: {
    preferBeatTags: ["lofi", "rest_heavy", "swing_hint"],
    preferFillTags: ["noise_fx", "lofi"],
    avoidTags: ["breakbeat"],
    earlySparseMeasures: 2
  },
  retroPulse: {
    preferBeatTags: ["loop_safe", "grid16", "syncopation"],
    preferFillTags: ["build", "transition"],
    avoidTags: ["rest_heavy"]
  }
}, Na = {
  dualBass: {
    density: 0.85,
    velocityScale: 0.9,
    offbeatAccentBoost: 3
  },
  bassLed: {
    density: 0.6,
    sustainWholeMeasure: !1,
    offbeatAccentBoost: 5
  },
  layeredBass: {
    density: 0.75,
    velocityScale: 0.95
  },
  minimal: {
    density: 0.5,
    sustainWholeMeasure: !0,
    velocityScale: 0.8
  },
  breakLayered: {
    density: 0.95,
    velocityScale: 1.05,
    offbeatAccentBoost: 6
  },
  lofiPadLead: {
    density: 0.55,
    sustainWholeMeasure: !0,
    velocityScale: 0.7
  },
  retroPulse: {
    density: 0.78,
    velocityScale: 0.95,
    offbeatAccentBoost: 2
  }
};
function La() {
  return {
    candidatePools: [],
    fallbackCount: 0,
    hookReuse: {
      exact: 0,
      varied: 0
    },
    motifSequence: [],
    cacheEvents: [],
    melodyPitch: []
  };
}
function P(t, e, a, s, n, o, r, l, i, u) {
  t && (t.candidatePools.push({
    category: e,
    stage: a,
    requestedTags: [...s],
    beforeCount: n,
    matchedCount: o,
    afterCount: r,
    fallback: l,
    fallbackReason: i,
    selectedId: u
  }), l && (t.fallbackCount += 1));
}
function $(t, e, a, s, n) {
  const o = ve(t, e, a);
  return P(
    s,
    n,
    "selection",
    [],
    t.length,
    t.length,
    t.length,
    !1,
    void 0,
    o.id
  ), o;
}
function B(t, e, a, s, n, o = 0.4) {
  if (!e.length)
    return t;
  const r = t.filter((c) => {
    const d = c.tags ?? [];
    return e.some((h) => d.includes(h));
  });
  let l = r, i = !1, u;
  return r.length === 0 ? (l = t, i = !0, u = "empty_match") : t.length >= 4 && r.length < t.length * o && (l = t, i = !0, u = "min_ratio"), P(
    a,
    s,
    n,
    e,
    t.length,
    r.length,
    l.length,
    i,
    u
  ), l;
}
function Ye(t, e) {
  const a = [...t];
  for (let s = a.length - 1; s > 0; s--) {
    const n = Math.floor(e() * (s + 1)), o = a[s];
    a[s] = a[n], a[n] = o;
  }
  return a;
}
function St(t, e, a, s = 0.6) {
  if (!e.length || t.length <= 1)
    return t;
  const n = t.filter((d) => {
    const h = d.tags ?? [];
    return e.some((g) => h.includes(g));
  });
  if (!n.length || n.length === t.length)
    return t;
  const o = t.filter((d) => !n.includes(d)), r = Ye(n, a), l = Ye(o, a), i = Math.min(
    r.length,
    Math.max(1, Math.ceil(t.length * s))
  ), u = r.slice(0, i), c = [...r.slice(i), ...l];
  return [...u, ...c];
}
const ne = 1337;
function ge(t) {
  let e = (t ?? ne) >>> 0;
  return e === 0 && (e = ne), () => (e = e * 1664525 + 1013904223 >>> 0, e / 4294967295);
}
function ve(t, e, a) {
  if (!t.length)
    throw new Error("No candidates available for selection");
  if (t.length === 1)
    return t[0];
  let s = t[Math.floor(e() * t.length)];
  if (a && t.length > 1) {
    let n = 0;
    for (; (s == null ? void 0 : s.id) === a && n < 3; )
      s = t[Math.floor(e() * t.length)], n++;
  }
  return s;
}
function N(t, e) {
  return e.length ? e.every((a) => t.tags.includes(a)) : !0;
}
function Ga(t) {
  const a = t % M;
  return Math.abs(a % 2) < 1e-6;
}
function qa(t, e) {
  return e.find((a) => t >= a.startBeat && t < a.startBeat + a.durationBeats);
}
function Ua(t, e) {
  return t === 0 ? "start" : t === e - 1 ? "end" : "middle";
}
function Va(t) {
  try {
    return yt(t), !0;
  } catch {
    return !1;
  }
}
function Mt(t, e, a, s, n, o, r, l) {
  var f;
  const i = Te.filter(Va), u = Ca[t.mood] ?? [], c = e.lofiFeel ? [...u, "lofi", "swing_hint", "rest_heavy"] : u, d = (m, _) => m.filter((b) => _.some((S) => b.tags.includes(S))), h = i.filter((m) => N(m, n));
  let g = i.filter((m) => m.tags.includes(a));
  const v = d(g, c);
  if (P(
    l,
    "rhythm",
    "mood-property",
    c,
    g.length,
    v.length,
    v.length || g.length,
    c.length > 0 && v.length === 0,
    c.length > 0 && v.length === 0 ? "empty_match" : void 0
  ), v.length)
    g = v;
  else {
    const m = d(i, c);
    P(
      l,
      "rhythm",
      "mood-property-global-fallback",
      c,
      i.length,
      m.length,
      m.length || g.length,
      c.length > 0 && m.length === 0,
      c.length > 0 && m.length === 0 ? "empty_match" : void 0
    ), m.length && (g = m);
  }
  e.lofiFeel > 0.5 && (g = B(g, ["lofi", "swing_hint", "rest_heavy"], l, "rhythm", "lofiFeel", 0.25)), e.loopCentric > 0.5 && (g = B(g, ["loop_safe", "texture_loop"], l, "rhythm", "loopCentric")), e.syncopationBias > 0.5 && (g = B(g, ["syncopation"], l, "rhythm", "syncopationBias")), e.textureFocus > 0.5 && (g = B(g, ["texture_loop", "straight", "simple", "grid16"], l, "rhythm", "textureFocus")), e.percussiveLayering > 0.5 && (g = B(g, ["grid16", "percussive_layer"], l, "rhythm", "percussiveLayering"));
  const p = V(t.stylePreset, "rhythm");
  if (p.length && (g = B(g, p, l, "rhythm", "preset", 0.25)), g.length || (P(l, "rhythm", "empty-pool-fallback", [], 0, 0, i.length, !0, "empty_pool"), g = i), n.length) {
    const m = g.filter((_) => N(_, n));
    P(
      l,
      "rhythm",
      "required-tags",
      n,
      g.length,
      m.length,
      m.length || h.length || g.length,
      m.length === 0,
      m.length === 0 ? "empty_match" : void 0
    ), m.length ? g = m : h.length && (g = h);
  }
  if ((f = s == null ? void 0 : s.variations) != null && f.length) {
    const m = s.variations.map((_) => se.get(_)).filter((_) => !!_);
    if (m.length && o() < 0.5) {
      const _ = L(m, r);
      return $(_, o, s.id, l, "rhythm");
    }
  }
  const y = L(g, r);
  return $(y, o, s == null ? void 0 : s.id, l, "rhythm");
}
function ze(t, e, a, s, n, o, r) {
  const l = Ha[t.mood] ?? [];
  let i = Y.filter((d) => l.some((h) => d.tags.includes(h)));
  if (P(r, "melody", "mood", l, Y.length, i.length, i.length, i.length === 0, i.length === 0 ? "empty_match" : void 0), a.length) {
    const d = i.filter((h) => N(h, a));
    if (P(
      r,
      "melody",
      "required-tags",
      a,
      i.length,
      d.length,
      d.length || i.length,
      d.length === 0,
      d.length === 0 ? "empty_match" : void 0
    ), d.length)
      i = d;
    else {
      const h = Y.filter((g) => N(g, a));
      h.length && (i = h);
    }
  }
  i.length || (P(r, "melody", "empty-pool-fallback", [], 0, 0, Y.length, !0, "empty_pool"), i = Y), e.textureFocus > 0.5 && (i = B(i, ["texture_loop", "ostinato", "loop_safe", "short", "static"], r, "melody", "textureFocus")), e.harmonicStatic > 0.5 && (i = St(i, ["scalar", "stepwise", "static"], s, 0.6)), e.gradualBuild > 0.5 && (i = B(i, ["ascending"], r, "melody", "gradualBuild")), e.lofiFeel > 0.5 && (i = B(i, ["lofi", "simple", "peaceful"], r, "melody", "lofiFeel", 0.25));
  const u = V(t.stylePreset, "melody");
  u.length && (i = B(i, u, r, "melody", "preset", 0.25));
  const c = L(i, o);
  return $(c, s, n == null ? void 0 : n.id, r, "melody");
}
function Wa(t, e, a, s, n, o, r, l, i) {
  const c = wa[t.mood] ?? [], d = e.lofiFeel ? [...c, "lofi", "rest_heavy", "swing_hint"] : c;
  let h = Se.filter((f) => Math.abs(f.length - s) < 1e-6);
  if (P(i, "melodyRhythm", "length", [`length:${s}`], Se.length, h.length, h.length, h.length === 0, h.length === 0 ? "empty_match" : void 0), !h.length)
    throw new Error(`No melody rhythm motifs of length ${s}`);
  let g = h.filter((f) => f.tags.includes(a));
  P(i, "melodyRhythm", "function", [a], h.length, g.length, g.length || h.length, g.length === 0, g.length === 0 ? "empty_match" : void 0), g.length || (g = h);
  let v = g.filter((f) => d.some((m) => f.tags.includes(m)));
  P(i, "melodyRhythm", "mood", d, g.length, v.length, v.length || g.length, v.length === 0, v.length === 0 ? "empty_match" : void 0), v.length || (v = g), e.lofiFeel > 0.5 && (v = B(v, ["lofi", "swing_hint"], i, "melodyRhythm", "lofiFeel", 0.25)), e.loopCentric > 0.5 && (v = B(v, ["loop_safe", "texture_loop"], i, "melodyRhythm", "loopCentric")), e.syncopationBias > 0.5 && (v = B(v, ["syncopated", "drive"], i, "melodyRhythm", "syncopationBias")), e.textureFocus > 0.5 && (v = B(v, ["texture_loop", "grid16", "simple"], i, "melodyRhythm", "textureFocus"));
  const p = V(t.stylePreset, "melodyRhythm");
  if (p.length && (v = B(v, p, i, "melodyRhythm", "preset", 0.25)), n.length) {
    const f = v.filter((m) => N(m, n));
    P(i, "melodyRhythm", "required-tags", n, v.length, f.length, f.length || v.length, f.length === 0, f.length === 0 ? "empty_match" : void 0), f.length && (v = f);
  }
  v = us(v, s);
  const y = L(v, l);
  return $(y, o, r, i, "melodyRhythm");
}
function ja(t, e, a, s, n) {
  let r = {
    broken: 90,
    steady: 86,
    arpeggio: 92
  }[t.texture] ?? 88;
  const l = e === 0 ? 6 : 0, i = t.measures - e <= 1 ? 4 : 0;
  if (n.textureFocus > 0.5 && (r -= 8), n.gradualBuild > 0.5) {
    const u = s > 1 ? a / Math.max(1, s - 1) : 0, c = Math.min(1, Math.max(0, u)), d = s <= 16 ? 0.6 : s <= 32 ? 0.75 : 0.9, h = Math.pow(c, d), g = s <= 16 ? 14 : s <= 32 ? 18 : 20, v = Math.floor(h * g);
    r += v;
  }
  return n.loopCentric > 0.5 && (r = Math.max(60, r - 2)), Math.min(110, Math.max(58, r + l + i));
}
const Ya = {
  C_Major: 60,
  D_Major: 62,
  E_Minor: 64,
  F_Major: 65,
  G_Major: 67,
  A_Minor: 69,
  B_Minor: 71,
  C_Minor: 60,
  D_Minor: 62
};
function za(t, e, a, s, n, o) {
  const r = (Ya[t] ?? 60) + 12, l = {
    upbeat: 0,
    // Bright → standard to high (C5 base)
    peaceful: -3,
    // Peaceful → slightly lower (A4 base)
    tense: -5,
    // Tense → lower (G4 base, heavier feel)
    sad: -2
    // Sad → slightly lower (Bb4 base)
  }, i = {
    slow: -2,
    // Slow → lower
    medium: 0,
    // Standard
    fast: 2
    // Fast → higher (lighter, more agile)
  }, u = {
    minimalTechno: -4,
    progressiveHouse: 3,
    retroLoopwave: 2,
    breakbeatJungle: -2,
    lofiChillhop: -5
  }, c = (n.textureFocus ? 2 : 0) + (n.gradualBuild ? 1 : 0) + (n.loopCentric ? -1 : 0) + (n.atmosPad ? 2 : 0) + (n.percussiveLayering ? -2 : 0), d = l[e] ?? 0, h = i[a] ?? 0, g = s ? u[s] ?? 0 : 0, v = ge(o), p = Math.floor(v() * 7) - 3, y = r + d + h + g + c + p;
  return Math.max(62, Math.min(82, y));
}
function $a(t, e, a, s, n, o) {
  if (!t)
    return o;
  const r = {
    steady: 0,
    broken: -3,
    arpeggio: 4
  }, l = Math.max(0, e);
  let i = r[t.texture] ?? 0;
  if (n.textureFocus > 0.5 && (i -= 4), n.filterMotion > 0.5 && (i += 1), de(t) && l === 0 && (i += 3), x(t) && l === 0 && (i -= 2), n.gradualBuild > 0.5) {
    const v = a / Math.max(1, s - 1), p = Math.round(Math.pow(v, 0.7) * 8);
    i += p;
  }
  (t.measures > 0 ? l / t.measures : 0) >= 0.75 && (i -= 2);
  const c = Math.min(t.occurrenceIndex - 1, 2) * 2;
  i -= c, n.atmosPad > 0.5 && (i -= 1);
  const d = 60, h = 84, g = o + i;
  return Math.max(d, Math.min(h, g));
}
function Ja(t, e, a, s) {
  if (e <= 0)
    return;
  const n = e - 0.25;
  if (n < 0)
    return;
  const o = a.pattern, r = o[o.length - 1] ?? o[0] ?? 1;
  t.push({
    channelRole: "melody",
    startBeat: n,
    durationBeats: 0.25,
    degree: r,
    velocity: Ma.PICKUP_BASE,
    sectionId: s,
    motifId: a.id
  });
}
function Xa(t, e, a, s) {
  if (!e.length)
    return t;
  const n = [e[e.length - 1]], o = n[0] + (a.textureFocus ? 2 : 1), r = n[0] - (a.loopCentric ? 1 : 2), l = /* @__PURE__ */ new Set([t, n[0], o, r]), i = Array.from(l);
  return i[Math.floor(s() * i.length)];
}
function $e(t, e, a, s, n) {
  const o = t.variations ?? [];
  if (!o.length)
    return;
  const r = o.map((i) => se.get(i)).filter((i) => !!i).filter((i) => i.tags.includes(e) && N(i, a));
  if (!r.length)
    return;
  const l = L(r, n);
  return ve(l, s, t.id);
}
const Qa = ["start", "middle", "end", "cadence", "pickup"], Za = [
  "ascending",
  "descending",
  "arch",
  "valley",
  "stepwise",
  "leaping",
  "static",
  "sequence",
  "neighbor",
  "complex"
];
function Je(t, e, a) {
  return a.some((s) => t.tags.includes(s) && e.tags.includes(s));
}
function es(t, e) {
  return t.pattern.length === e.pattern.length && Je(t, e, Qa) && Je(t, e, Za);
}
function ts(t, e, a, s) {
  const n = t.variations ?? [];
  if (!n.length)
    return;
  const o = n.map((l) => be.get(l)).filter((l) => !!l).filter((l) => N(l, e)).filter((l) => es(t, l));
  if (!o.length)
    return;
  const r = L(o, s);
  return ve(r, a, t.id);
}
function as(t, e, a, s, n) {
  var u;
  const o = (u = n.steps) != null && u.length ? n.steps : Ae, r = [], l = k(a, 40), i = s ?? a;
  for (let c = 0; c < o.length; c++) {
    const d = e + c * 0.5, h = Et(o[c], a, i, l);
    h !== null && r.push({
      channelRole: "bass",
      startBeat: d,
      durationBeats: 0.5,
      degree: 0,
      velocity: Bt(t, c),
      sectionId: t.id,
      midiOverride: h
    });
  }
  return r;
}
function Rt(t, e, a, s, n, o, r, l, i) {
  const u = (l == null ? void 0 : l.enforceDroneStatic) ?? !0, c = (l == null ? void 0 : l.preferredTags) ?? [], d = e === t.measures - 1, h = n.get(t.id);
  if (h) {
    if (d && !(h.tags ?? []).includes("section_end")) {
      const p = j(
        t.texture,
        o,
        r,
        a,
        s,
        ["section_end"],
        h.id,
        i
      );
      if (p)
        return s.add(p.id), p;
    }
    return h;
  }
  if (o.harmonicStatic > 0.5) {
    if (!u && c.length) {
      const y = j(
        t.texture,
        o,
        r,
        a,
        s,
        c,
        void 0,
        i
      );
      if (y)
        return n.set(t.id, y), s.add(y.id), y;
    }
    const p = j(
      t.texture,
      o,
      r,
      a,
      s,
      ["drone", "static"],
      void 0,
      i
    );
    if (p && u)
      return n.set(t.id, p), s.add(p.id), p;
  }
  const g = de(t) ? ["pickup"] : [], v = j(t.texture, o, r, a, s, g, void 0, i) ?? j(t.texture, o, r, a, s, [], void 0, i) ?? xa;
  if (n.set(t.id, v), s.add(v.id), d && !(v.tags ?? []).includes("section_end")) {
    const p = j(
      t.texture,
      o,
      r,
      a,
      s,
      ["section_end"],
      v.id,
      i
    );
    if (p)
      return s.add(p.id), p;
  }
  return v;
}
function j(t, e, a, s, n, o, r, l) {
  let i = je.get(t) ?? [];
  if (P(l, "bass", "texture", [`texture:${t}`], Me.length, i.length, i.length, i.length === 0, i.length === 0 ? "empty_match" : void 0), !i.length && t !== "steady" && (i = je.get("steady") ?? [], P(l, "bass", "texture-steady-fallback", ["texture:steady"], Me.length, i.length, i.length, i.length === 0, i.length === 0 ? "empty_match" : void 0)), !i.length)
    return;
  (e.loopCentric || e.harmonicStatic) && (i = B(i, ["loop_safe"], l, "bass", "loopCentricOrHarmonicStatic")), e.syncopationBias > 0.5 && (i = B(i, ["syncopated"], l, "bass", "syncopationBias")), e.textureFocus > 0.5 && (i = B(i, ["default"], l, "bass", "textureFocus")), e.percussiveLayering > 0.5 && (i = B(i, ["percussive_layer", "four_on_floor"], l, "bass", "percussiveLayering")), e.percussiveLayering && e.syncopationBias && e.breakInsertion && (i = B(i, ["breakbeat", "variation"], l, "bass", "breakbeatFocus", 0.2)), (e.lofiFeel || e.atmosPad && e.loopCentric) && (i = B(i, ["lofi", "rest_heavy"], l, "bass", "lofiPad", 0.25)), e.harmonicStatic > 0.5 && (i = St(i, ["drone", "static"], s, 0.65));
  const u = V(a, "bass");
  if (u.length && (i = B(i, u, l, "bass", "preset", 0.25)), o.length) {
    const d = i.filter(
      (h) => o.every((g) => (h.tags ?? []).includes(g))
    );
    P(l, "bass", "required-tags", o, i.length, d.length, d.length || i.length, d.length === 0, d.length === 0 ? "empty_match" : void 0), d.length && (i = d);
  }
  if (!i.length)
    return;
  const c = L(i, n);
  return $(c, s, r, l, "bass");
}
function ss(t, e) {
  const s = [];
  for (const n of e) {
    let o = n.startBeat, r = 0;
    const l = 4;
    for (; r < l && t.some(
      (u) => Math.abs(u.startBeat - o) < 0.0625
    ); )
      r++, o = n.startBeat + r * 0.0625;
    s.push({
      ...n,
      startBeat: o
    });
  }
  return s;
}
function ns(t, e, a, s, n, o, r, l, i, u, c) {
  if (!Q.length)
    return;
  const d = ["transition", "section_end"];
  a && d.push("loop_out");
  let h = Q.filter((b) => b.length_beats <= M);
  P(c, "transitions", "length", ["length<=measure"], Q.length, h.length, h.length || Q.length, h.length === 0, h.length === 0 ? "empty_match" : void 0), h.length || (h = Q);
  const g = u > 1 ? i / Math.max(1, u - 1) : 0, v = [];
  r.gradualBuild > 0.5 && (g < 0.4 ? v.push("build") : g < 0.8 ? v.push("drum_fill") : v.push("loop_out")), r.breakInsertion && g >= 0.5 && v.push("noise_fx"), r.percussiveLayering > 0.5 && v.push("drum_fill"), v.length && (h = B(h, v, c, "transitions", "priority-tags", 0.2));
  const p = V(l, "transitions");
  if (p.length && (h = B(h, p, c, "transitions", "preset", 0.2)), d.length) {
    const b = h.filter((S) => N(S, d));
    P(c, "transitions", "required-tags", d, h.length, b.length, b.length || h.length, b.length === 0, b.length === 0 ? "empty_match" : void 0), b.length && (h = b);
  }
  if (!h.length)
    return;
  const y = L(h, o), f = ve(y, s, n);
  if (!f)
    return;
  const m = f.length_beats >= M ? e : e + Math.max(0, M - f.length_beats), _ = _t(f.pattern, m, t.id);
  return { motifId: f.id, hits: _ };
}
function Bt(t, e) {
  const a = qe[t.texture] ?? qe.default;
  return e === 0 ? a + Ue.DOWNBEAT_BOOST : e % 4 === 0 ? a + Ue.STRONG_BEAT_BOOST : a;
}
function Et(t, e, a, s) {
  switch (t) {
    case "root":
      return I(s, e);
    case "fifth":
      return I(s + 7, e);
    case "lowFifth":
      return I(s - 5, e);
    case "octave":
      return I(s + 12, e);
    case "octaveHigh":
      return I(s + 19, e);
    case "approach": {
      const n = k(a, s + 5);
      return I(n - 1, a);
    }
    case "rest":
      return null;
    default:
      return I(s, e);
  }
}
function rs(t, e, a) {
  if (t === "steady") {
    const s = [1, 5];
    return s[Math.floor(a / 2) % s.length];
  } else {
    const s = [1, 3, 5, 7];
    return s[e % s.length];
  }
}
function os(t, e) {
  return 58 + (t === "start" && e === 0 ? 6 : 0);
}
function is(t, e, a, s, n, o, r) {
  const l = [], i = yt(a);
  let u = 0, c = 0;
  const d = Na[o];
  for (let h = 0; h < i.length; h++) {
    const g = i[h];
    if (u >= M) break;
    const v = M - u, p = Math.min(g.durationBeats, v), y = rs(
      t.texture,
      c,
      u
    ), f = u % 1 > 1e-6;
    let m = os(n, u);
    if (d != null && d.velocityScale && (m = Math.round(m * d.velocityScale)), f && (d != null && d.offbeatAccentBoost) && (m += d.offbeatAccentBoost), (d == null ? void 0 : d.density) !== void 0 && d.density < 1) {
      const _ = Math.max(0, Math.min(1, d.density));
      if (r() > _) {
        u += p, c++;
        continue;
      }
    }
    if (l.push({
      channelRole: "accompaniment",
      startBeat: e + u,
      durationBeats: p,
      degree: y,
      velocity: m,
      sectionId: t.id
    }), u += p, c++, u >= M) break;
  }
  if (n === "start" && de(t) && s.pattern.length && e >= 0.5 && !((d == null ? void 0 : d.density) !== void 0 && d.density < 0.5)) {
    const h = s.pattern[0];
    l.push({
      channelRole: "accompaniment",
      startBeat: Math.max(0, e - 0.5),
      durationBeats: 0.5,
      degree: h,
      velocity: K.EARLY_START,
      sectionId: t.id
    });
  }
  if (d != null && d.sustainWholeMeasure && l.length) {
    const h = l[0].degree, g = Math.max(
      K.PAD_MIN,
      Math.round(l.reduce((v, p) => v + p.velocity, 0) / l.length)
    );
    return [
      {
        channelRole: "accompaniment",
        startBeat: e,
        durationBeats: M,
        degree: h,
        velocity: g,
        sectionId: t.id
      }
    ];
  }
  return l;
}
function ls(t, e) {
  const a = t.pattern ?? [];
  if (!a.length)
    return !1;
  const s = e >= 4 ? 0.25 : 0;
  let n = 0, o = !1, r = 0;
  for (const l of a) {
    const i = Pe(l.value);
    if (l.rest) {
      n += i, r = 0;
      continue;
    }
    if (i >= 0.5) {
      o = !0, r = 0;
      continue;
    }
    if (r += i, r > 1 + 1e-6)
      return !1;
  }
  return n >= s ? !0 : o;
}
function us(t, e) {
  const a = t.filter((s) => ls(s, e));
  return a.length ? a : t;
}
function Oe(t, e, a) {
  t.has(e) || t.set(e, /* @__PURE__ */ new Map());
  const s = t.get(e);
  return s.has(a) || s.set(a, {}), s.get(a);
}
function Ie(t, e) {
  return (e == null ? void 0 : e.templateCacheScope) === "section" ? t.id : t.templateId;
}
function cs(t, e, a, s) {
  const n = t.get(e);
  if (!(!n || n.size === 0))
    return n.get(1);
}
function ds(t, e, a, s) {
  t.has(e) || t.set(e, /* @__PURE__ */ new Map());
  const n = t.get(e);
  a === 1 && n.set(a, s);
}
function ps(t, e) {
  const a = ge(t.seed), s = t.seed ?? Date.now(), n = za(
    e.key,
    t.mood,
    t.tempo,
    t.stylePreset,
    e.styleIntent,
    s
  );
  return {
    rng: a,
    compositionBaseRegister: n,
    sectionById: new Map(e.sections.map((o) => [o.id, o])),
    styleIntent: e.styleIntent,
    stylePreset: t.stylePreset,
    voiceArrangement: e.voiceArrangement,
    totalMeasures: t.lengthInMeasures,
    motifSelectionDiagnostics: La(),
    experiments: t.experiments,
    usedMotifs: {
      rhythms: /* @__PURE__ */ new Set(),
      melodies: /* @__PURE__ */ new Set(),
      drums: /* @__PURE__ */ new Set(),
      melodyRhythms: /* @__PURE__ */ new Set(),
      bassPatterns: /* @__PURE__ */ new Set(),
      transitions: /* @__PURE__ */ new Set()
    },
    caches: {
      template: /* @__PURE__ */ new Map(),
      hook: /* @__PURE__ */ new Map(),
      bassPattern: /* @__PURE__ */ new Map()
    },
    lastMotifs: {},
    motifUsage: {
      rhythm: {},
      melody: {},
      drums: {},
      melodyRhythm: {},
      bass: {},
      transitions: {}
    }
  };
}
function hs(t, e, a, s, n) {
  t.startMeasure * M;
  const o = Math.max(1, mt(t));
  let r = 0;
  for (; r < t.measures; ) {
    const l = Math.min(o, t.measures - r), i = r === 0, u = t.startMeasure + r, c = gs(
      t,
      e,
      a,
      l,
      i,
      u,
      s,
      n
    );
    vs(c, e, a, s, n), r += l;
  }
}
function gs(t, e, a, s, n, o, r, l) {
  var C;
  const i = cs(
    r.caches.hook,
    t.templateId,
    t.occurrenceIndex,
    r.rng
  ), u = o - t.startMeasure, c = Math.floor(
    u / Math.max(1, mt(t))
  ), d = u + s >= t.measures, h = u === 0 ? "start" : d ? "end" : "middle", g = [];
  o === r.totalMeasures - 1 ? g.push("loop_safe") : o === r.totalMeasures - 2 && !(x(t) && n) && g.push("cadence");
  let v, p, y, f = "new_selection", m = "new_selection", _ = "new_selection";
  const b = le(h, g);
  le(h, g);
  const S = Oe(
    r.caches.template,
    Ie(t, a.experiments),
    b
  );
  if (x(t) && n && i) {
    const E = se.get(i.rhythmId), A = be.get(i.melodyId);
    E && (v = E, f = "hook_reuse"), A && (p = A, m = "hook_reuse");
  }
  if (!v) {
    const E = S.rhythm;
    v = E ? se.get(E) : void 0, v && (f = "template_cache"), v || (v = Mt(
      a,
      r.styleIntent,
      h,
      r.lastMotifs.rhythm,
      g,
      r.rng,
      r.usedMotifs.rhythms,
      r.motifSelectionDiagnostics
    ), S.rhythm = v.id);
  }
  if (!p) {
    const A = ((C = a.experiments) == null ? void 0 : C.varyNonInitialPhraseMelody) === !0 && !n && !x(t) ? void 0 : S.melody;
    p = A ? be.get(A) : void 0, p && (m = "template_cache"), p || (p = ze(
      a,
      r.styleIntent,
      g,
      r.rng,
      r.lastMotifs.melodyFragment,
      r.usedMotifs.melodies,
      r.motifSelectionDiagnostics
    ), S.melody = p.id);
  }
  let T;
  const F = a.sectionRepeatBias ?? ie;
  if (x(t) && n && !!i && F < 0.25 && r.rng() > F) {
    const E = ts(
      p,
      g,
      r.rng,
      r.usedMotifs.melodies
    ), A = E ?? ze(
      a,
      r.styleIntent,
      g,
      r.rng,
      p,
      r.usedMotifs.melodies,
      r.motifSelectionDiagnostics
    );
    A.id !== p.id && (T = E ? "melody_variation" : "fallback", p = A, m = "variation");
  }
  if (x(t) && n && i) {
    const E = We.get(i.melodyRhythmId);
    E && (y = E, _ = "hook_reuse");
  }
  if (!y) {
    const E = S.melodyRhythm;
    y = E ? We.get(E) : void 0, y && (_ = "template_cache"), y || (y = Wa(
      a,
      r.styleIntent,
      h,
      s * M,
      g,
      r.rng,
      void 0,
      r.usedMotifs.melodyRhythms,
      r.motifSelectionDiagnostics
    ), S.melodyRhythm = y.id);
  }
  if (de(t) && n && ds(r.caches.hook, t.templateId, t.occurrenceIndex, {
    rhythmId: v.id,
    melodyId: p.id,
    melodyRhythmId: y.id
  }), r.usedMotifs.rhythms.add(v.id), r.usedMotifs.melodies.add(p.id), r.usedMotifs.melodyRhythms.add(y.id), r.motifSelectionDiagnostics.cacheEvents.push(
    { sectionId: t.id, phraseIndex: c, category: "rhythm", motifId: v.id, source: f },
    { sectionId: t.id, phraseIndex: c, category: "melody", motifId: p.id, source: m },
    { sectionId: t.id, phraseIndex: c, category: "melodyRhythm", motifId: y.id, source: _ }
  ), r.motifUsage.melody[p.id] = (r.motifUsage.melody[p.id] ?? 0) + 1, r.motifUsage.melodyRhythm[y.id] = (r.motifUsage.melodyRhythm[y.id] ?? 0) + 1, n) {
    const E = x(t) && !!i && (i == null ? void 0 : i.rhythmId) === v.id && (i == null ? void 0 : i.melodyId) === p.id && (i == null ? void 0 : i.melodyRhythmId) === y.id, A = x(t) && !!i && !E;
    E ? r.motifSelectionDiagnostics.hookReuse.exact += 1 : A && (r.motifSelectionDiagnostics.hookReuse.varied += 1), l.sectionMotifPlan.push({
      sectionId: t.id,
      templateId: t.templateId,
      occurrenceIndex: t.occurrenceIndex,
      primaryRhythm: v.id,
      primaryMelody: p.id,
      primaryMelodyRhythm: y.id,
      reprisesHook: E,
      hookReuse: E ? "exact" : A ? "varied" : "none",
      hookVariationSource: T,
      hookOriginalMelody: A ? i == null ? void 0 : i.melodyId : void 0
    });
  }
  return {
    section: t,
    phraseMeasures: s,
    isFirstPhrase: n,
    phraseStartMeasureIndex: o,
    phraseIndex: c,
    cachedHook: i,
    baseRhythm: v,
    baseMelody: p,
    baseMelodyRhythm: y
  };
}
function vs(t, e, a, s, n) {
  const { section: o, phraseMeasures: r, isFirstPhrase: l, baseMelody: i, baseMelodyRhythm: u } = t;
  o.startMeasure * M;
  const c = Fa(u);
  let d = 0, h = 0, g = 0;
  for (let v = 0; v < r; v++) {
    const p = ms(
      t,
      v,
      a,
      s
    );
    l && v === 0 && Ja(n.melody, p.measureStartBeat, i, o.id), fs(
      p,
      c,
      i,
      o,
      s,
      n.melody,
      { phraseBeatCursor: d, phraseStepIndex: h, melodyDegreeCursor: g }
    );
    const y = (v + 1) * M;
    for (; h < c.length && d < y; ) {
      const _ = c[h];
      _.rest || g++, d += _.durationBeats, h++;
    }
    const f = _s(p, e, o, s, n.bass);
    ys(
      p,
      i,
      o,
      s,
      n.accompanimentSeeds
    );
    const m = bs(
      p,
      o,
      s,
      n.drums
    );
    s.motifSelectionDiagnostics.motifSequence.push({
      sectionId: o.id,
      templateId: o.templateId,
      occurrenceIndex: o.occurrenceIndex,
      phraseIndex: t.phraseIndex,
      measureIndex: p.globalMeasureIndex,
      measureInSection: p.measureInSection,
      texture: o.texture,
      chord: D(e, p.measureStartBeat),
      rhythm: p.rhythmMotif.id,
      melody: i.id,
      melodyRhythm: u.id,
      bass: f,
      drums: m
    }), s.lastMotifs.rhythm = p.rhythmMotif, s.lastMotifs.melodyFragment = i;
  }
}
function ms(t, e, a, s) {
  const { section: n, isFirstPhrase: o, baseRhythm: r } = t, l = t.phraseStartMeasureIndex - n.startMeasure + e, i = n.startMeasure + l, u = n.startMeasure * M + l * M, c = Ua(l, n.measures), d = [], h = x(n) && l === 0;
  i === s.totalMeasures - 1 ? d.push("loop_safe") : i === s.totalMeasures - 2 && !h && d.push("cadence");
  const g = le(c, d), v = Oe(
    s.caches.template,
    Ie(n, a.experiments),
    g
  ), p = a.sectionRepeatBias ?? ie, y = e > 0 || !o || n.occurrenceIndex > 1, f = !x(n) && y && s.rng() > p;
  let m = v.rhythm ? se.get(v.rhythm) : void 0, _ = m ? "template_cache" : "base_reuse";
  if (m) {
    if (f && m.id === r.id) {
      const b = $e(r, c, d, s.rng, s.usedMotifs.rhythms);
      b && (m = b, _ = "variation");
    }
  } else if (f) {
    const b = $e(r, c, d, s.rng, s.usedMotifs.rhythms);
    m = b ?? r, b && (_ = "variation");
  } else
    m = r;
  return (!m.tags.includes(c) || !N(m, d)) && (m = Mt(
    a,
    s.styleIntent,
    c,
    r,
    d,
    s.rng,
    s.usedMotifs.rhythms,
    s.motifSelectionDiagnostics
  ), _ = "new_selection"), v.rhythm = m.id, s.motifUsage.rhythm[m.id] = (s.motifUsage.rhythm[m.id] ?? 0) + 1, s.usedMotifs.rhythms.add(m.id), s.motifSelectionDiagnostics.cacheEvents.push({
    sectionId: n.id,
    phraseIndex: t.phraseIndex,
    measureIndex: i,
    category: "rhythm",
    motifId: m.id,
    source: _
  }), {
    measureInSection: l,
    globalMeasureIndex: i,
    measureStartBeat: u,
    functionTag: c,
    requiredTags: d,
    isHookMeasure: h,
    phraseOffset: e,
    phraseIndex: t.phraseIndex,
    rhythmMotif: m
  };
}
function fs(t, e, a, s, n, o, r) {
  const { measureStartBeat: l, measureInSection: i, globalMeasureIndex: u, phraseOffset: c } = t, d = (c + 1) * M;
  for (; r.phraseStepIndex < e.length && r.phraseBeatCursor < d; ) {
    const h = e[r.phraseStepIndex], g = r.phraseBeatCursor - c * M;
    if (!h.rest) {
      let v = a.pattern[r.melodyDegreeCursor % a.pattern.length];
      r.phraseStepIndex === e.length - 1 && (s.occurrenceIndex > 1 || i > 0) && !x(s) && (v = Xa(v, a.pattern, n.styleIntent, n.rng));
      let y = ja(
        s,
        i,
        u,
        n.totalMeasures,
        n.styleIntent
      );
      o.push({
        channelRole: "melody",
        startBeat: l + g,
        durationBeats: h.durationBeats,
        degree: v,
        velocity: y,
        sectionId: s.id,
        motifId: a.id
      }), r.melodyDegreeCursor++;
    }
    r.phraseBeatCursor += h.durationBeats, r.phraseStepIndex++;
  }
}
function _s(t, e, a, s, n) {
  const { measureStartBeat: o, measureInSection: r } = t;
  let l = s.caches.bassPattern.get(a.id);
  const i = l ? "template_cache" : "new_selection";
  l || (l = Rt(
    a,
    r,
    s.rng,
    s.usedMotifs.bassPatterns,
    s.caches.bassPattern,
    s.styleIntent,
    s.stylePreset,
    void 0,
    s.motifSelectionDiagnostics
  ), s.caches.bassPattern.set(a.id, l)), s.motifUsage.bass[l.id] = (s.motifUsage.bass[l.id] ?? 0) + 1, s.usedMotifs.bassPatterns.add(l.id), s.motifSelectionDiagnostics.cacheEvents.push({
    sectionId: a.id,
    phraseIndex: t.phraseIndex,
    measureIndex: t.globalMeasureIndex,
    category: "bass",
    motifId: l.id,
    source: i
  });
  const u = D(e, o), c = D(e, o + M);
  return n.push(
    ...as(
      a,
      o,
      u,
      c,
      l
    )
  ), l.id;
}
function ys(t, e, a, s, n) {
  const { measureStartBeat: o, rhythmMotif: r, functionTag: l } = t;
  n.push(
    ...is(
      a,
      o,
      r,
      e,
      l,
      s.voiceArrangement.id,
      s.rng
    )
  );
}
function bs(t, e, a, s) {
  var g;
  const { measureStartBeat: n, measureInSection: o, requiredTags: r } = t, l = o === e.measures - 1, i = l || e.measures > 2 && o === e.measures - 2, u = le(`${o}:${i ? "fill" : "beat"}`, r), c = Oe(
    a.caches.template,
    Ie(e, a.experiments),
    u
  );
  let d = c.drum ? Da.get(c.drum) : void 0;
  const h = d ? "template_cache" : "new_selection";
  if (d || (d = Ts(
    o,
    e.measures,
    r,
    a.rng,
    a.lastMotifs.drumPatternId,
    a.usedMotifs.drums,
    i,
    a.styleIntent,
    a.stylePreset,
    a.voiceArrangement.id,
    a.motifSelectionDiagnostics
  ), d && (c.drum = d.id)), d && (a.motifUsage.drums[d.id] = (a.motifUsage.drums[d.id] ?? 0) + 1, a.usedMotifs.drums.add(d.id), s.push(..._t(d.pattern, n, e.id)), a.lastMotifs.drumPatternId = d.id, a.motifSelectionDiagnostics.cacheEvents.push({
    sectionId: e.id,
    phraseIndex: t.phraseIndex,
    measureIndex: t.globalMeasureIndex,
    category: "drums",
    motifId: d.id,
    source: h
  })), l) {
    const v = e.id === ((g = a.sectionById.get(Array.from(a.sectionById.keys()).pop())) == null ? void 0 : g.id), p = ns(
      e,
      n,
      v,
      a.rng,
      a.lastMotifs.transitionId,
      a.usedMotifs.transitions,
      a.styleIntent,
      a.stylePreset,
      e.startMeasure + o,
      a.totalMeasures,
      a.motifSelectionDiagnostics
    );
    p && (a.motifUsage.transitions[p.motifId] = (a.motifUsage.transitions[p.motifId] ?? 0) + 1, a.usedMotifs.transitions.add(p.motifId), s.push(...ss(s, p.hits)), a.lastMotifs.transitionId = p.motifId);
  }
  return d == null ? void 0 : d.id;
}
function Ss(t, e, a) {
  return t.map((s) => {
    var h;
    const n = a.sectionById.get(s.sectionId), o = Math.floor(s.startBeat / M), r = n ? o - n.startMeasure : 0, l = $a(
      n,
      r,
      o,
      a.totalMeasures,
      a.styleIntent,
      a.compositionBaseRegister
    ), i = he(s.degree, e.scaleDegrees, l), u = D(e, s.startBeat), c = Ga(s.startBeat), d = c ? I(i, u) : ((h = a.experiments) == null ? void 0 : h.weakBeatQuantization) === "scale" ? i : ae(i, u);
    return a.motifSelectionDiagnostics.melodyPitch.push({
      sectionId: s.sectionId,
      measureIndex: o,
      startBeat: s.startBeat,
      durationBeats: s.durationBeats,
      motifId: s.motifId,
      degree: s.degree,
      scaleMidi: i,
      correctedMidi: d,
      velocity: s.velocity,
      strongBeat: c,
      changed: i !== d
    }), { ...s, midi: d };
  });
}
function Ms(t, e, a, s) {
  const n = s - 5;
  return t.map((o) => {
    const r = he(o.degree, e.scaleDegrees, n), l = D(e, o.startBeat), i = qa(o.startBeat, a), u = ae(r, l, i == null ? void 0 : i.midi);
    return { ...o, midi: u };
  });
}
function Rs(t, e) {
  return t.map((a) => {
    const n = a.midiOverride ?? he(a.degree, e.scaleDegrees, 52, -1), o = D(e, a.startBeat), r = I(n, o);
    return { ...a, midi: r };
  });
}
function Bs(t, e) {
  const a = ps(t, e), s = {
    melody: [],
    bass: [],
    accompanimentSeeds: [],
    drums: [],
    sectionMotifPlan: []
  };
  for (const l of e.sections)
    hs(l, e, t, a, s);
  const n = Ss(s.melody, e, a), o = Rs(s.bass, e), r = Ms(s.accompanimentSeeds, e, n, a.compositionBaseRegister);
  return {
    melody: n,
    bass: o,
    accompanimentSeeds: r,
    drums: s.drums,
    motifUsage: a.motifUsage,
    sectionMotifPlan: s.sectionMotifPlan,
    motifSelection: a.motifSelectionDiagnostics
  };
}
function Es(t, e) {
  const { voiceArrangement: a } = e, s = t.seed ?? ne, n = Bs(t, e);
  if (a.id === "standard" || a.id === "swapped")
    return {
      tracks: [
        { role: "melody", notes: n.melody },
        { role: "bass", notes: n.bass },
        { role: "accompaniment", notes: n.accompanimentSeeds }
      ],
      drums: n.drums,
      motifUsage: n.motifUsage,
      sectionMotifPlan: n.sectionMotifPlan,
      motifSelection: n.motifSelection
    };
  const o = [];
  for (const r of a.voices) {
    let l;
    switch (r.role) {
      case "bass":
      case "bassAlt":
        l = Os(
          r.role,
          r.priority,
          r.octaveOffset ?? 0,
          r.seedOffset ?? 0,
          t,
          e,
          n.motifUsage.bass,
          n.motifSelection
        );
        break;
      case "pad":
        l = Is(
          r.priority,
          t,
          e,
          s + (r.seedOffset ?? 0)
        );
        break;
      case "melody":
      case "melodyAlt":
      case "accompaniment":
        if (r.role === "melody" && a.id === "minimal")
          continue;
        r.role === "melody" ? l = n.melody : l = n.accompanimentSeeds;
        break;
      default:
        l = [];
    }
    const i = l.map((u) => {
      let c, d = u.velocity;
      if ((u.channelRole === "bass" || r.role === "bass" || r.role === "bassAlt") && u.midiOverride !== void 0)
        c = u.midiOverride;
      else {
        Math.floor(u.startBeat / M);
        const h = r.role === "melody" || r.role === "melodyAlt" ? 72 : 67, g = he(u.degree, e.scaleDegrees, h), v = D(e, u.startBeat);
        c = I(g, v), r.octaveOffset && (c += r.octaveOffset * 12);
      }
      return a.id === "layeredBass" && (r.role === "bass" ? d = Math.max(28, Math.round(d * 0.65)) : r.role === "bassAlt" && (d = Math.max(22, Math.round(d * 0.5)))), { ...u, midi: c, velocity: d };
    });
    i.length > 0 && o.push({ role: r.role, notes: i });
  }
  return {
    tracks: o,
    drums: n.drums,
    motifUsage: n.motifUsage,
    sectionMotifPlan: n.sectionMotifPlan,
    motifSelection: n.motifSelection
  };
}
function Ts(t, e, a, s, n, o, r, l, i, u, c) {
  var S, T, F;
  const d = Ka[u];
  if (!r && (d != null && d.earlySparseMeasures) && t < d.earlySparseMeasures && s() < 0.3)
    return;
  if (l.gradualBuild && e >= 8) {
    const R = t / Math.max(1, e - 1), C = Math.min(0.35, 6 / Math.max(1, e)), E = Math.min(0.7, 14 / Math.max(1, e));
    if (R < C) {
      if (s() < 0.75)
        return;
    } else if (R < E && s() < 0.35)
      return;
  }
  const h = l.breakInsertion ? 2 : 4, g = h > 0 && e >= h && (t + 1) % h === 0, v = r || g;
  let p = w.filter(
    (R) => v ? R.type === "fill" : R.type === "beat"
  );
  P(c, "drums", "type", [v ? "fill" : "beat"], w.length, p.length, p.length, p.length === 0, p.length === 0 ? "empty_match" : void 0);
  const y = p.filter((R) => R.length_beats <= M);
  if (P(c, "drums", "length", ["length<=measure"], p.length, y.length, y.length || p.length, y.length === 0, y.length === 0 ? "empty_match" : void 0), y.length && (p = y), a.length) {
    const R = p.filter((C) => {
      const E = C.tags;
      return E ? a.every((A) => E.includes(A)) : !1;
    });
    P(c, "drums", "required-tags", a, p.length, R.length, R.length || p.length, R.length === 0, R.length === 0 ? "empty_match" : void 0), R.length && (p = R);
  }
  p.length || (P(c, "drums", "type-fallback", [v ? "fill" : "beat"], w.length, w.filter((R) => v ? R.type === "fill" : R.type === "beat").length, w.filter((R) => v ? R.type === "fill" : R.type === "beat").length, !0, "empty_pool"), p = w.filter((R) => v ? R.type === "fill" : R.type === "beat")), p.length || (P(c, "drums", "global-fallback", [], 0, 0, w.length, !0, "empty_pool"), p = w);
  const f = l.percussiveLayering && l.syncopationBias && l.breakInsertion && !l.loopCentric, m = l.atmosPad && l.loopCentric && l.harmonicStatic, _ = l.loopCentric && l.textureFocus && l.percussiveLayering;
  if (v) {
    (T = d == null ? void 0 : d.preferFillTags) != null && T.length && (p = B(p, d.preferFillTags, c, "drums", "arrangementFillTags", 0.25));
    const R = V(i, "drumsFill");
    R.length && (p = B(p, R, c, "drums", "presetFillTags", 0.25));
  } else {
    l.loopCentric > 0.5 && (p = B(p, ["loop_safe"], c, "drums", "loopCentric")), l.syncopationBias > 0.5 && (p = B(p, f ? ["breakbeat", "syncopation", "grid16"] : ["syncopation"], c, "drums", "syncopationBias")), l.textureFocus > 0.5 && (p = B(p, ["texture_loop", "straight", "grid16"], c, "drums", "textureFocus")), l.percussiveLayering > 0.5 && (p = B(p, f ? ["breakbeat", "percussive_layer", "grid16"] : ["percussive_layer", "four_on_floor"], c, "drums", "percussiveLayering")), m && (p = B(p, ["lofi", "rest_heavy", "swing_hint"], c, "drums", "lofiGroove", 0.3)), _ && (p = B(p, ["loop_safe", "grid16", "texture_loop"], c, "drums", "retroPulse", 0.25)), (S = d == null ? void 0 : d.preferBeatTags) != null && S.length && (p = B(p, d.preferBeatTags, c, "drums", "arrangementBeatTags", 0.25));
    const R = V(i, "drumsBeat");
    R.length && (p = B(p, R, c, "drums", "presetBeatTags", 0.25));
  }
  if (f && (p = B(p, ["breakbeat", "grid16"], c, "drums", "breakbeatFocus", 0.2)), (F = d == null ? void 0 : d.avoidTags) != null && F.length) {
    const R = p.filter((C) => {
      const E = C.tags;
      return E ? !d.avoidTags.some((A) => E.includes(A)) : !0;
    });
    P(c, "drums", "avoid-tags", d.avoidTags, p.length, R.length, R.length || p.length, R.length === 0, R.length === 0 ? "empty_match" : void 0), R.length && (p = R);
  }
  const b = L(p, o);
  return $(b, s, n, c, "drums");
}
function L(t, e) {
  if (!t.length)
    return t;
  const a = t.filter((s) => s.id ? !e.has(s.id) : !0);
  return a.length ? a : t;
}
function le(t, e) {
  if (!e.length)
    return t;
  const a = [...e].sort();
  return `${t}:${a.join("|")}`;
}
function Ps(t, e) {
  const a = (t ?? ne) + e >>> 0;
  return ge(a);
}
function Tt(t, e, a, s, n) {
  if (t >= 1)
    return !0;
  if (s.gradualBuild > 0.5) {
    const o = e / Math.max(1, a - 1), r = Math.min(1, t + o * 0.3);
    return n() < r;
  }
  return n() < t;
}
function As(t, e, a, s, n, o, r = 0) {
  var c;
  const l = (c = n.steps) != null && c.length ? n.steps : Ae, i = [], u = s ?? a;
  for (let d = 0; d < l.length; d++) {
    const h = e + d * 0.5, g = Et(l[d], a, u, o);
    g !== null && i.push({
      channelRole: "bass",
      startBeat: h,
      durationBeats: 0.5,
      degree: 0,
      velocity: Bt(t, d),
      sectionId: t.id,
      midiOverride: g
    });
  }
  return i;
}
function Os(t, e, a, s, n, o, r, l) {
  const i = [], u = o.styleIntent, c = n.seed ?? ne, d = Ps(c, s), h = /* @__PURE__ */ new Set(), g = /* @__PURE__ */ new Map(), p = 40 + a * 12;
  for (const y of o.sections) {
    const f = y.startMeasure * M;
    for (let m = 0; m < y.measures; m++) {
      if (!Tt(e, m, y.measures, u, d))
        continue;
      const _ = f + m * M, b = Rt(
        y,
        m,
        d,
        h,
        g,
        u,
        n.stylePreset,
        t === "bassAlt" ? { enforceDroneStatic: !1, preferredTags: ["drone", "accent"] } : void 0,
        l
      );
      r && (r[b.id] = (r[b.id] ?? 0) + 1);
      const S = D(o, _), T = D(o, _ + M), F = As(
        y,
        _,
        S,
        T,
        b,
        p,
        a
      );
      i.push(...F);
    }
  }
  return i;
}
function Is(t, e, a, s) {
  const n = ge(s), o = [];
  for (const r of a.sections) {
    const l = r.startMeasure * M;
    for (let i = 0; i < r.measures; i++) {
      if (!Tt(t, i, r.measures, a.styleIntent, n))
        continue;
      const u = l + i * M, c = i % 2 === 0 ? 1 : 5;
      o.push({
        channelRole: "accompaniment",
        startBeat: u,
        durationBeats: M,
        degree: c,
        velocity: K.PAD_MIN,
        sectionId: r.id
      });
    }
  }
  return o;
}
const Ds = 42, Fs = 0.5, xs = 0.015, Cs = 0.12, Xe = 1 / 16, Qe = 0.012, Hs = 43, ws = 36, ks = 75, Ze = 1e-9, Ks = {
  S: 2,
  // snare: e.g. idx 1 → 3  (~14 kHz → ~3.5 kHz)
  T: 3
  // tom:   e.g. idx 5 → 8  (~1.2 kHz → ~554 Hz)
}, Ns = {
  K: { mode: "long", spec: "long_period", periodIndex: 3, releaseRange: [0.045, 0.075], velocity: W.KICK, amplitude: 1 },
  T: { mode: "long", spec: "long_period", periodIndex: 5, releaseRange: [0.05, 0.09], velocity: W.TOM, amplitude: 0.92 },
  N: { mode: "long", spec: "long_period", periodIndex: 8, releaseRange: [0.06, 0.1], velocity: W.LOW_NOISE, amplitude: 0.88 },
  S: { mode: "short", spec: "short_period", periodIndex: 1, releaseRange: [0.02, 0.045], velocity: W.SNARE, amplitude: 0.9 },
  H: { mode: "short", spec: "short_period", periodIndex: 0, releaseRange: [0.015, 0.03], velocity: W.HIHAT, amplitude: 0.86 },
  O: { mode: "short", spec: "short_period", periodIndex: 2, releaseRange: [0.03, 0.055], velocity: W.OPEN_HAT, amplitude: 0.94 }
}, Ls = 5, Gs = 0.06;
function qs(t) {
  let e = t;
  return () => (e = (e * 1664525 + 1013904223) % 4294967296, e / 4294967296);
}
function De(t, e, a, s) {
  let n = 1;
  const o = e === "bass" || e === "bassAlt", r = e === "melody" || e === "melodyAlt", l = t === "square1" || t === "square2", i = o && a < Sa.BASS_LOW_RANGE;
  o && (n *= q.BASS_BASE), t === "triangle" && (n *= q.TRIANGLE_BASE, i && (n *= q.TRIANGLE_LOW_RANGE_BOOST), o || (n *= q.TRIANGLE_NON_BASS)), l && o && (n *= q.SQUARE_BASS, i && (n *= q.BASS_LOW_RANGE)), l && r && (n *= q.MELODY_CHANNEL_SCALE);
  const u = Math.round(s * n);
  return Math.max(Ge.MIN, Math.min(Ge.MAX_ACCENT, u));
}
function Us(t, e) {
  const a = {
    reverseProbability: 0.5,
    sustainProbability: 0.2,
    densityThresholds: { sparse: 0.45, normal: 0.85 }
  };
  return t.textureFocus > 0.5 && (a.reverseProbability = 0.35, a.sustainProbability = 0.12, a.densityThresholds = { sparse: 0.3, normal: 0.7 }), t.loopCentric > 0.5 && (a.sustainProbability = Math.min(0.35, a.sustainProbability + 0.1), a.densityThresholds = {
    sparse: Math.min(0.5, a.densityThresholds.sparse + 0.05),
    normal: Math.min(0.95, a.densityThresholds.normal + 0.05)
  }), e === "arpeggio" && t.gradualBuild && (a.densityThresholds = { sparse: 0.25, normal: 0.65 }), a;
}
function Vs(t, e, a, s, n) {
  const o = Math.abs(e.midi - t.midi), r = e.startBeat - (t.startBeat + a), l = o > 0 && o <= Ls, i = r >= -1e-3 && r <= 0.5, u = a >= 0.5;
  if (!l || !i || !u)
    return !1;
  let c = 0.15;
  return s.atmosPad > 0.5 ? c = 0.4 : s.loopCentric && s.textureFocus ? c = 0.35 : s.gradualBuild && s.breakInsertion && (c = 0.25), n() < c;
}
function Ws(t, e, a) {
  let s = t;
  return e === "slow" ? s += 0.02 : e === "fast" && (s -= 0.015), a >= 4 && (s += 0.01), Math.max(0.02, Math.min(0.12, s));
}
function js(t, e) {
  if (!t)
    return !1;
  const a = `${t}|${e}`;
  return a === "H|H" || a === "H|O" || a === "O|H";
}
function Ys(t, e, a) {
  const s = (t == null ? void 0 : t.releaseRange) ?? [xs, Cs], n = s[0] + a() * Math.max(0, s[1] - s[0]);
  return e.percussiveLayering > 0.5 ? Math.max(s[0], n * 0.85) : e.gradualBuild > 0.5 ? Math.min(s[1], n * 1.05) : n;
}
function zs(t, e, a) {
  const s = e.voiceArrangement.voices.filter((n) => n.channel === "triangle");
  for (const n of s) {
    const o = a.tracks.find((r) => r.role === n.role);
    if (o && o.notes.some((r) => r.startBeat <= t && r.startBeat + r.durationBeats > t))
      return !0;
  }
  return !1;
}
function $s(t) {
  for (let e = t.length - 1; e >= 0; e--) {
    const a = t[e];
    if (a.channel === "noise" && a.command === "noteOff")
      return a;
  }
}
function Js(t) {
  const e = (t % M + M) % M;
  return Math.abs(e - 1) < 0.1 || Math.abs(e - 3) < 0.1;
}
function Xs(t) {
  const e = t.length > 0 ? t : [0, 4, 7], a = [];
  for (let s = 0; s < 4; s++) {
    const n = e[s % e.length], o = Math.floor(s / e.length) * 12;
    a.push(n + o);
  }
  return a;
}
function Qs(t, e, a) {
  return t() < a ? [...e].reverse() : e;
}
function Zs(t, e, a, s, n) {
  const o = Us(s, n), r = Math.max(K.PAD_MIN, Math.round(t.velocity * K.ARPEGGIO_SCALE));
  if (a() < o.sustainProbability) {
    const h = ae(t.midi, e, t.midi);
    return [
      {
        ...t,
        startBeat: t.startBeat,
        durationBeats: Math.max(t.durationBeats, 1),
        velocity: r,
        midi: h
      }
    ];
  }
  const l = Qs(
    a,
    Xs(pe(e)),
    o.reverseProbability
  ), i = a();
  let u;
  i < o.densityThresholds.sparse ? u = 2 : i < o.densityThresholds.normal ? u = 4 : u = 1;
  const c = u === 4 ? 0.25 : u === 2 ? 0.5 : Math.max(t.durationBeats, 1), d = [];
  for (let h = 0; h < u; h++) {
    const g = t.startBeat + c * h, v = l[h % l.length], p = I(t.midi + v, e), y = ae(p, e, t.midi);
    d.push({
      channelRole: "accompaniment",
      startBeat: g,
      durationBeats: c,
      degree: t.degree,
      velocity: r,
      sectionId: t.sectionId,
      midi: y
    });
  }
  return d;
}
function en(t) {
  const e = [];
  for (const a of t) {
    const s = [0, 0.5];
    for (const n of s)
      e.push({
        ...a,
        startBeat: a.startBeat + n,
        durationBeats: 0.5,
        velocity: Math.max(K.PAD_MIN, Math.round(a.velocity * K.BROKEN_SCALE))
      });
  }
  return e;
}
function tn(t) {
  return t.map((e) => ({
    ...e,
    durationBeats: e.durationBeats >= 1 ? e.durationBeats : 1,
    velocity: Math.max(K.PAD_MIN, Math.round(e.velocity * K.STEADY_SCALE))
  }));
}
function an(t, e, a) {
  return {
    rng: qs(t.seed ?? Ds),
    sectionById: new Map(e.sections.map((s) => [s.id, s])),
    totalBeats: (t.lengthInMeasures ?? 32) * M,
    styleIntent: e.styleIntent,
    tempoSetting: t.tempo ?? "medium",
    phase1: e,
    phase2: a
  };
}
function sn(t, e, a) {
  const s = [], n = e.channel;
  for (let o = 0; o < t.notes.length; o++) {
    const r = t.notes[o], l = a.sectionById.get(r.sectionId);
    l && Math.max(0, Math.floor(r.startBeat / M) - l.startMeasure);
    const i = {
      midi: r.midi,
      velocity: De(n, e.role, r.midi, r.velocity)
    }, u = t.notes[o + 1];
    if (u && Vs(r, u, r.durationBeats, a.styleIntent, a.rng)) {
      const c = Math.abs(u.midi - r.midi);
      i.slide = {
        targetMidi: u.midi,
        durationSeconds: Ws(
          Gs,
          a.tempoSetting,
          c
        )
      };
    }
    Fe(s, r.startBeat, r.durationBeats, n, i, a.totalBeats);
  }
  return s;
}
function nn(t, e, a) {
  const s = [], n = e.channel;
  for (const o of t.notes)
    Fe(s, o.startBeat, o.durationBeats, n, {
      midi: o.midi,
      velocity: De(n, e.role, o.midi, o.velocity)
    }, a.totalBeats);
  return s;
}
function rn(t, e, a) {
  var l;
  const s = [], n = e.channel, o = /* @__PURE__ */ new Map();
  for (const i of t.notes) {
    const u = Math.floor(i.startBeat / M), c = o.get(u) ?? [];
    c.push(i), o.set(u, c);
  }
  const r = Array.from(o.keys()).sort((i, u) => i - u);
  for (const i of r) {
    const u = o.get(i), c = u.length ? a.sectionById.get(u[0].sectionId) : void 0, d = (c == null ? void 0 : c.texture) ?? "steady", h = D(a.phase1, ((l = u[0]) == null ? void 0 : l.startBeat) ?? i * M);
    let g;
    d === "arpeggio" ? g = u.flatMap(
      (f) => Zs(f, h, a.rng, a.styleIntent, c == null ? void 0 : c.texture)
    ) : d === "broken" ? g = en(u) : g = tn(u);
    const v = [], p = [];
    for (const f of g)
      a.rng() < a.phase1.techniqueStrategy.echoProbability && v.push({
        ...f,
        startBeat: f.startBeat + 0.25,
        velocity: Math.round(f.velocity * Ve.ECHO_SCALE)
      }), a.rng() < a.phase1.techniqueStrategy.detuneProbability && p.push({
        ...f,
        startBeat: f.startBeat,
        velocity: Math.round(f.velocity * Ve.DETUNE_SCALE),
        midi: f.midi,
        detuneCents: 12
      });
    const y = [...g, ...v, ...p].map((f) => {
      const m = D(a.phase1, f.startBeat), _ = a.phase2.tracks.find((T) => T.role === "melody"), b = _ ? dn(f.startBeat, _.notes) : void 0, S = ae(f.midi, m, (b == null ? void 0 : b.midi) ?? f.midi);
      return { ...f, midi: S };
    });
    for (const f of y)
      Fe(s, f.startBeat, f.durationBeats, n, {
        midi: f.midi,
        velocity: De(n, e.role, f.midi, f.velocity),
        detuneCents: f.detuneCents
      }, a.totalBeats);
  }
  return s;
}
function on(t, e) {
  const a = [];
  let s = -1, n = null, o = null, r = null;
  const l = [...t].sort((i, u) => i.startBeat - u.startBeat);
  for (const i of l) {
    let u = i.startBeat;
    const c = Ns[i.instrument];
    if (!c) continue;
    const d = js(r, i.instrument), h = d ? 0 : Xe;
    o !== null && u - o <= h && (u = o + Math.max(h, Xe));
    const g = Ys(c, e.styleIntent, e.rng), v = Math.max(0.01, Math.min(g * 0.7, g)), p = Math.min(i.durationBeats, Fs);
    if (u >= e.totalBeats) continue;
    if (n !== null && u < n)
      if (d && s >= 0) {
        const S = $s(a);
        S && (S.beatTime = u, i.instrument === "H" && r === "O" && (S.data.releaseSeconds = 3e-3)), n = u;
      } else s >= 0 && (a.splice(s), s = -1, n = null, o = null);
    s = a.length;
    let y = c.mode, f = c.periodIndex, m = c.amplitude;
    i.instrument === "S" && Js(u) && (y = "long", f = 4, m = Math.min(1, c.amplitude * 1.05)), a.push({
      beatTime: u,
      channel: "noise",
      command: "noteOn",
      data: {
        noiseMode: c.spec,
        // descriptive label (kept for compat)
        mode: y,
        // actual "long"|"short" LFSR selector
        velocity: c.velocity,
        amplitude: m,
        releaseSeconds: g,
        decaySeconds: v,
        periodIndex: f,
        clockDivider: f
      }
    });
    const _ = Math.min(u + p, e.totalBeats), b = Ks[i.instrument];
    if (b !== void 0) {
      const S = Math.min(15, f + b), T = u + (_ - u) * 0.4;
      T < _ && a.push({
        beatTime: T,
        channel: "noise",
        command: "setParam",
        data: { param: "periodIndex", value: S }
      });
    }
    if (a.push({
      beatTime: _,
      channel: "noise",
      command: "noteOff",
      data: {}
    }), i.instrument === "K" && !zs(u, e.phase1, e.phase2)) {
      const S = Qe * e.phase1.bpm / 60, T = Math.min(u + S, e.totalBeats);
      T > u && (a.push({
        beatTime: u + Ze,
        // fires after same-beat bass noteOn
        channel: "triangle",
        command: "noteOn",
        data: {
          midi: Hs,
          velocity: ks,
          slide: {
            targetMidi: ws,
            durationSeconds: Qe * 0.75
          }
        }
      }), a.push({
        beatTime: T + Ze,
        channel: "triangle",
        command: "noteOff",
        data: {}
      }));
    }
    n = _, o = u, r = i.instrument;
  }
  return a;
}
function ln(t, e, a) {
  const s = e.role;
  return s === "melody" || s === "melodyAlt" ? sn(t, e, a) : s === "bass" || s === "bassAlt" ? nn(t, e, a) : s === "accompaniment" || s === "pad" ? rn(t, e, a) : [];
}
function un(t, e, a) {
  const s = an(t, e, a), n = [];
  for (const l of a.tracks) {
    const i = e.voiceArrangement.voices.find((c) => c.role === l.role);
    if (!i)
      continue;
    const u = ln(l, i, s);
    n.push(...u);
  }
  const o = on(a.drums, s);
  n.push(...o), n.sort((l, i) => l.beatTime - i.beatTime);
  const r = cn(n);
  return { events: n, diagnostics: r };
}
function Fe(t, e, a, s, n, o, r = {}) {
  if (e >= o)
    return;
  t.push({
    beatTime: e,
    channel: s,
    command: "noteOn",
    data: n
  });
  const l = Math.min(e + a, o);
  t.push({
    beatTime: l,
    channel: s,
    command: "noteOff",
    data: r
  });
}
function cn(t) {
  const e = /* @__PURE__ */ new Map(), a = { voiceAllocation: [] };
  for (const s of t) {
    e.has(s.channel) || e.set(s.channel, 0);
    const n = e.get(s.channel);
    s.command === "noteOn" ? e.set(s.channel, n + 1) : s.command === "noteOff" && n > 0 && e.set(s.channel, n - 1), a.voiceAllocation.push({
      beatTime: s.beatTime,
      channel: s.channel,
      activeCount: e.get(s.channel)
    });
  }
  return a;
}
function dn(t, e) {
  return e.find((a) => t >= a.startBeat && t < a.startBeat + a.durationBeats);
}
const pn = [
  {
    channel: "square1",
    param: "duty",
    value: 0.25
  },
  {
    channel: "square2",
    param: "duty",
    value: 0.5
  }
], hn = [
  {
    id: "DS_MEASURE_BOUNDARY_SWEEP",
    param: "duty",
    channels: [
      "square1",
      "square2"
    ],
    minDurationBeats: 1.5,
    requireMeasureBoundary: !0,
    styleFlag: "filterMotion",
    steps: [
      0.5,
      0.75,
      0.25
    ]
  },
  {
    id: "DS_MINIMAL_LOW_PASS_THUMP",
    param: "duty",
    channels: [
      "square1",
      "square2"
    ],
    minDurationBeats: 2,
    requireMeasureBoundary: !0,
    styleFlag: "percussiveLayering",
    steps: [
      0.18,
      0.38,
      0.24
    ]
  },
  {
    id: "DS_PROGRESSIVE_FILTER_RISE",
    param: "duty",
    channels: [
      "square2"
    ],
    minDurationBeats: 4,
    styleFlag: "gradualBuild",
    steps: [
      0.28,
      0.46,
      0.62,
      0.76
    ]
  },
  {
    id: "DS_PROGRESSIVE_PULSE_SQ1",
    param: "duty",
    channels: [
      "square1"
    ],
    minDurationBeats: 3,
    styleFlag: "gradualBuild",
    steps: [
      0.22,
      0.4,
      0.56
    ]
  },
  {
    id: "DS_BREAKBEAT_STUTTER",
    param: "duty",
    channels: [
      "square1",
      "square2"
    ],
    minDurationBeats: 0.5,
    styleFlag: "syncopationBias",
    steps: [
      0.12,
      0.75,
      0.12,
      0.75
    ]
  },
  {
    id: "DS_LOFI_WARM_Wobble",
    param: "duty",
    channels: [
      "square2"
    ],
    minDurationBeats: 2,
    styleFlag: "lofiFeel",
    steps: [
      0.3,
      0.5,
      0.3,
      0.5
    ]
  }
], gn = [
  {
    id: "GP_TRIANGLE_MEASURE_ACCENT",
    channel: "triangle",
    param: "gain",
    measureBoundaryValue: 0.9,
    defaultValue: 0.7,
    styleFlag: "percussiveLayering"
  },
  {
    id: "GP_NOISE_BREAK_SPILL",
    channel: "noise",
    param: "gain",
    measureBoundaryValue: 0.82,
    defaultValue: 0.7,
    styleFlag: "breakInsertion"
  },
  {
    id: "GP_MINIMAL_BASS_SIDECHAIN",
    channel: "square2",
    param: "gain",
    measureBoundaryValue: 0.68,
    defaultValue: 0.56,
    styleFlag: "percussiveLayering"
  },
  {
    id: "GP_MINIMAL_PERC_FADE",
    channel: "noise",
    param: "gain",
    measureBoundaryValue: 0.7,
    defaultValue: 0.58,
    styleFlag: "percussiveLayering"
  },
  {
    id: "GP_PROGRESSIVE_PAD_SWELL",
    channel: "triangle",
    param: "gain",
    measureBoundaryValue: 0.88,
    defaultValue: 0.74,
    styleFlag: "gradualBuild"
  },
  {
    id: "GP_PROGRESSIVE_SQUARE_GLIDE",
    channel: "square1",
    param: "gain",
    measureBoundaryValue: 0.8,
    defaultValue: 0.66,
    styleFlag: "gradualBuild"
  },
  {
    id: "GP_BREAKBEAT_CRASH",
    channel: "noise",
    param: "gain",
    measureBoundaryValue: 0.92,
    defaultValue: 0.78,
    styleFlag: "breakInsertion"
  },
  {
    id: "GP_LOFI_TAPE_DROP",
    channel: "square1",
    param: "gain",
    measureBoundaryValue: 0.72,
    defaultValue: 0.62,
    styleFlag: "lofiFeel"
  }
], vn = [
  {
    id: "SW_NES_FALL_MOTION",
    channels: [
      "square1",
      "square2"
    ],
    minDurationBeats: 1,
    period: 3,
    shift: 5,
    negate: !1,
    sweepDurationBeats: 0.5,
    everyNthNote: 8,
    styleFlag: "filterMotion"
  },
  {
    id: "SW_NES_RISE_BUILD",
    channels: [
      "square1",
      "square2"
    ],
    minDurationBeats: 1,
    period: 4,
    shift: 5,
    negate: !0,
    sweepDurationBeats: 0.5,
    everyNthNote: 12,
    styleFlag: "gradualBuild"
  }
], mn = [
  {
    id: "PB_RETRO_LEAD_SCOOP",
    channels: [
      "square1",
      "square2"
    ],
    minDurationBeats: 0.5,
    intervalSemitones: 0.35,
    returnAfterBeats: 0.125,
    rampDurationSeconds: 0.035,
    everyNthNote: 7,
    styleFlag: "filterMotion"
  },
  {
    id: "PB_BREAKBEAT_STING",
    channels: [
      "square1",
      "square2"
    ],
    minDurationBeats: 0.25,
    intervalSemitones: -0.45,
    returnAfterBeats: 0.0625,
    rampDurationSeconds: 0.025,
    everyNthNote: 11,
    styleFlag: "syncopationBias"
  },
  {
    id: "PB_PAD_DRIFT",
    channels: [
      "square1",
      "square2"
    ],
    minDurationBeats: 1,
    intervalSemitones: 0.22,
    returnAfterBeats: 0.25,
    rampDurationSeconds: 0.08,
    everyNthNote: 9,
    styleFlag: "atmosPad"
  },
  {
    id: "PB_GRADUAL_SCOOP",
    channels: [
      "square1"
    ],
    minDurationBeats: 0.75,
    intervalSemitones: 0.5,
    returnAfterBeats: 0.125,
    rampDurationSeconds: 0.05,
    everyNthNote: 6,
    styleFlag: "gradualBuild"
  }
], fn = {
  initialParams: pn,
  dutySweeps: hn,
  gainProfiles: gn,
  sweepOrnaments: vn,
  pitchBendOrnaments: mn
}, Z = fn, _n = {
  square1: { base: 0.68, peak: 0.9 },
  square2: { base: 0.66, peak: 0.88 },
  triangle: { base: 0.48, peak: 0.68 },
  noise: { base: 0.74, peak: 0.82 }
};
function yn(t, e, a) {
  const s = [], n = t.events.reduce((p, y) => Math.max(p, y.beatTime), 0), o = Math.max(1, Math.ceil(n / M)), r = !!a;
  for (const p of Z.initialParams ?? [])
    s.push({
      beatTime: 0,
      channel: p.channel,
      command: "setParam",
      data: { param: p.param, value: p.value }
    });
  const l = r ? (Z.dutySweeps ?? []).filter(
    (p) => p.styleFlag ? e[p.styleFlag] > 0.5 : !1
  ) : [], i = r ? (Z.gainProfiles ?? []).filter(
    (p) => p.styleFlag ? e[p.styleFlag] > 0.5 : !1
  ) : [], u = r ? (Z.pitchBendOrnaments ?? []).filter(
    (p) => p.styleFlag ? e[p.styleFlag] > 0.5 : !1
  ) : [], c = r ? (Z.sweepOrnaments ?? []).filter(
    (p) => p.styleFlag ? e[p.styleFlag] > 0.5 : !1
  ) : [], d = {}, h = {};
  r && e.filterMotion > 0.5 && l.push({
    id: "STYLE_FILTER_SWELL",
    param: "duty",
    channels: ["square1", "square2"],
    minDurationBeats: 2,
    steps: [0.2, 0.6, 0.4, 0.75]
  }), r && e.percussiveLayering > 0.5 && i.push({
    id: "STYLE_NOISE_PUNCH",
    channel: "noise",
    param: "gain",
    measureBoundaryValue: 0.85,
    defaultValue: 0.78
  }), r && e.percussiveLayering && !e.breakInsertion && i.push(
    {
      id: "STYLE_MINIMAL_SIDECHAIN_SQ1",
      channel: "square1",
      param: "gain",
      measureBoundaryValue: 0.74,
      defaultValue: 0.62
    },
    {
      id: "STYLE_MINIMAL_SIDECHAIN_SQ2",
      channel: "square2",
      param: "gain",
      measureBoundaryValue: 0.72,
      defaultValue: 0.6
    }
  ), r && e.atmosPad > 0.5 && i.push({
    id: "STYLE_TRIANGLE_PAD",
    channel: "triangle",
    param: "gain",
    measureBoundaryValue: 0.82,
    defaultValue: 0.72
  }), r && e.gradualBuild && e.breakInsertion && l.push({
    id: "STYLE_PROGRESSIVE_DUTY_SWELL",
    param: "duty",
    channels: ["square2"],
    minDurationBeats: 1,
    steps: [0.32, 0.48, 0.58, 0.68]
  }), r && e.gradualBuild && e.breakInsertion && i.push({
    id: "STYLE_PROGRESSIVE_TRI_RISE",
    channel: "triangle",
    param: "gain",
    measureBoundaryValue: 0.9,
    defaultValue: 0.76
  });
  const g = /* @__PURE__ */ new Set();
  for (const p of t.events) {
    if (p.command !== "noteOn") continue;
    const y = bn(t.events, p), f = y ? y.beatTime - p.beatTime : 0;
    for (const m of l) {
      if (!m.channels.includes(p.channel) || !y || f < m.minDurationBeats || m.requireMeasureBoundary && !(ye(p.beatTime) || (y ? ye(y.beatTime) : !1)))
        continue;
      const _ = f / (m.steps.length + 1);
      m.steps.forEach((b, S) => {
        s.push({
          beatTime: p.beatTime + _ * (S + 1),
          channel: p.channel,
          command: "setParam",
          data: { param: m.param, value: b }
        });
      });
    }
    for (const m of i) {
      if (p.channel !== m.channel) continue;
      const _ = ye(p.beatTime) ? m.measureBoundaryValue : m.defaultValue;
      s.push({
        beatTime: p.beatTime,
        channel: p.channel,
        command: "setParam",
        data: { param: m.param, value: _ }
      });
    }
    for (const m of u) {
      if (!m.channels.includes(p.channel) || !y || f < m.minDurationBeats) continue;
      const _ = p.data.midi;
      if (typeof _ != "number") continue;
      const b = (d[p.channel] ?? 0) + 1;
      if (d[p.channel] = b, b % Math.max(1, m.everyNthNote) !== 0) continue;
      const S = p.beatTime + Math.min(0.0625, f / 4), T = Math.min(
        p.beatTime + f - 0.03125,
        S + m.returnAfterBeats
      );
      T <= S || (s.push({
        beatTime: S,
        channel: p.channel,
        command: "setParam",
        data: {
          param: "pitchBend",
          value: _ + m.intervalSemitones,
          rampDuration: m.rampDurationSeconds,
          curve: "linear"
        }
      }), s.push({
        beatTime: T,
        channel: p.channel,
        command: "setParam",
        data: {
          param: "pitchBend",
          value: _,
          rampDuration: m.rampDurationSeconds,
          curve: "linear"
        }
      }));
    }
    for (const m of c) {
      if (!m.channels.includes(p.channel) || !y || f < m.minDurationBeats) continue;
      const _ = (h[p.channel] ?? 0) + 1;
      if (h[p.channel] = _, _ % Math.max(1, m.everyNthNote) !== 0) continue;
      s.push({
        beatTime: p.beatTime,
        channel: p.channel,
        command: "setParam",
        data: {
          param: "sweep",
          enabled: !0,
          period: m.period,
          shift: m.shift,
          negate: m.negate
        }
      });
      const b = Math.min(
        p.beatTime + m.sweepDurationBeats,
        y.beatTime - 0.03125
      );
      b > p.beatTime && s.push({
        beatTime: b,
        channel: p.channel,
        command: "setParam",
        data: { param: "sweep", enabled: !1 }
      });
    }
    if (r && e.breakInsertion && p.channel === "noise") {
      const m = Math.floor(p.beatTime / M);
      if (!g.has(m) && m > 0 && (m + 1) % 8 === 0) {
        g.add(m);
        const _ = m * M;
        s.push({
          beatTime: _ - 0.25 >= 0 ? _ - 0.25 : _,
          channel: "noise",
          command: "setParam",
          data: { param: "gain", value: 0.45 }
        }), s.push({
          beatTime: _ + 1,
          channel: "noise",
          command: "setParam",
          data: { param: "gain", value: 0.78 }
        });
        for (const b of ["square1", "square2"])
          s.push({
            beatTime: _ - 0.25 >= 0 ? _ - 0.25 : _,
            channel: b,
            command: "setParam",
            data: { param: "gain", value: 0.55 }
          }), s.push({
            beatTime: _ + 1,
            channel: b,
            command: "setParam",
            data: { param: "gain", value: 0.82 }
          });
      }
    }
  }
  if (r && e.gradualBuild && o > 1) {
    const p = Math.max(1, Math.floor(o / 8));
    for (const [y, f] of Object.entries(_n)) {
      const m = y;
      for (let _ = 0; _ < o; _ += p) {
        const b = o > 1 ? _ / (o - 1) : 1, S = Math.pow(b, e.loopCentric ? 0.8 : 1), T = f.base + (f.peak - f.base) * S;
        s.push({
          beatTime: _ * M,
          channel: m,
          command: "setParam",
          data: { param: "gain", value: Number(T.toFixed(3)) }
        });
      }
    }
  }
  const v = [...t.events, ...s];
  return v.sort((p, y) => p.beatTime === y.beatTime ? p.command === y.command ? 0 : p.command === "setParam" ? -1 : y.command === "setParam" ? 1 : 0 : p.beatTime - y.beatTime), { events: v };
}
function bn(t, e) {
  if (e.command !== "noteOn") return;
  let a, s = 1 / 0;
  for (const n of t)
    if (n.channel === e.channel && n.command === "noteOff" && n.beatTime > e.beatTime) {
      const o = n.beatTime - e.beatTime;
      o < s && (s = o, a = n);
    }
  return a;
}
function ye(t) {
  return Math.abs(t % M) < 1e-6;
}
const G = 1e-6, Re = 1 / 32, Sn = /* @__PURE__ */ new Set([2, 5, 9, 10, 11]);
function Mn(t, e, a) {
  const s = 60 / t.bpm, n = On(t), o = new Map(
    t.voiceArrangement.voices.map((v) => [v.channel, v.role])
  ), r = Rn(t, e, a, s, o), l = [], i = [], u = Fn(), c = {}, d = { root: 0, fifth: 0, approach: 0, other: 0 };
  for (const v of r)
    u[v.toneClass] += 1, c[v.role] = (c[v.role] ?? 0) + 1, En(v, t, n, l, i, d);
  const h = Tn(r, n, l, i);
  h.denseUnisonRepeats = Pn(r, t, l);
  const g = An(r, e, t, a, s, n, l, i);
  return {
    notes: r,
    toneCounts: u,
    roleCounts: c,
    bassFunctions: d,
    collisionCounts: h,
    boundaryCounts: g,
    warnings: nt(l),
    errors: nt(i)
  };
}
function Rn(t, e, a, s, n) {
  const o = /* @__PURE__ */ new Map(), r = [];
  for (const l of xn(e)) {
    const i = l.time / s;
    if (l.command === "noteOn") {
      if (typeof l.data.midi != "number" || l.channel === "noise") continue;
      const h = o.get(l.channel) ?? [];
      h.push({ event: l, startBeat: i }), o.set(l.channel, h);
      continue;
    }
    if (l.command !== "noteOff") continue;
    const c = (o.get(l.channel) ?? []).shift();
    if (!c) continue;
    const d = Math.min(a, Math.max(c.startBeat, i));
    Cn(c.event, d - c.startBeat, s) || r.push(Bn(t, c.event, c.startBeat, d, n));
  }
  return r.sort((l, i) => l.startBeat - i.startBeat || l.channel.localeCompare(i.channel));
}
function Bn(t, e, a, s, n) {
  const o = e.data.midi, r = D(t, a), l = O(k(r, 0)), i = O(o - l), u = new Set(pe(r).map((f) => O(f))), c = O(k(t.key, 0)), d = new Set(t.scaleDegrees.map((f) => O(f))), h = O(o - c);
  let g;
  u.has(i) ? g = "chord_tone" : d.has(h) && Sn.has(i) ? g = "tension" : d.has(h) ? g = "scale_tone" : g = "non_scale_tone";
  const v = Math.floor((a + G) / M), p = Pt(a, M), y = Hn(t, v);
  return {
    startBeat: ee(a),
    endBeat: ee(s),
    durationBeats: ee(s - a),
    measureIndex: v,
    beatInMeasure: ee(p),
    sectionId: (y == null ? void 0 : y.id) ?? "unknown",
    channel: e.channel,
    role: n.get(e.channel) ?? "unknown",
    chord: r,
    midi: o,
    toneClass: g,
    chordInterval: i,
    strongBeat: Be(p, 0, Re) || Be(p, 2, Re)
  };
}
function En(t, e, a, s, n, o) {
  (t.role === "bass" || t.role === "bassAlt") && Be(t.beatInMeasure, 0, Re) && (t.chordInterval === 0 ? o.root += 1 : t.chordInterval === 7 ? o.fifth += 1 : In(t, e) ? o.approach += 1 : (o.other += 1, t.toneClass === "non_scale_tone" ? n.push(U(t, "bass_downbeat_conflict", "bass_generation", "Bass downbeat is outside both the current chord and key.")) : t.toneClass !== "chord_tone" && s.push(U(t, "bass_downbeat_tension", "bass_generation", "Bass downbeat is a scale tone outside the current chord.")))), t.toneClass === "non_scale_tone" && t.strongBeat && t.durationBeats >= a.longNonScaleBeats && s.push(U(t, "long_strong_non_scale_tone", Dn(t.role), "Long non-scale tone begins on a strong beat."));
}
function Tn(t, e, a, s) {
  const n = { minorSecondOrMajorSeventh: 0, sustainedMinorSecond: 0, voiceCrossing: 0, denseUnisonRepeats: 0 };
  for (let o = 0; o < t.length; o++)
    for (let r = o + 1; r < t.length; r++) {
      const l = t[o], i = t[r];
      if (i.startBeat >= l.endBeat - G) break;
      if (l.channel === i.channel || !st(l.role) || !st(i.role)) continue;
      const u = Math.min(l.endBeat, i.endBeat) - Math.max(l.startBeat, i.startBeat);
      if (u <= G) continue;
      const c = Math.abs(l.midi - i.midi), d = O(c);
      if (d === 1 || d === 11) {
        n.minorSecondOrMajorSeventh += 1;
        const v = l.startBeat >= i.startBeat ? l : i;
        u >= e.sustainedCollisionBeats && d === 1 ? (n.sustainedMinorSecond += 1, s.push(z(v, l, i, "sustained_minor_second", "accompaniment_generation", "Minor-second collision is sustained across independent voices."))) : a.push(z(v, l, i, "brief_second_or_seventh", "accompaniment_generation", "Brief second or seventh occurs between simultaneous voices."));
      }
      const h = kn(l, i), g = Kn(l, i);
      h && g && g.midi > h.midi + 12 && (n.voiceCrossing += 1, a.push(z(g, l, i, "voice_crossing", "accompaniment_generation", "Accompaniment crosses more than an octave above the melody.")));
    }
  return n;
}
function Pn(t, e, a) {
  let s = 0;
  const n = O(k(e.key, 0)), o = O(n + 11), r = /* @__PURE__ */ new Map();
  for (const l of t) {
    if (!J(l.role)) continue;
    const i = `${l.channel}	${l.role}`, u = r.get(i) ?? [];
    u.push(l), r.set(i, u);
  }
  for (const l of r.values()) {
    l.sort((u, c) => u.startBeat - c.startBeat);
    let i = 1;
    for (let u = 0; u < l.length; u++) {
      const c = l[u], d = l[u + 1];
      O(c.midi) === o && c.strongBeat && c.durationBeats >= 0.5 && (d && d.startBeat - c.endBeat <= 1 + G && O(d.midi) === n || a.push(U(c, "unresolved_leading_tone", "motif", "Strong leading tone does not resolve to the tonic within one beat."))), d && d.midi === c.midi && d.startBeat - c.startBeat <= 0.5 + G ? (i += 1, i === 4 && (s += 1, a.push(U(d, "dense_unison_repeat", "motif", "The same melody pitch repeats four times within a dense onset sequence.")))) : i = 1;
    }
  }
  return s;
}
function An(t, e, a, s, n, o, r, l) {
  var p, y;
  let i = 0, u = 0, c = 0;
  const d = a.sections.slice(1).map((f) => f.startMeasure * M);
  for (const f of d) {
    const m = tt(t, f);
    m && f - m.endBeat <= o.boundaryWindowBeats && m.toneClass === "non_scale_tone" && (i += 1, r.push(U(m, "section_boundary_non_scale_tone", "motif", "Section closes on a non-scale tone.")));
    const _ = wn(t, f);
    _ && f - _[1].endBeat <= o.boundaryWindowBeats && Math.abs(_[1].midi - _[0].midi) > 12 && _[1].toneClass !== "chord_tone" && (i += 1, r.push(z(_[1], _[0], _[1], "cadence_unresolved_leap", "motif", "Section cadence approaches an unstable tone through a leap larger than an octave.")));
  }
  const h = tt(t, s + G), g = t.find((f) => J(f.role));
  if (h && s - h.endBeat <= o.boundaryWindowBeats && h.toneClass === "non_scale_tone" && (u += 1, r.push(U(h, "loop_tail_non_scale_tone", "motif", "Loop tail closes on a non-scale tone."))), h && g && s - h.endBeat <= o.boundaryWindowBeats) {
    const f = Math.abs(h.midi - g.midi);
    f > 19 && h.toneClass !== "chord_tone" ? (c += 1, l.push(z(h, h, g, "unresolved_loop_leap", "timeline_finalization", "Loop wraps from an unresolved tone through an extreme leap."))) : f > 12 && (u += 1, r.push(z(h, h, g, "large_loop_leap", "motif", "Loop melody wraps through a leap larger than an octave.")));
  }
  const v = s * n;
  for (const f of e) {
    if (f.command !== "noteOff") continue;
    const m = typeof f.data.releaseSeconds == "number" ? f.data.releaseSeconds : 0;
    m <= 0 || f.time + m <= v + G || (c += 1, l.push({
      severity: "error",
      rule: "loop_release_tail",
      cause: "timeline_finalization",
      message: "Release tail extends beyond the loop boundary.",
      beat: ee(f.time / n),
      measureIndex: Math.floor(s / M),
      sectionId: ((p = a.sections.at(-1)) == null ? void 0 : p.id) ?? "unknown",
      channels: [f.channel],
      roles: [((y = a.voiceArrangement.voices.find((_) => _.channel === f.channel)) == null ? void 0 : y.role) ?? "unknown"],
      midi: []
    }));
  }
  return { sectionWarnings: i, loopWarnings: u, loopErrors: c };
}
function On(t) {
  const e = t.styleIntent.breakInsertion > 0.5 || t.styleIntent.syncopationBias > 0.6, a = t.styleIntent.atmosPad > 0.5 || t.styleIntent.lofiFeel > 0.5;
  return {
    sustainedCollisionBeats: e ? 2 : 1,
    longNonScaleBeats: a ? 2 : 1,
    boundaryWindowBeats: a ? 1 : 0.5
  };
}
function In(t, e) {
  const a = D(e, t.startBeat + M), s = O(k(a, 0)), n = O(k(t.chord, 0));
  if (s === n) return !1;
  const o = O(t.midi - s);
  return o === 1 || o === 11;
}
function U(t, e, a, s) {
  return {
    severity: e === "bass_downbeat_conflict" ? "error" : "warning",
    rule: e,
    cause: a,
    message: s,
    beat: t.startBeat,
    measureIndex: t.measureIndex,
    sectionId: t.sectionId,
    channels: [t.channel],
    roles: [t.role],
    midi: [t.midi]
  };
}
function z(t, e, a, s, n, o) {
  return {
    severity: s === "sustained_minor_second" || s === "unresolved_loop_leap" ? "error" : "warning",
    rule: s,
    cause: n,
    message: o,
    beat: Math.max(e.startBeat, a.startBeat),
    measureIndex: t.measureIndex,
    sectionId: t.sectionId,
    channels: [e.channel, a.channel],
    roles: [e.role, a.role],
    midi: [e.midi, a.midi]
  };
}
function Dn(t) {
  return t === "bass" || t === "bassAlt" ? "bass_generation" : t === "accompaniment" || t === "pad" ? "accompaniment_generation" : "quantization";
}
function Fn() {
  return { chord_tone: 0, tension: 0, scale_tone: 0, non_scale_tone: 0 };
}
function xn(t) {
  return [...t].sort((e, a) => e.time - a.time || et(e) - et(a));
}
function et(t) {
  return t.command === "noteOff" ? 0 : t.command === "noteOn" ? 1 : 2;
}
function Cn(t, e, a) {
  return t.channel === "triangle" && t.data.midi === 43 && e * a <= 0.02 && !!t.data.slide;
}
function Hn(t, e) {
  return t.sections.find((a) => e >= a.startMeasure && e < a.startMeasure + a.measures);
}
function tt(t, e) {
  return t.filter((a) => J(a.role) && a.endBeat <= e + G).sort((a, s) => s.endBeat - a.endBeat)[0];
}
function wn(t, e) {
  const a = t.filter((s) => J(s.role) && s.endBeat <= e + G).sort((s, n) => n.endBeat - s.endBeat || n.startBeat - s.startBeat).slice(0, 2).reverse();
  return a.length === 2 ? [a[0], a[1]] : void 0;
}
function kn(t, e) {
  return J(t.role) ? t : J(e.role) ? e : void 0;
}
function Kn(t, e) {
  return at(t.role) ? t : at(e.role) ? e : void 0;
}
function J(t) {
  return t === "melody" || t === "melodyAlt";
}
function at(t) {
  return t === "accompaniment" || t === "pad";
}
function st(t) {
  return t !== "drums" && t !== "unknown";
}
function nt(t) {
  return t.sort((e, a) => e.beat - a.beat || e.rule.localeCompare(a.rule) || e.channels.join().localeCompare(a.channels.join()));
}
function Be(t, e, a) {
  return Math.abs(t - e) <= a;
}
function Pt(t, e) {
  return (t % e + e) % e;
}
function O(t) {
  return Pt(t, 12);
}
function ee(t) {
  return Number(t.toFixed(6));
}
function Nn(t, e, a, s, n, o) {
  const r = 60 / t.bpm, l = t.sections.reduce(
    (d, h) => Math.max(d, (h.startMeasure + h.measures) * 4),
    0
  ), i = l * r, u = e.map((d) => ({
    time: d.beatTime * r,
    channel: d.channel,
    command: d.command,
    data: d.data
  }));
  u.sort((d, h) => d.time - h.time);
  const c = {
    voiceAllocation: a.voiceAllocation.map((d) => ({
      time: d.beatTime * r,
      channel: d.channel,
      activeCount: d.activeCount
    })),
    loopWindow: Ln(u),
    loopIntegrity: Gn(u, i),
    theoryAudit: Mn(t, u, l),
    motifUsage: s,
    sectionMotifPlan: n,
    motifSelection: o
  };
  return { events: u, diagnostics: c };
}
function Ln(t) {
  if (!t.length)
    return { head: [], tail: [] };
  const e = 0.1, a = t[t.length - 1].time, s = t.filter((o) => a - o.time < e);
  return { head: t.filter((o) => o.time < e), tail: s };
}
function Gn(t, e) {
  const a = [0.1, 0.25, 0.5].map((u) => ({
    seconds: u,
    headEvents: t.filter((c) => c.time < u).length,
    tailEvents: t.filter((c) => e - c.time < u).length,
    noiseTailEvents: t.filter(
      (c) => c.channel === "noise" && e - c.time < u
    ).length
  })), s = /* @__PURE__ */ new Map();
  let n = 0;
  for (const u of qn(t))
    if (u.command === "noteOn") {
      const c = s.get(u.channel) ?? [];
      c.push(u), s.set(u.channel, c);
    } else if (u.command === "noteOff") {
      const c = s.get(u.channel) ?? [];
      c.length > 0 ? c.shift() : n += 1;
    }
  const o = Array.from(s.values()).flat().map((u) => ({
    channel: u.channel,
    time: rt(u.time),
    midi: u.data.midi
  }));
  let r = 0, l = 0, i = 0;
  for (const u of t) {
    const c = typeof u.data.releaseSeconds == "number" ? u.data.releaseSeconds : 0;
    if (c <= 0) continue;
    const d = u.time + c - e;
    d > 1e-6 && (r += 1, u.channel === "noise" && (l += 1), i = Math.max(i, d));
  }
  return {
    windows: a,
    unmatchedNoteOnCount: o.length,
    unmatchedNoteOffCount: n,
    openNotes: o.slice(0, 12),
    lateReleaseCount: r,
    noiseLateReleaseCount: l,
    maxReleaseOverhangSeconds: rt(i)
  };
}
function qn(t) {
  return [...t].sort((e, a) => e.time !== a.time ? e.time - a.time : e.command === a.command ? 0 : e.command === "noteOff" ? -1 : 1);
}
function rt(t) {
  return Number(t.toFixed(6));
}
function Un(t) {
  return {
    percussiveMelodic: Math.max(-1, Math.min(1, t.percussiveMelodic)),
    calmEnergetic: Math.max(-1, Math.min(1, t.calmEnergetic))
  };
}
function ot(t) {
  const { percussiveMelodic: e, calmEnergetic: a } = t, s = Math.max(0, -e), n = Math.max(0, e), o = Math.max(0, -a), r = Math.max(0, a);
  return {
    // ========================================
    // Percussive side (negative percussiveMelodic)
    // ========================================
    /**
     * percussiveLayering: Continuous strength based on percussive axis.
     * High values prefer drums with "percussive_layer", "four_on_floor" tags.
     */
    percussiveLayering: s,
    /**
     * syncopationBias: Continuous strength based on percussive axis.
     * High values prefer motifs with "syncopation" tags.
     */
    syncopationBias: s,
    /**
     * breakInsertion: Combined strength from both percussive and energetic axes.
     * Limited by the weaker of the two.
     */
    breakInsertion: Math.min(s, r),
    // ========================================
    // Melodic side (positive percussiveMelodic)
    // ========================================
    /**
     * harmonicStatic: Combined strength from melodic+calm or percussive+calm.
     * Takes the stronger of the two possible combinations.
     */
    harmonicStatic: Math.max(
      Math.min(n, o),
      Math.min(s, o)
    ),
    /**
     * atmosPad: Maximum of melodic, calm, or energetic strength.
     */
    atmosPad: Math.max(n, o, r),
    /**
     * filterMotion: Maximum of melodic or energetic strength.
     */
    filterMotion: Math.max(n, r),
    // ========================================
    // Calm side (negative calmEnergetic)
    // ========================================
    /**
     * loopCentric: Continuous strength based on calm axis.
     */
    loopCentric: o,
    /**
     * textureFocus: Strong calm OR percussive+calm combination.
     * The combo condition requires less calm strength, so it is amplified.
     */
    textureFocus: Math.max(o, Math.min(s, o * 2)),
    // ========================================
    // Energetic side (positive calmEnergetic)
    // ========================================
    /**
     * gradualBuild: Continuous strength based on energetic axis.
     */
    gradualBuild: r,
    /**
     * lofiFeel: Combined strength requiring both calm and melodic.
     * Limited by the weaker of the two.
     */
    lofiFeel: Math.min(o, n)
  };
}
function Vn(t) {
  return t.calmEnergetic < -0.4 ? "slow" : t.calmEnergetic > 0.4 ? "fast" : "medium";
}
function Wn(t) {
  const { percussiveMelodic: e, calmEnergetic: a } = t;
  return a <= -0.3 && e >= 0.2 || e <= -0.4 ? "minor" : (a >= 0.3, "major");
}
function jn(t) {
  const { percussiveMelodic: e, calmEnergetic: a } = t;
  let s = "medium";
  a > 0.4 && (s = "high"), a < -0.4 && (s = "low");
  let n = "upbeat";
  return a <= -0.5 ? n = "peaceful" : e <= -0.4 ? n = "tense" : e >= 0.4 ? n = "sad" : a >= 0.4 && (n = "upbeat"), { energy: s, mood: n };
}
const ue = [
  "textureFocus",
  "loopCentric",
  "gradualBuild",
  "harmonicStatic",
  "percussiveLayering",
  "breakInsertion",
  "filterMotion",
  "syncopationBias",
  "atmosPad",
  "lofiFeel"
], Yn = {
  textureFocus: 0,
  loopCentric: 0,
  gradualBuild: 0,
  harmonicStatic: 0,
  percussiveLayering: 0,
  breakInsertion: 0,
  filterMotion: 0,
  syncopationBias: 0,
  atmosPad: 0,
  lofiFeel: 0
}, zn = {
  percussiveMelodic: 0,
  calmEnergetic: 0
};
function At(t) {
  let e = t >>> 0;
  return e === 0 && (e = 1), () => (e = e * 1664525 + 1013904223 >>> 0, e / 4294967295);
}
function it(t, e) {
  if (!Object.values(t).every((r) => r <= 0)) return t;
  const s = At(e ^ 43981), n = ["loopCentric", "filterMotion", "atmosPad", "gradualBuild"], o = n[Math.floor(s() * n.length)];
  return { ...t, [o]: 1 };
}
function $n(t, e, a) {
  const s = { ...Yn };
  for (const n of ue) {
    const o = t[n];
    typeof o == "number" ? s[n] = Math.max(0, Math.min(1, o)) : a && e ? s[n] = e() : s[n] = 0;
  }
  return s;
}
function Jn(t, e) {
  const a = { ...t.intent };
  if (e.intent)
    for (const s of ue) {
      const n = e.intent[s];
      typeof n == "number" && (a[s] = Math.max(0, Math.min(1, n)));
    }
  return {
    tempo: e.tempo ?? t.tempo,
    intent: a,
    randomizeUnsetIntent: e.randomizeUnsetIntent ?? t.randomizeUnsetIntent
  };
}
function Xn(t) {
  var m, _;
  const e = typeof t.lengthInMeasures == "number" && t.lengthInMeasures > 0 ? Math.trunc(t.lengthInMeasures) : 32, a = typeof t.seed == "number" && Number.isFinite(t.seed) ? Math.trunc(t.seed) : Math.floor(Math.random() * 4294967295), s = t.twoAxisStyle ?? zn, n = Un(s);
  let o = ot(n);
  if (o = it(o, a), (m = t.overrides) != null && m.intent)
    for (const b of ue) {
      const S = t.overrides.intent[b];
      typeof S == "boolean" && (o[b] = S);
    }
  const r = Vn(n), l = jn(n), i = l.mood;
  let u = {
    tempo: r,
    intent: o,
    randomizeUnsetIntent: !0
  };
  t.overrides && (u = Jn(u, t.overrides));
  const c = u.randomizeUnsetIntent ?? !1, d = c ? At(a) : null, h = $n(u.intent, d, c);
  u = {
    ...u,
    intent: h,
    randomizeUnsetIntent: c
  };
  let g = { ...ot(n) };
  if (g = it(g, a), (_ = t.overrides) != null && _.intent)
    for (const b of ue) {
      const S = t.overrides.intent[b];
      typeof S == "number" && (g[b] = Math.max(0, Math.min(1, S)));
    }
  const v = t.mode ?? Wn(n), p = {
    mood: i,
    mode: v,
    axis: { ...n },
    tempo: u.tempo ?? "medium",
    lengthInMeasures: e,
    seed: a,
    stylePreset: t.preset ?? void 0,
    styleOverrides: g,
    sectionRepeatBias: t.sectionRepeatBias ?? ie
  }, y = {
    ...u,
    tags: {
      mood: l.mood,
      energy: l.energy
    },
    twoAxisStyle: { ...n }
  }, f = {
    lengthInMeasures: e,
    seed: a,
    twoAxisStyle: { ...n },
    sectionRepeatBias: t.sectionRepeatBias ?? ie
  };
  return t.overrides && (f.overrides = JSON.parse(JSON.stringify(t.overrides))), t.preset && (f.preset = t.preset), t.mode && (f.mode = t.mode), {
    pipeline: p,
    profile: y,
    replayOptions: f
  };
}
function Qn(t) {
  const { pipeline: e, profile: a, replayOptions: s } = er(t);
  return Zn(e, a, s);
}
function Zn(t, e, a) {
  const s = da(t), n = Es(t, s), o = un(t, s, n), r = yn(o, s.styleIntent, t.stylePreset), l = Nn(
    s,
    r.events,
    o.diagnostics,
    n.motifUsage,
    n.sectionMotifPlan,
    n.motifSelection
  ), u = t.lengthInMeasures * 4, c = u / s.bpm * 60, d = s.sections.map((h) => `${h.templateId}${h.measures}`).join("-");
  return {
    events: l.events,
    diagnostics: l.diagnostics,
    meta: {
      bpm: s.bpm,
      key: s.key,
      seed: t.seed,
      mood: t.mood,
      tempo: t.tempo,
      lengthInMeasures: t.lengthInMeasures,
      styleIntent: s.styleIntent,
      voiceArrangement: s.voiceArrangement,
      profile: e,
      replayOptions: a,
      sectionPattern: d,
      loopInfo: {
        loopStartBeat: 0,
        loopEndBeat: u,
        loopStartTime: 0,
        loopEndTime: c,
        totalBeats: u,
        totalDuration: c
      }
    }
  };
}
async function hr(t) {
  return Qn(t);
}
function er(t) {
  return Xn(t);
}
const tr = [
  {
    id: "SE_JUMP_01",
    type: "jump",
    description: "Light upward jump sound (square wave sweep)",
    tags: [
      "bright",
      "short",
      "retro"
    ],
    weight: 1.5,
    channels: [
      "square1"
    ],
    durationRange: [
      0.12,
      0.25
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 50,
          max: 62
        },
        pitchEnd: {
          min: 72,
          max: 84
        },
        dutyCycle: [
          0.25,
          0.5
        ],
        velocityRange: [
          96,
          122
        ]
      }
    },
    pitchSweep: {
      enabled: !0,
      curveOptions: [
        "linear",
        "exponential"
      ],
      durationRange: [
        0.14,
        0.26
      ]
    }
  },
  {
    id: "SE_JUMP_02",
    type: "jump",
    description: "Powerful jump sound (linear sweep, low-pitch start)",
    tags: [
      "heavy",
      "long",
      "retro"
    ],
    weight: 1,
    channels: [
      "square2"
    ],
    durationRange: [
      0.15,
      0.3
    ],
    channelParams: {
      square2: {
        pitchStart: {
          min: 40,
          max: 52
        },
        pitchEnd: {
          min: 64,
          max: 76
        },
        dutyCycle: [
          0.5
        ],
        velocityRange: [
          94,
          120
        ]
      }
    },
    pitchSweep: {
      enabled: !0,
      curveOptions: [
        "linear",
        "exponential"
      ],
      durationRange: [
        0.16,
        0.32
      ]
    }
  },
  {
    id: "SE_JUMP_03",
    type: "jump",
    description: "Spring jump sound (fast bright upward sweep)",
    tags: [
      "bright",
      "short",
      "retro"
    ],
    weight: 1,
    channels: [
      "square1"
    ],
    durationRange: [
      0.1,
      0.18
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 56,
          max: 64
        },
        pitchEnd: {
          min: 84,
          max: 96
        },
        dutyCycle: [
          0.125,
          0.25
        ],
        velocityRange: [
          98,
          124
        ]
      }
    },
    pitchSweep: {
      enabled: !0,
      curveOptions: [
        "exponential"
      ],
      durationRange: [
        0.1,
        0.18
      ]
    }
  },
  {
    id: "SE_JUMP_04",
    type: "jump",
    description: "Low-gravity jump sound (soft triangle upward sweep)",
    tags: [
      "soft",
      "long"
    ],
    weight: 0.7,
    channels: [
      "triangle"
    ],
    durationRange: [
      0.24,
      0.38
    ],
    channelParams: {
      triangle: {
        pitchStart: {
          min: 45,
          max: 55
        },
        pitchEnd: {
          min: 67,
          max: 79
        },
        velocityRange: [
          82,
          108
        ]
      }
    },
    pitchSweep: {
      enabled: !0,
      curveOptions: [
        "linear",
        "exponential"
      ],
      durationRange: [
        0.24,
        0.38
      ]
    }
  },
  {
    id: "SE_COIN_01",
    type: "coin",
    description: "Sparkling coin collection sound (2-note arpeggio)",
    tags: [
      "bright",
      "pickup",
      "short"
    ],
    weight: 1.5,
    channels: [
      "square1"
    ],
    durationRange: [
      0.18,
      0.24
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 72,
          max: 84
        },
        dutyCycle: [
          0.5
        ],
        velocityRange: [
          102,
          124
        ]
      }
    },
    noteSequence: {
      intervals: [
        0,
        4
      ],
      noteDurations: [
        0.04,
        0.16
      ]
    }
  },
  {
    id: "SE_COIN_02",
    type: "coin",
    description: "Super Mario-style coin sound (3-note arpeggio, high-pitch)",
    tags: [
      "bright",
      "pickup",
      "retro"
    ],
    weight: 1,
    channels: [
      "square1"
    ],
    durationRange: [
      0.2,
      0.28
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 76,
          max: 84
        },
        dutyCycle: [
          0.5
        ],
        velocityRange: [
          98,
          120
        ]
      }
    },
    noteSequence: {
      intervals: [
        0,
        4,
        12
      ],
      noteDurations: [
        0.04,
        0.04,
        0.16
      ]
    }
  },
  {
    id: "SE_COIN_03",
    type: "coin",
    description: "Delayed sparkle pickup sound (wide arpeggio)",
    tags: [
      "pickup",
      "bright",
      "retro"
    ],
    weight: 1,
    channels: [
      "square2"
    ],
    durationRange: [
      0.2,
      0.3
    ],
    channelParams: {
      square2: {
        pitchStart: {
          min: 74,
          max: 82
        },
        dutyCycle: [
          0.25,
          0.5
        ],
        velocityRange: [
          120,
          127
        ]
      }
    },
    noteSequence: {
      intervals: [
        0,
        7,
        12
      ],
      noteDurations: [
        0.03,
        0.05,
        0.14
      ]
    }
  },
  {
    id: "SE_COIN_04",
    type: "coin",
    description: "Lower-pitch pickup sound (compact major arpeggio)",
    tags: [
      "pickup",
      "soft",
      "short"
    ],
    weight: 0.7,
    channels: [
      "square1"
    ],
    durationRange: [
      0.16,
      0.24
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 64,
          max: 72
        },
        dutyCycle: [
          0.25
        ],
        envelope: "pluck",
        velocityRange: [
          90,
          116
        ]
      }
    },
    noteSequence: {
      intervals: [
        0,
        3,
        7
      ],
      noteDurations: [
        0.04,
        0.04,
        0.1
      ]
    }
  },
  {
    id: "SE_EXPLOSION_01",
    type: "explosion",
    description: "Impact explosion sound (noise + triangle bass sweep, linear)",
    tags: [
      "heavy",
      "long",
      "combat"
    ],
    weight: 1,
    channels: [
      "noise",
      "triangle"
    ],
    durationRange: [
      0.8,
      1.2
    ],
    channelParams: {
      noise: {
        noiseMode: "long",
        envelope: "percussive",
        velocityRange: [
          92,
          120
        ],
        releaseRange: [
          0.5,
          0.8
        ]
      },
      triangle: {
        pitchStart: {
          min: 36,
          max: 43
        },
        pitchEnd: {
          min: 24,
          max: 31
        },
        envelope: "percussive",
        velocityRange: [
          78,
          104
        ],
        startOffsetRange: [
          0.01,
          0.025
        ]
      }
    },
    pitchSweep: {
      enabled: !0,
      curveType: "linear"
    }
  },
  {
    id: "SE_EXPLOSION_02",
    type: "explosion",
    description: "Short explosion sound (noise only, high-frequency)",
    tags: [
      "short",
      "combat",
      "bright"
    ],
    weight: 1.5,
    channels: [
      "noise"
    ],
    durationRange: [
      0.4,
      0.6
    ],
    channelParams: {
      noise: {
        noiseMode: "short",
        envelope: "percussive",
        velocityRange: [
          90,
          118
        ],
        releaseRange: [
          0.22,
          0.4
        ]
      }
    }
  },
  {
    id: "SE_EXPLOSION_03",
    type: "explosion",
    description: "Noisy crumble explosion (long noise with falling triangle, exponential sweep)",
    tags: [
      "heavy",
      "long",
      "combat"
    ],
    weight: 0.8,
    channels: [
      "noise",
      "triangle"
    ],
    durationRange: [
      0.65,
      0.95
    ],
    channelParams: {
      noise: {
        noiseMode: "long",
        envelope: "percussive",
        velocityRange: [
          86,
          112
        ],
        releaseRange: [
          0.42,
          0.7
        ]
      },
      triangle: {
        pitchStart: {
          min: 31,
          max: 38
        },
        pitchEnd: {
          min: 18,
          max: 26
        },
        envelope: "percussive",
        velocityRange: [
          82,
          106
        ],
        startOffsetRange: [
          0.015,
          0.035
        ]
      }
    },
    pitchSweep: {
      enabled: !0,
      curveType: "exponential"
    }
  },
  {
    id: "SE_EXPLOSION_04",
    type: "explosion",
    description: "Compact impact explosion (noise burst plus square punch)",
    tags: [
      "short",
      "heavy",
      "combat"
    ],
    weight: 1,
    channels: [
      "noise",
      "square1"
    ],
    durationRange: [
      0.18,
      0.32
    ],
    channelParams: {
      noise: {
        noiseMode: "short",
        envelope: "percussive",
        velocityRange: [
          98,
          124
        ],
        releaseRange: [
          0.16,
          0.28
        ]
      },
      square1: {
        pitchStart: {
          min: 34,
          max: 43
        },
        dutyCycle: [
          0.125
        ],
        envelope: "percussive",
        velocityRange: [
          86,
          108
        ],
        startOffsetRange: [
          6e-3,
          0.018
        ]
      }
    }
  },
  {
    id: "SE_HIT_01",
    type: "hit",
    description: "Damage sound (short descending arpeggio)",
    tags: [
      "short",
      "combat",
      "retro"
    ],
    weight: 1.5,
    channels: [
      "square1"
    ],
    durationRange: [
      0.08,
      0.12
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 60,
          max: 72
        },
        dutyCycle: [
          0.125
        ],
        envelope: "percussive",
        velocityRange: [
          100,
          126
        ]
      }
    },
    noteSequence: {
      intervals: [
        0,
        -2,
        -5
      ],
      noteDurations: [
        0.03,
        0.03,
        0.03
      ]
    }
  },
  {
    id: "SE_HIT_02",
    type: "hit",
    description: "Sharp damage sound (noise + square wave combo)",
    tags: [
      "bright",
      "combat",
      "short"
    ],
    weight: 1,
    channels: [
      "square1",
      "noise"
    ],
    durationRange: [
      0.1,
      0.15
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 48,
          max: 60
        },
        dutyCycle: [
          0.125
        ],
        velocityRange: [
          70,
          94
        ]
      },
      noise: {
        noiseMode: "short",
        envelope: "percussive",
        velocityRange: [
          94,
          120
        ],
        releaseRange: [
          0.12,
          0.2
        ],
        startOffsetRange: [
          4e-3,
          0.014
        ]
      }
    }
  },
  {
    id: "SE_HIT_03",
    type: "hit",
    description: "Low thud damage sound (triangle downward sweep)",
    tags: [
      "heavy",
      "combat",
      "short"
    ],
    weight: 1,
    channels: [
      "triangle"
    ],
    durationRange: [
      0.1,
      0.18
    ],
    channelParams: {
      triangle: {
        pitchStart: {
          min: 43,
          max: 52
        },
        pitchEnd: {
          min: 31,
          max: 38
        },
        velocityRange: [
          94,
          118
        ]
      }
    },
    pitchSweep: {
      enabled: !0,
      curveType: "linear",
      durationRange: [
        0.08,
        0.16
      ]
    }
  },
  {
    id: "SE_HIT_04",
    type: "hit",
    description: "Noise bite damage sound (short percussive burst)",
    tags: [
      "bright",
      "combat",
      "short"
    ],
    weight: 0.7,
    channels: [
      "noise"
    ],
    durationRange: [
      0.05,
      0.09
    ],
    channelParams: {
      noise: {
        noiseMode: "short",
        envelope: "percussive",
        velocityRange: [
          102,
          126
        ],
        releaseRange: [
          0.04,
          0.08
        ]
      }
    }
  },
  {
    id: "SE_POWERUP_01",
    type: "powerup",
    description: "Power-up sound (ascending arpeggio, fast)",
    tags: [
      "pickup",
      "bright",
      "short"
    ],
    weight: 1.5,
    channels: [
      "square1"
    ],
    durationRange: [
      0.24,
      0.32
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 60,
          max: 67
        },
        dutyCycle: [
          0.5
        ],
        velocityRange: [
          92,
          116
        ]
      }
    },
    noteSequence: {
      intervals: [
        0,
        3,
        5,
        7,
        10,
        12
      ],
      noteDurations: [
        0.04,
        0.04,
        0.04,
        0.04,
        0.04,
        0.08
      ]
    }
  },
  {
    id: "SE_POWERUP_02",
    type: "powerup",
    description: "Bright power-up sound (fast arpeggio, high-pitch)",
    tags: [
      "pickup",
      "bright",
      "retro"
    ],
    weight: 1,
    channels: [
      "square2"
    ],
    durationRange: [
      0.28,
      0.36
    ],
    channelParams: {
      square2: {
        pitchStart: {
          min: 64,
          max: 72
        },
        dutyCycle: [
          0.25
        ],
        velocityRange: [
          88,
          112
        ]
      }
    },
    noteSequence: {
      intervals: [
        0,
        2,
        4,
        7,
        9,
        12,
        16
      ],
      noteDurations: [
        0.04,
        0.04,
        0.04,
        0.04,
        0.04,
        0.04,
        0.08
      ]
    }
  },
  {
    id: "SE_POWERUP_03",
    type: "powerup",
    description: "Two-channel shimmer power-up arpeggio",
    tags: [
      "pickup",
      "bright",
      "long"
    ],
    weight: 0.8,
    channels: [
      "square1",
      "square2"
    ],
    durationRange: [
      0.32,
      0.44
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 60,
          max: 67
        },
        dutyCycle: [
          0.25
        ],
        velocityRange: [
          88,
          110
        ]
      },
      square2: {
        pitchStart: {
          min: 72,
          max: 79
        },
        dutyCycle: [
          0.125
        ],
        velocityRange: [
          76,
          100
        ],
        startOffsetRange: [
          0.018,
          0.035
        ]
      }
    },
    noteSequence: {
      intervals: [
        0,
        4,
        7,
        12
      ],
      noteDurations: [
        0.07,
        0.07,
        0.07,
        0.14
      ]
    }
  },
  {
    id: "SE_POWERUP_04",
    type: "powerup",
    description: "Soft confirm power-up sound (triangle arpeggio)",
    tags: [
      "pickup",
      "soft",
      "long"
    ],
    weight: 0.7,
    channels: [
      "triangle"
    ],
    durationRange: [
      0.26,
      0.38
    ],
    channelParams: {
      triangle: {
        pitchStart: {
          min: 55,
          max: 64
        },
        velocityRange: [
          78,
          104
        ]
      }
    },
    noteSequence: {
      intervals: [
        0,
        5,
        9,
        12
      ],
      noteDurations: [
        0.06,
        0.06,
        0.06,
        0.12
      ]
    }
  },
  {
    id: "SE_SELECT_01",
    type: "select",
    description: "Menu selection sound (short single tone)",
    tags: [
      "ui",
      "short",
      "soft"
    ],
    weight: 1.5,
    channels: [
      "square1"
    ],
    durationRange: [
      0.05,
      0.08
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 72,
          max: 84
        },
        dutyCycle: [
          0.25
        ],
        velocityRange: [
          80,
          106
        ]
      }
    }
  },
  {
    id: "SE_SELECT_02",
    type: "select",
    description: "Selection sound (2-note ascending arpeggio)",
    tags: [
      "ui",
      "bright",
      "short"
    ],
    weight: 1,
    channels: [
      "square1"
    ],
    durationRange: [
      0.06,
      0.1
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 72,
          max: 84
        },
        dutyCycle: [
          0.5
        ],
        velocityRange: [
          82,
          108
        ]
      }
    },
    noteSequence: {
      intervals: [
        0,
        4
      ],
      noteDurations: [
        0.03,
        0.04
      ]
    }
  },
  {
    id: "SE_SELECT_03",
    type: "select",
    description: "Cancel selection sound (soft descending pair)",
    tags: [
      "ui",
      "soft",
      "short"
    ],
    weight: 1,
    channels: [
      "square2"
    ],
    durationRange: [
      0.06,
      0.1
    ],
    channelParams: {
      square2: {
        pitchStart: {
          min: 67,
          max: 76
        },
        dutyCycle: [
          0.25
        ],
        velocityRange: [
          76,
          100
        ]
      }
    },
    noteSequence: {
      intervals: [
        0,
        -3
      ],
      noteDurations: [
        0.03,
        0.04
      ]
    }
  },
  {
    id: "SE_SELECT_04",
    type: "select",
    description: "Disabled selection sound (low muted triangle)",
    tags: [
      "ui",
      "soft",
      "short"
    ],
    weight: 0.7,
    channels: [
      "triangle"
    ],
    durationRange: [
      0.08,
      0.12
    ],
    channelParams: {
      triangle: {
        pitchStart: {
          min: 48,
          max: 57
        },
        velocityRange: [
          96,
          122
        ]
      }
    }
  },
  {
    id: "SE_LASER_01",
    type: "laser",
    description: "Laser fire sound (fast descending sweep)",
    tags: [
      "combat",
      "short",
      "bright"
    ],
    weight: 1.5,
    channels: [
      "square1"
    ],
    durationRange: [
      0.1,
      0.15
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 72,
          max: 84
        },
        pitchEnd: {
          min: 48,
          max: 60
        },
        dutyCycle: [
          0.125,
          0.25
        ],
        velocityRange: [
          90,
          116
        ]
      }
    },
    pitchSweep: {
      enabled: !0,
      curveType: "exponential"
    }
  },
  {
    id: "SE_LASER_02",
    type: "laser",
    description: "Laser fire sound (linear descending sweep)",
    tags: [
      "combat",
      "long",
      "retro"
    ],
    weight: 1,
    channels: [
      "square2"
    ],
    durationRange: [
      0.12,
      0.2
    ],
    channelParams: {
      square2: {
        pitchStart: {
          min: 76,
          max: 88
        },
        pitchEnd: {
          min: 52,
          max: 64
        },
        dutyCycle: [
          0.125
        ],
        velocityRange: [
          88,
          114
        ]
      }
    },
    pitchSweep: {
      enabled: !0,
      curveType: "linear"
    }
  },
  {
    id: "SE_LASER_03",
    type: "laser",
    description: "Charge shot sound (upward square sweep)",
    tags: [
      "combat",
      "long",
      "bright"
    ],
    weight: 0.8,
    channels: [
      "square1"
    ],
    durationRange: [
      0.22,
      0.34
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 48,
          max: 60
        },
        pitchEnd: {
          min: 76,
          max: 88
        },
        dutyCycle: [
          0.25,
          0.5
        ],
        velocityRange: [
          86,
          112
        ]
      }
    },
    pitchSweep: {
      enabled: !0,
      curveType: "exponential",
      durationRange: [
        0.2,
        0.32
      ]
    }
  },
  {
    id: "SE_LASER_04",
    type: "laser",
    description: "Noisy blaster sound (square sweep plus noise snap)",
    tags: [
      "combat",
      "short",
      "retro"
    ],
    weight: 0.7,
    channels: [
      "square2",
      "noise"
    ],
    durationRange: [
      0.12,
      0.18
    ],
    channelParams: {
      square2: {
        pitchStart: {
          min: 69,
          max: 81
        },
        pitchEnd: {
          min: 43,
          max: 55
        },
        dutyCycle: [
          0.125
        ],
        velocityRange: [
          92,
          118
        ]
      },
      noise: {
        noiseMode: "short",
        envelope: "percussive",
        velocityRange: [
          70,
          96
        ],
        releaseRange: [
          0.04,
          0.08
        ],
        startOffsetRange: [
          6e-3,
          0.016
        ]
      }
    },
    pitchSweep: {
      enabled: !0,
      curveType: "exponential",
      durationRange: [
        0.1,
        0.16
      ]
    }
  },
  {
    id: "SE_CLICK_01",
    type: "click",
    description: "Crisp UI click (narrow duty-cycle, high-pitch)",
    tags: [
      "ui",
      "short",
      "bright"
    ],
    weight: 1.5,
    channels: [
      "square1"
    ],
    durationRange: [
      0.02,
      0.03
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 84,
          max: 96
        },
        dutyCycle: [
          0.125
        ],
        envelope: "percussive",
        velocityRange: [
          84,
          112
        ]
      }
    }
  },
  {
    id: "SE_CLICK_02",
    type: "click",
    description: "Soft UI click (round duty-cycle, lower pitch)",
    tags: [
      "ui",
      "short",
      "soft"
    ],
    weight: 1,
    channels: [
      "square1"
    ],
    durationRange: [
      0.03,
      0.04
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 72,
          max: 84
        },
        dutyCycle: [
          0.5
        ],
        envelope: "percussive",
        velocityRange: [
          70,
          96
        ]
      }
    }
  },
  {
    id: "SE_CLICK_03",
    type: "click",
    description: "Low UI click sound (muted square tick)",
    tags: [
      "ui",
      "soft",
      "short"
    ],
    weight: 1,
    channels: [
      "square2"
    ],
    durationRange: [
      0.025,
      0.04
    ],
    channelParams: {
      square2: {
        pitchStart: {
          min: 66,
          max: 78
        },
        dutyCycle: [
          0.125
        ],
        envelope: "percussive",
        velocityRange: [
          72,
          98
        ]
      }
    }
  },
  {
    id: "SE_CLICK_04",
    type: "click",
    description: "Noise tick click sound",
    tags: [
      "ui",
      "bright",
      "short"
    ],
    weight: 0.7,
    channels: [
      "noise"
    ],
    durationRange: [
      0.015,
      0.03
    ],
    channelParams: {
      noise: {
        noiseMode: "short",
        envelope: "snap",
        velocityRange: [
          62,
          88
        ],
        releaseRange: [
          0.012,
          0.025
        ]
      }
    }
  },
  {
    id: "SE_SYNTH_01",
    type: "synth",
    description: "Synth single tone (square wave, sustained)",
    tags: [
      "retro",
      "bright",
      "long"
    ],
    weight: 1.5,
    channels: [
      "square1"
    ],
    durationRange: [
      0.15,
      0.3
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 48,
          max: 72
        },
        dutyCycle: [
          0.125,
          0.25,
          0.5
        ],
        envelope: "sustained",
        velocityRange: [
          86,
          114
        ]
      }
    }
  },
  {
    id: "SE_SYNTH_02",
    type: "synth",
    description: "Synth single tone (triangle wave, sustained)",
    tags: [
      "soft",
      "long",
      "retro"
    ],
    weight: 1,
    channels: [
      "triangle"
    ],
    durationRange: [
      0.2,
      0.4
    ],
    channelParams: {
      triangle: {
        pitchStart: {
          min: 60,
          max: 84
        },
        envelope: "sustained",
        velocityRange: [
          80,
          108
        ]
      }
    }
  },
  {
    id: "SE_SYNTH_03",
    type: "synth",
    description: "Pulse-width synth tone (variable duty-cycle, sustained)",
    tags: [
      "retro",
      "bright",
      "long"
    ],
    weight: 0.8,
    channels: [
      "square2"
    ],
    durationRange: [
      0.18,
      0.36
    ],
    channelParams: {
      square2: {
        pitchStart: {
          min: 50,
          max: 74
        },
        dutyCycleRange: {
          min: 0.125,
          max: 0.5
        },
        envelope: "sustained",
        velocityRange: [
          84,
          112
        ]
      }
    }
  },
  {
    id: "SE_SYNTH_04",
    type: "synth",
    description: "Layered short synth tone (square plus triangle)",
    tags: [
      "retro",
      "soft",
      "short"
    ],
    weight: 0.7,
    channels: [
      "square1",
      "triangle"
    ],
    durationRange: [
      0.12,
      0.24
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 55,
          max: 67
        },
        dutyCycle: [
          0.25
        ],
        envelope: "sustained",
        velocityRange: [
          72,
          96
        ]
      },
      triangle: {
        pitchStart: {
          min: 43,
          max: 55
        },
        envelope: "fade",
        velocityRange: [
          76,
          102
        ],
        startOffsetRange: [
          0.012,
          0.03
        ]
      }
    }
  },
  {
    id: "SE_TONE_01",
    type: "tone",
    description: "Basic tone (square wave, mid-range, sustained)",
    tags: [
      "retro",
      "bright",
      "short"
    ],
    weight: 1.5,
    channels: [
      "square1"
    ],
    durationRange: [
      0.1,
      0.2
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 60,
          max: 72
        },
        dutyCycle: [
          0.5
        ],
        envelope: "sustained",
        velocityRange: [
          84,
          112
        ]
      }
    }
  },
  {
    id: "SE_TONE_02",
    type: "tone",
    description: "Basic tone (triangle wave, mid-range, sustained)",
    tags: [
      "soft",
      "long",
      "retro"
    ],
    weight: 1,
    channels: [
      "triangle"
    ],
    durationRange: [
      0.12,
      0.3
    ],
    channelParams: {
      triangle: {
        pitchStart: {
          min: 60,
          max: 72
        },
        envelope: "sustained",
        velocityRange: [
          76,
          104
        ]
      }
    }
  },
  {
    id: "SE_TONE_03",
    type: "tone",
    description: "Pulse tone (narrow duty square wave, sustained)",
    tags: [
      "retro",
      "bright",
      "short"
    ],
    weight: 1,
    channels: [
      "square2"
    ],
    durationRange: [
      0.08,
      0.16
    ],
    channelParams: {
      square2: {
        pitchStart: {
          min: 57,
          max: 76
        },
        dutyCycle: [
          0.125,
          0.25
        ],
        envelope: "sustained",
        velocityRange: [
          82,
          108
        ]
      }
    }
  },
  {
    id: "SE_TONE_04",
    type: "tone",
    description: "Low soft triangle tone (fade envelope)",
    tags: [
      "soft",
      "long"
    ],
    weight: 0.7,
    channels: [
      "triangle"
    ],
    durationRange: [
      0.18,
      0.36
    ],
    channelParams: {
      triangle: {
        pitchStart: {
          min: 43,
          max: 60
        },
        envelope: "fade",
        velocityRange: [
          70,
          98
        ]
      }
    }
  },
  {
    id: "SE_JUMP_05",
    type: "jump",
    description: "NES hardware sweep jump - rapid pitch rise via APU sweep unit",
    tags: [
      "retro",
      "bright",
      "short"
    ],
    weight: 1,
    channels: [
      "square1"
    ],
    durationRange: [
      0.15,
      0.28
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 60,
          max: 72
        },
        dutyCycleRange: {
          min: 0.25,
          max: 0.5
        },
        envelope: "percussive",
        velocityRange: [
          100,
          127
        ]
      }
    },
    hardwareSweep: {
      enabled: !0,
      period: 1,
      shift: 2,
      negate: !0
    }
  },
  {
    id: "SE_HIT_05",
    type: "hit",
    description: "NES hardware sweep hit - sharp pitch drop via APU sweep unit",
    tags: [
      "retro",
      "combat",
      "short"
    ],
    weight: 1,
    channels: [
      "square1"
    ],
    durationRange: [
      0.1,
      0.2
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 66,
          max: 78
        },
        dutyCycle: [
          0.125,
          0.25
        ],
        envelope: "percussive",
        velocityRange: [
          96,
          122
        ]
      }
    },
    hardwareSweep: {
      enabled: !0,
      period: 1,
      shift: 3,
      negate: !1
    }
  },
  {
    id: "SE_LASER_05",
    type: "laser",
    description: "NES hardware sweep laser - fast pitch fall then auto-mute via APU sweep unit",
    tags: [
      "retro",
      "combat",
      "bright"
    ],
    weight: 1,
    channels: [
      "square1"
    ],
    durationRange: [
      0.08,
      0.18
    ],
    channelParams: {
      square1: {
        pitchStart: {
          min: 72,
          max: 84
        },
        dutyCycle: [
          0.125,
          0.25
        ],
        envelope: "percussive",
        velocityRange: [
          90,
          116
        ]
      }
    },
    hardwareSweep: {
      enabled: !0,
      period: 0,
      shift: 3,
      negate: !1
    }
  }
], ar = {
  templates: tr
};
function sr() {
  return ar.templates;
}
function nr(t) {
  let e = t >>> 0;
  return e === 0 && (e = 1), () => (e = e * 1664525 + 1013904223 >>> 0, e / 4294967295);
}
class gr {
  constructor() {
    this.templates = sr();
  }
  /**
   * Generates a sound effect based on type and optional template selection.
   *
   * The generation process:
   * 1. Select template (specific templateId or random from type)
   * 2. Sample parameters from template ranges (duration, pitch, velocity, etc.)
   * 3. Generate event list (noteOn/noteOff pairs with sampled parameters)
   * 4. Return events + metadata for playback
   *
   * @param options - SE generation options (type, seed, templateId, startTime)
   * @returns SE result with events, metadata, and replay options
   */
  generateSE(e) {
    const a = e.seed ?? Math.floor(Math.random() * 1e9), s = nr(a), n = this.selectTemplate(e, s), o = this.concretizeParameters(
      n,
      s,
      e.baseFrequency,
      e.quantizeToChord,
      e.velocityScale ?? 1
    ), r = this.generateEvents(n, o, e.startTime ?? 0), l = this.calculateEventDuration(r, e.startTime ?? 0, o.duration), i = {
      type: e.type,
      seed: a,
      startTime: e.startTime ?? 0
    };
    return e.templateId && (i.templateId = e.templateId), e.baseFrequency !== void 0 && (i.baseFrequency = e.baseFrequency), e.quantizeToChord !== void 0 && (i.quantizeToChord = e.quantizeToChord), e.variantIntent !== void 0 && (i.variantIntent = e.variantIntent), e.velocityScale !== void 0 && (i.velocityScale = e.velocityScale), {
      events: r,
      meta: {
        type: e.type,
        templateId: n.id,
        seed: a,
        duration: l,
        channels: n.channels,
        replayOptions: i
      }
    };
  }
  selectTemplate(e, a) {
    if (e.templateId) {
      const n = this.templates.find((o) => o.id === e.templateId);
      if (!n) throw new Error(`Template not found: ${e.templateId}`);
      return n;
    }
    let s = this.templates.filter((n) => n.type === e.type);
    if (s.length === 0)
      throw new Error(`No templates found for type: ${e.type}`);
    if (e.variantIntent) {
      const n = s.filter((o) => {
        var r;
        return (r = o.tags) == null ? void 0 : r.includes(e.variantIntent);
      });
      n.length > 0 && (s = n);
    }
    return this.weightedTemplateChoice(s, a);
  }
  concretizeParameters(e, a, s, n, o = 1) {
    var h;
    const [r, l] = e.durationRange, i = r + a() * (l - r), u = {};
    let c = 0, d = 0;
    s !== void 0 && (d = this.calculatePitchShift(e, s));
    for (const g of e.channels) {
      const v = e.channelParams[g];
      if (!v) continue;
      const p = v.velocityRange ? v.velocityRange : g === "noise" ? [88, 118] : [96, 122], y = g === "square1" || g === "square2" ? 0.8 : g === "noise" ? 0.85 : 1, f = Math.round(
        Math.max(1, Math.min(127, this.sampleFloatRange(p, a) * o * y))
      ), m = v.startOffsetRange ? this.sampleFloatRange(v.startOffsetRange, a) : 0;
      c = Math.max(c, m);
      const _ = v.pitchStart ? this.samplePitchRange(v.pitchStart, a) : void 0, b = v.pitchEnd ? this.samplePitchRange(v.pitchEnd, a) : void 0;
      if (u[g] = {
        pitchStart: _ !== void 0 ? this.resolvePitch(_, d, n) : void 0,
        pitchEnd: b !== void 0 ? this.resolvePitch(b, d, n) : void 0,
        dutyCycle: v.dutyCycleRange ? this.sampleFloatRange([v.dutyCycleRange.min, v.dutyCycleRange.max], a) : v.dutyCycle ? v.dutyCycle[Math.floor(a() * v.dutyCycle.length)] : void 0,
        noiseMode: v.noiseMode,
        envelope: v.envelope,
        velocity: f,
        startOffset: m,
        releaseSeconds: v.releaseRange ? this.sampleFloatRange(v.releaseRange, a) : void 0
      }, (h = e.pitchSweep) != null && h.enabled) {
        const S = e.pitchSweep.curveOptions ?? (e.pitchSweep.curveType ? [e.pitchSweep.curveType] : void 0);
        S && (u[g].sweepCurve = this.weightedChoice(
          S,
          e.pitchSweep.curveWeights,
          a
        ) ?? e.pitchSweep.curveType), e.pitchSweep.durationRange && (u[g].sweepDuration = this.sampleFloatRange(e.pitchSweep.durationRange, a));
      }
    }
    return { duration: i + c, baseDuration: i, channelParams: u };
  }
  samplePitchRange(e, a) {
    return Math.floor(e.min + a() * (e.max - e.min + 1));
  }
  sampleFloatRange(e, a) {
    return e[0] + a() * (e[1] - e[0]);
  }
  /**
   * Select an option from an array using weighted probabilities.
   * @param options - Array of options to choose from
   * @param weights - Record mapping option string to weight (default: equal weights)
   * @param rng - Random number generator
   * @returns Selected option
   */
  weightedChoice(e, a, s) {
    if (!a)
      return e[Math.floor(s() * e.length)];
    const n = e.reduce((r, l) => r + (a[String(l)] || 1), 0);
    let o = s() * n;
    for (const r of e) {
      const l = a[String(r)] || 1;
      if (o < l) return r;
      o -= l;
    }
    return e[e.length - 1];
  }
  weightedTemplateChoice(e, a) {
    const s = e.reduce((o, r) => o + (r.weight ?? 1), 0);
    let n = a() * s;
    for (const o of e) {
      const r = o.weight ?? 1;
      if (n < r) return o;
      n -= r;
    }
    return e[e.length - 1];
  }
  calculateEventDuration(e, a, s) {
    if (e.length === 0)
      return s;
    const n = e.reduce((o, r) => Math.max(o, r.time), a);
    return Math.max(0, n - a);
  }
  generateEvents(e, a, s) {
    const n = [];
    for (const o of e.channels) {
      const r = a.channelParams[o], l = this.generateChannelEvents(
        o,
        e,
        r,
        a,
        s + (r.startOffset ?? 0)
      );
      n.push(...l);
    }
    return n.sort((o, r) => o.time - r.time), n;
  }
  /**
   * チャンネル別にイベントを生成
   */
  generateChannelEvents(e, a, s, n, o) {
    return e.startsWith("square") ? this.generateSquareEvents(e, a, s, n, o) : e === "triangle" ? this.generateTriangleEvents(e, a, s, n, o) : e === "noise" ? this.generateNoiseEvents(a, s, n, o) : [];
  }
  /**
   * Square チャンネルのイベント生成
   */
  generateSquareEvents(e, a, s, n, o) {
    var l, i;
    const r = [];
    return s.dutyCycle !== void 0 && r.push({
      time: o,
      channel: e,
      command: "setParam",
      data: { param: "duty", value: s.dutyCycle }
    }), a.noteSequence ? r.push(...this.generateNoteSequence(e, a, s, o)) : (l = a.hardwareSweep) != null && l.enabled ? r.push(...this.generateHardwareSweep(e, a, s, n, o)) : (i = a.pitchSweep) != null && i.enabled ? r.push(...this.generatePitchSweep(e, a, s, n, o)) : s.pitchStart !== void 0 && r.push(...this.generateSimpleNote(e, s, n.baseDuration, o)), r;
  }
  /**
   * Triangle チャンネルのイベント生成
   */
  generateTriangleEvents(e, a, s, n, o) {
    var l;
    const r = [];
    return a.noteSequence ? r.push(...this.generateNoteSequence(e, a, s, o)) : (l = a.pitchSweep) != null && l.enabled ? r.push(...this.generatePitchSweep(e, a, s, n, o)) : s.pitchStart !== void 0 && r.push(...this.generateSimpleNote(e, s, n.baseDuration, o)), r;
  }
  /**
   * Noise チャンネルのイベント生成
   */
  generateNoiseEvents(e, a, s, n) {
    const o = [], r = "noise";
    a.noiseMode && o.push({
      time: n,
      channel: r,
      command: "setParam",
      data: { param: "noiseMode", value: a.noiseMode }
    });
    const l = a.velocity ?? 110, i = a.releaseSeconds ?? s.baseDuration * 0.3, u = { velocity: l };
    return a.noiseMode && (u.noiseMode = a.noiseMode), Object.assign(
      u,
      this.resolveEnvelopeData(a, s.baseDuration, i)
    ), o.push({
      time: n,
      channel: r,
      command: "noteOn",
      data: u
    }), o.push({
      time: n + s.baseDuration,
      channel: r,
      command: "noteOff",
      data: {}
    }), o;
  }
  /**
   * ノートシーケンス生成（アルペジオ等）
   */
  generateNoteSequence(e, a, s, n) {
    const o = [];
    if (!a.noteSequence) return o;
    let r = n;
    const l = s.pitchStart, i = s.velocity ?? 110;
    for (let u = 0; u < a.noteSequence.intervals.length; u++) {
      const c = l + a.noteSequence.intervals[u], d = a.noteSequence.noteDurations[u];
      o.push({
        time: r,
        channel: e,
        command: "noteOn",
        data: { midi: c, velocity: i }
      }), o.push({
        time: r + d,
        channel: e,
        command: "noteOff",
        data: this.resolveNoteOffData(s, d)
      }), r += d;
    }
    return o;
  }
  /**
   * ピッチスイープ生成
   */
  generatePitchSweep(e, a, s, n, o) {
    var c;
    const r = [];
    if (!((c = a.pitchSweep) != null && c.enabled)) return r;
    const l = s.sweepDuration ?? n.baseDuration, i = s.sweepCurve ?? a.pitchSweep.curveType ?? "exponential", u = s.velocity ?? 110;
    return r.push({
      time: o,
      channel: e,
      command: "noteOn",
      data: { midi: s.pitchStart, velocity: u }
    }), r.push({
      time: o,
      channel: e,
      command: "setParam",
      data: {
        param: "pitchBend",
        value: s.pitchEnd,
        rampDuration: l,
        curve: i
      }
    }), r.push({
      time: o + l,
      channel: e,
      command: "noteOff",
      data: this.resolveNoteOffData(s, l)
    }), r;
  }
  /**
   * NES APU ハードウェアスウィープ SE 生成
   *
   * noteOn 後すぐに setSweep を送り、APU sweep unit を起動する。
   * negate=true ならピッチ上昇（period 縮小）、false なら下降（period 拡大）。
   * period が [8, 0x7FF] を外れるとワークレット側が自動ミュートする。
   * noteOff は duration 後に送り、チャンネルとスウィープ状態を解放する。
   */
  generateHardwareSweep(e, a, s, n, o) {
    var c;
    const r = [];
    if (!((c = a.hardwareSweep) != null && c.enabled)) return r;
    const l = a.hardwareSweep, i = n.baseDuration, u = s.velocity ?? 110;
    return r.push({
      time: o,
      channel: e,
      command: "noteOn",
      data: { midi: s.pitchStart, velocity: u }
    }), r.push({
      time: o,
      channel: e,
      command: "setParam",
      data: {
        param: "sweep",
        enabled: !0,
        period: l.period,
        shift: l.shift,
        negate: l.negate
      }
    }), r.push({
      time: o + i,
      channel: e,
      command: "noteOff",
      data: {}
    }), r;
  }
  /**
   * 単純なノート生成（エンベロープのみ）
   */
  generateSimpleNote(e, a, s, n) {
    const o = [], r = a.velocity ?? 110;
    return o.push({
      time: n,
      channel: e,
      command: "noteOn",
      data: { midi: a.pitchStart, velocity: r }
    }), o.push({
      time: n + s,
      channel: e,
      command: "noteOff",
      data: this.resolveNoteOffData(a, s)
    }), o;
  }
  /**
   * Calculate pitch shift needed to align template's reference pitch with baseFrequency.
   *
   * Pattern A implementation: Uses the template's start pitch as reference and calculates
   * the semitone offset needed to shift it to the target baseFrequency.
   *
   * Strategy for finding reference pitch per SE type:
   * - pitch sweep (jump, laser): Use pitchStart as reference
   * - note sequence (coin, powerup, hit): Use first note (pitchStart) as reference
   * - single tone (select, click, synth, tone): Use pitchStart as reference
   * - multi-channel (explosion): Use triangle channel pitch (bass) as reference
   *
   * @param template SE template with pitch configuration
   * @param baseFrequency Target frequency in Hz
   * @returns Semitone shift to apply to all pitches
   */
  calculatePitchShift(e, a) {
    for (const s of e.channels) {
      const n = e.channelParams[s];
      if (!(n != null && n.pitchStart)) continue;
      const o = (n.pitchStart.min + n.pitchStart.max) / 2, r = _a(o), l = a / r, i = fa(l);
      return Math.round(i);
    }
    return 0;
  }
  /**
   * Clamp MIDI note number to valid range (0-127).
   *
   * Prevents pitch shifting from producing invalid MIDI values.
   * Also ensures we don't exceed Nyquist frequency (sample rate / 2).
   *
   * @param midi MIDI note number (may be out of range)
   * @returns Clamped MIDI note number
   */
  clampMidi(e) {
    return Math.max(0, Math.min(127, Math.round(e)));
  }
  resolvePitch(e, a, s) {
    const n = this.clampMidi(e + a);
    return s ? this.clampMidi(I(n, s)) : n;
  }
  resolveNoteOffData(e, a) {
    const s = this.resolveReleaseSeconds(e, a);
    return s ? { releaseSeconds: s } : {};
  }
  resolveEnvelopeData(e, a, s) {
    switch (e.envelope) {
      case "percussive":
        return { decaySeconds: a * 0.7, releaseSeconds: s };
      case "pluck":
        return { decaySeconds: Math.min(0.08, a * 0.45), releaseSeconds: s };
      case "snap":
        return { decaySeconds: Math.min(0.025, a * 0.35), releaseSeconds: s };
      case "fade":
        return { decaySeconds: a, releaseSeconds: s };
      default:
        return e.releaseSeconds ? { releaseSeconds: s } : {};
    }
  }
  resolveReleaseSeconds(e, a) {
    if (e.releaseSeconds)
      return e.releaseSeconds;
    switch (e.envelope) {
      case "pluck":
        return Math.min(0.045, a * 0.35);
      case "snap":
        return Math.min(0.018, a * 0.25);
      case "fade":
        return Math.min(0.18, a * 0.6);
      case "percussive":
        return Math.min(0.06, a * 0.3);
      default:
        return;
    }
  }
}
const lt = 0.1, rr = 25, ut = 0.3, ct = 1789773, oe = [
  4,
  8,
  16,
  32,
  64,
  96,
  128,
  160,
  202,
  254,
  380,
  508,
  762,
  1016,
  2034,
  4068
], or = 5200, ir = 69, lr = 440;
function ce(t) {
  return lr * Math.pow(2, (t - ir) / 12);
}
function ur(t, e = 0.85) {
  return Math.max(0, Math.min(1, (t ?? 100) / 127 * e));
}
function cr(t = 256) {
  const a = Math.tanh(0.55), s = new Float32Array(t);
  for (let n = 0; n < t; n++) {
    const o = 2 * n / (t - 1) - 1;
    s[n] = Math.tanh(o * 0.55) / a;
  }
  return s;
}
class xe {
  constructor(e, a, s) {
    this.context = e;
    const n = new AudioWorkletNode(e, a);
    n.connect(s), this.port = n.port, this.sampleRate = e.sampleRate, this.nodeStartTime = e.currentTime;
  }
  /**
   * Schedules a message to be processed by the AudioWorklet at a specific time.
   *
   * @param message Message data to send to the worklet
   * @param when Absolute time in seconds (AudioContext.currentTime)
   */
  scheduleMessage(e, a) {
    const s = a - this.nodeStartTime, n = Math.max(
      0,
      Math.round(s * this.sampleRate)
    );
    this.port.postMessage({ ...e, sampleFrame: n });
  }
  /** Clears all scheduled events and stops sound output */
  stop() {
    this.port.postMessage({ type: "clear" });
  }
}
class dt extends xe {
  constructor(e, a) {
    super(e, "square-processor", a), this.currentDuty = 0.5;
  }
  noteOn(e, a) {
    const s = e.detuneCents ?? 0, n = Math.pow(2, s / 1200), o = {
      type: "noteOn",
      frequency: e.frequency * n,
      amplitude: e.amplitude ?? 0.8,
      duty: e.duty ?? this.currentDuty
    };
    e.slide && (o.slide = {
      targetFrequency: e.slide.targetFrequency,
      durationSamples: Math.round(
        (e.slide.durationSeconds ?? 0) * this.sampleRate
      )
    }), this.scheduleMessage(o, a);
  }
  noteOff(e, a) {
    this.scheduleMessage({ type: "noteOff" }, a);
  }
  setParam(e, a) {
    if (e.param === "duty" && (this.currentDuty = Number(e.value ?? this.currentDuty)), e.param === "pitchBend" && typeof e.value == "number") {
      const s = e.value > 0 ? ce(e.value) : 0, n = Number(e.rampDuration ?? 0), o = e.curve ?? "linear";
      this.scheduleMessage(
        {
          type: "setParam",
          param: "pitchBend",
          value: s,
          rampDuration: n,
          curve: o
        },
        a
      );
      return;
    }
    if (e.param === "sweep") {
      this.scheduleMessage(
        {
          type: "setSweep",
          enabled: e.enabled !== !1,
          period: typeof e.period == "number" ? e.period : 0,
          shift: typeof e.shift == "number" ? e.shift : 0,
          negate: e.negate === !0
        },
        a
      );
      return;
    }
    this.scheduleMessage(
      { type: "setParam", param: e.param, value: e.value },
      a
    );
  }
}
class dr extends xe {
  constructor(e, a) {
    super(e, "triangle-processor", a);
  }
  noteOn(e, a) {
    const s = {
      type: "noteOn",
      frequency: e.frequency,
      amplitude: e.amplitude ?? 0.7
    };
    this.scheduleMessage(s, a);
  }
  noteOff(e, a) {
    this.scheduleMessage({ type: "noteOff" }, a);
  }
  setParam(e, a) {
    if (e.param === "pitchBend" && typeof e.value == "number") {
      const s = e.value > 0 ? ce(e.value) : 0, n = Number(e.rampDuration ?? 0), o = e.curve ?? "linear";
      this.scheduleMessage(
        {
          type: "setParam",
          param: "pitchBend",
          value: s,
          rampDuration: n,
          curve: o
        },
        a
      );
      return;
    }
    this.scheduleMessage(
      { type: "setParam", param: e.param, value: e.value },
      a
    );
  }
}
class pr extends xe {
  constructor(e, a) {
    super(e, "noise-processor", a), this.periodIndex = 0, this.mode = "short";
  }
  noteOn(e, a) {
    const s = Math.max(
      0,
      Math.min(
        oe.length - 1,
        e.periodIndex ?? this.periodIndex
      )
    ), o = oe[s] * 16 / ct, r = Math.max(
      1,
      Math.round(o * this.sampleRate)
    ), l = Math.max(1e-3, e.decaySeconds ?? 0.12), i = Math.max(1e-3, e.releaseSeconds ?? 0.03), u = Math.max(
      1,
      Math.round(l * this.sampleRate)
    ), c = Math.max(
      1,
      Math.round(i * this.sampleRate)
    ), d = Math.max(0, Math.min(1, e.amplitude ?? 0.6)), h = e.mode === "long" ? "long" : "short", g = Math.max(
      100,
      Math.min(this.sampleRate / 2, e.cutoffHz ?? 6e3)
    );
    this.periodIndex = s, this.mode = h, this.scheduleMessage(
      {
        type: "noteOn",
        mode: h,
        amplitude: d,
        periodSamples: r,
        decaySamples: u,
        releaseSamples: c,
        cutoffHz: g
      },
      a
    );
  }
  noteOff(e, a) {
    const s = Math.max(
      1e-3,
      Number((e == null ? void 0 : e.releaseSeconds) ?? 0.03)
    ), n = Math.max(
      1,
      Math.round(s * this.sampleRate)
    );
    this.scheduleMessage({ type: "noteOff", releaseSamples: n }, a);
  }
  setParam(e, a) {
    if (!(!e || !e.param)) {
      if (e.param === "mode" && typeof e.value == "string") {
        this.mode = e.value === "long" ? "long" : "short", this.scheduleMessage({ type: "setParam", param: "mode", value: e.value }, a);
        return;
      }
      if (e.param === "periodIndex") {
        const s = Math.max(
          0,
          Math.min(oe.length - 1, Number(e.value ?? this.periodIndex))
        );
        this.periodIndex = s;
        const o = oe[s] * 16 / ct, r = Math.max(1, Math.round(o * this.sampleRate));
        this.scheduleMessage({ type: "setParam", param: "periodSamples", value: r }, a);
        return;
      }
      this.scheduleMessage(
        { type: "setParam", param: e.param, value: e.value },
        a
      );
    }
  }
}
const pt = /* @__PURE__ */ new WeakMap(), te = class te {
  constructor(e, a = {}) {
    this.context = e, this.events = [], this.eventIndex = 0, this.lookahead = lt, this.leadTime = ut, this.intervalHandle = null, this.startTime = 0, this.lastEventTime = 0, this.completionResolver = null, this.loopEnabled = !1, this.eventCallback = null, this.masterGainNode = e.createGain(), this.masterGainNode.gain.value = te.BASE_GAIN, this.destination = a.gainNode ?? e.destination, this.workletBasePath = a.workletBasePath ?? "./worklets/";
  }
  /**
   * Initializes the synthesizer by loading AudioWorklet processors.
   *
   * Must be called once before playback. Loads the square, triangle,
   * and noise processor modules (if not already loaded for this context)
   * and creates channel instances.
   */
  async init() {
    const e = this.context, a = this.workletBasePath;
    let s = pt.get(e);
    s || (s = /* @__PURE__ */ new Set(), pt.set(e, s));
    const n = async (l) => {
      if (s.has(l))
        return;
      const i = `${a}${l}`;
      try {
        await e.audioWorklet.addModule(i), s.add(l);
      } catch (u) {
        const c = u instanceof Error ? u.message : String(u);
        throw new Error(
          `Failed to load AudioWorklet "${l}" from "${i}". Verify that the processor file is hosted and workletBasePath is correct. Cause: ${c}`
        );
      }
    };
    await n("square-processor.js"), await n("triangle-processor.js"), await n("noise-processor.js"), this.channels = {
      square1: new dt(e, this.masterGainNode),
      square2: new dt(e, this.masterGainNode),
      triangle: new dr(e, this.masterGainNode),
      noise: new pr(e, this.masterGainNode)
    };
    const o = e.createWaveShaper();
    o.curve = cr(), o.oversample = "none";
    const r = e.createBiquadFilter();
    r.type = "highpass", r.frequency.value = 20, r.Q.value = 0.707, this.masterGainNode.connect(o), o.connect(r), r.connect(this.destination);
  }
  /** Returns the master gain node for external ducking/mixing control */
  get masterGain() {
    return this.masterGainNode;
  }
  /**
   * Stops playback and clears all scheduled events.
   *
   * Stops the scheduling loop, clears all channel queues, and resolves
   * the playback promise.
   */
  stop() {
    this.intervalHandle !== null && (clearInterval(this.intervalHandle), this.intervalHandle = null), Object.values(this.channels).forEach((e) => e.stop()), this.completionResolver && (this.completionResolver(), this.completionResolver = null);
  }
  /**
   * Plays the provided events one time and resolves when playback ends.
   *
   * Use this for finite SE/BGM renders that should signal completion. For
   * looping playback, call {@link playLoop} instead so the caller is not
   * blocked by a never-resolving promise.
   */
  play(e, a = {}) {
    return this.preparePlayback(e, a, !1), new Promise((s) => {
      this.completionResolver = s, this.startScheduler();
    });
  }
  /**
   * Starts looping playback of the provided events.
   *
   * Returns immediately after scheduling begins; call {@link stop} to halt
   * the loop. This keeps the async contract simple for callers that want
   * background music playback without awaiting.
   */
  playLoop(e, a = {}) {
    this.preparePlayback(e, a, !0), this.completionResolver = null, this.startScheduler();
  }
  /** Common setup shared by play() and playLoop(). */
  preparePlayback(e, a, s) {
    this.stop(), this.events = e ?? [], this.lookahead = a.lookahead ?? lt, this.leadTime = a.leadTime ?? ut, this.loopEnabled = s, this.eventCallback = a.onEvent ?? null;
    const n = a.volume ?? 1;
    this.masterGainNode.gain.value = te.BASE_GAIN * n;
    const o = this.events.length ? this.events[this.events.length - 1].time : 0;
    let r = Math.max(0, a.offset ?? 0);
    r > 0 && (s && o > 0 ? r = r % o : r = Math.min(r, o));
    const l = this.context.currentTime, i = a.startTime ?? l + this.leadTime;
    this.startTime = i - r, this.lastEventTime = o, this.eventIndex = this.resolveEventIndex(r);
  }
  /** Launches the scheduling interval and immediately runs an initial tick. */
  startScheduler() {
    const e = () => this.tick();
    this.intervalHandle = window.setInterval(
      e,
      rr
    ), e();
  }
  /** Determines the event index that should be scheduled after applying an offset */
  resolveEventIndex(e) {
    if (e <= 0)
      return 0;
    const a = 1e-3;
    for (let s = 0; s < this.events.length; s += 1)
      if (this.events[s].time + a >= e)
        return s;
    return this.events.length;
  }
  /**
   * Scheduling tick function (called periodically).
   *
   * Checks for events within the lookahead window and dispatches them
   * to appropriate channels. Handles looping by resetting event index.
   */
  tick() {
    const e = this.context.currentTime, a = e + this.lookahead;
    for (; this.eventIndex < this.events.length; ) {
      const s = this.events[this.eventIndex], n = this.startTime + s.time;
      if (n <= a)
        this.dispatchEvent(s, n), this.eventIndex += 1;
      else
        break;
    }
    if (this.loopEnabled && this.eventIndex >= this.events.length && (this.startTime += this.lastEventTime, this.eventIndex = 0), !this.loopEnabled) {
      const s = this.startTime + this.lastEventTime + 1;
      this.eventIndex >= this.events.length && e >= s && this.stop();
    }
  }
  /**
   * Dispatches a single event to the appropriate channel.
   *
   * Routes noteOn, noteOff, and setParam commands to the correct channel
   * (square1/2, triangle, or noise) and invokes the event callback if registered.
   *
   * @param event Playback event to dispatch
   * @param when Absolute time to schedule the event
   */
  dispatchEvent(e, a) {
    const s = e.data ?? {};
    switch (this.eventCallback && this.eventCallback(e, a), e.channel) {
      case "square1":
      case "square2":
        e.command === "noteOn" ? this.channels[e.channel].noteOn(this.mapPitchData(s), a) : e.command === "noteOff" ? this.channels[e.channel].noteOff(s, a) : e.command === "setParam" && this.channels[e.channel].setParam(s, a);
        break;
      case "triangle":
        e.command === "noteOn" ? this.channels.triangle.noteOn(this.mapPitchData(s), a) : e.command === "noteOff" ? this.channels.triangle.noteOff(s, a) : e.command === "setParam" && this.channels.triangle.setParam(s, a);
        break;
      case "noise":
        e.command === "noteOn" ? this.channels.noise.noteOn(this.mapNoiseData(s), a) : e.command === "noteOff" ? this.channels.noise.noteOff(s, a) : e.command === "setParam" && this.channels.noise.setParam(s, a);
        break;
    }
  }
  /**
   * Maps event data to PitchData for square/triangle channels.
   *
   * Converts MIDI note numbers to frequencies, applies velocity scaling,
   * and extracts pitch slide parameters if present.
   *
   * @param data Event data object
   * @returns Formatted pitch data for channel noteOn
   */
  mapPitchData(e) {
    const a = Number(e.midi ?? 60), s = Number(e.detuneCents ?? 0);
    let n = null;
    const o = e.slide;
    return o && (typeof o.targetMidi == "number" ? n = {
      targetFrequency: ce(o.targetMidi),
      durationSeconds: Number(o.durationSeconds ?? 0)
    } : typeof o.targetFrequency == "number" && (n = {
      targetFrequency: o.targetFrequency,
      durationSeconds: Number(o.durationSeconds ?? 0)
    })), {
      frequency: ce(a),
      amplitude: ur(
        typeof e.velocity == "number" ? e.velocity : void 0
      ),
      duty: typeof e.duty == "number" ? e.duty : void 0,
      detuneCents: s,
      slide: n
    };
  }
  /**
   * Maps event data to NoiseData for the noise channel.
   *
   * Applies instrument presets (K/S/H/O/T), scales amplitude by velocity,
   * and extracts envelope/filter parameters.
   *
   * @param data Event data object
   * @returns Formatted noise data for channel noteOn
   */
  mapNoiseData(e) {
    const a = typeof e.velocity == "number" ? e.velocity : 100, s = Math.max(0, Math.min(1, a / 127)), n = Math.min(
      1,
      Math.max(
        0,
        (typeof e.amplitude == "number" ? e.amplitude : 0.6) * s
      )
    ), o = typeof e.decaySeconds == "number" ? e.decaySeconds : 0.14, r = typeof e.releaseSeconds == "number" ? e.releaseSeconds : 0.03, l = typeof e.periodIndex == "number" ? e.periodIndex : typeof e.clockDivider == "number" ? e.clockDivider : typeof e.period == "number" ? e.period : 3, i = typeof e.mode == "string" ? e.mode : typeof e.noiseMode == "string" ? e.noiseMode : "short", u = typeof e.cutoffHz == "number" ? e.cutoffHz : or;
    return {
      amplitude: n,
      decaySeconds: o,
      releaseSeconds: r,
      periodIndex: l,
      mode: i,
      cutoffHz: u
    };
  }
};
te.BASE_GAIN = 0.16;
let ht = te;
export {
  ht as AlgoChipSynthesizer,
  ie as DEFAULT_SECTION_REPEAT_BIAS,
  gr as SEGenerator,
  hr as generateComposition,
  Qn as runPipeline
};
//# sourceMappingURL=index.js.map
